// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%231e1e27%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dadbe7%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28134.5, 172, 222.5%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%231eba62%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23fc435c%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23fc435c%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2817, 17, 26, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.85%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%2311111a%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%285.6, 35.6, 76%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28110.4, 155.4, 216%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./assets/fonts/museo-sans/MuseoSans_100.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./assets/fonts/museo-sans/MuseoSans_300.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./assets/fonts/museo-sans/MuseoSans_500.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./assets/fonts/museo-sans/MuseoSans_700.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./assets/fonts/museo-sans/MuseoSans_900.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons&Weight=700);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons+Outlined&Weight=700);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://cdn.jsdelivr.net/npm/bootstrap-icons@1.3.0/font/bootstrap-icons.css);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.hover-bg-gray-100:hover {
  background-color: #eff1f9 !important;
}

.hover-bg-gray-200:hover {
  background-color: #e7e8f1 !important;
}

.hover-bg-gray-300:hover {
  background-color: #dadbe7 !important;
}

.hover-bg-gray-400:hover {
  background-color: #c6c7d6 !important;
}

.hover-bg-gray-500:hover {
  background-color: #9ea0b9 !important;
}

.hover-bg-gray-600:hover {
  background-color: #787a91 !important;
}

.hover-bg-gray-700:hover {
  background-color: #434453 !important;
}

.hover-bg-gray-800:hover {
  background-color: #1e1e27 !important;
}

.hover-bg-gray-900:hover {
  background-color: #11111a !important;
}

.hover-bg-primary-100:hover {
  background-color: #e5f6ff !important;
}

.hover-bg-primary-200:hover {
  background-color: #C5E0FB !important;
}

.hover-bg-primary-300:hover {
  background-color: #79a8df !important;
}

.hover-bg-primary-400:hover {
  background-color: #4381cf !important;
}

.hover-bg-primary-500:hover {
  background-color: #0E59BE !important;
}

.hover-bg-primary-600:hover {
  background-color: #0b48ae !important;
}

.hover-bg-primary-700:hover {
  background-color: #08379e !important;
}

.hover-bg-primary-800:hover {
  background-color: #05268e !important;
}

.hover-bg-primary-900:hover {
  background-color: #00157C !important;
}

/* \$input-btn-font-size:         \$font-size-base * 1 !default;
\$input-btn-font-size-sm:      \$font-size-sm * 1 !default;
\$input-btn-font-size-lg:      \$font-size-lg * 1 !default; */
/* \$btn-font-weight:             \$font-weight-bold !default; */
/*!
 * Bootstrap  v5.3.7 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0E59BE;
  --bs-indigo: #7b7df0;
  --bs-purple: #bf71e6;
  --bs-pink: #eb62d0;
  --bs-red: #fc435c;
  --bs-orange: #f09449;
  --bs-yellow: #ffd022;
  --bs-green: #1eba62;
  --bs-teal: #03acb8;
  --bs-cyan: #13ccbb;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #787a91;
  --bs-gray-dark: #1e1e27;
  --bs-gray-100: #eff1f9;
  --bs-gray-200: #e7e8f1;
  --bs-gray-300: #dadbe7;
  --bs-gray-400: #c6c7d6;
  --bs-gray-500: #9ea0b9;
  --bs-gray-600: #787a91;
  --bs-gray-700: #434453;
  --bs-gray-800: #1e1e27;
  --bs-gray-900: #11111a;
  --bs-primary: #0E59BE;
  --bs-secondary: #c6c7d6;
  --bs-success: #1eba62;
  --bs-info: #13ccbb;
  --bs-warning: #ffd022;
  --bs-danger: #fc435c;
  --bs-light: #eff1f9;
  --bs-dark: #11111a;
  --bs-gray-100: #eff1f9;
  --bs-gray-200: #e7e8f1;
  --bs-gray-300: #dadbe7;
  --bs-gray-400: #c6c7d6;
  --bs-gray-500: #9ea0b9;
  --bs-gray-600: #787a91;
  --bs-gray-700: #434453;
  --bs-gray-800: #1e1e27;
  --bs-gray-900: #11111a;
  --bs-primary-100: #e5f6ff;
  --bs-primary-200: #C5E0FB;
  --bs-primary-300: #79a8df;
  --bs-primary-400: #4381cf;
  --bs-primary-500: #0E59BE;
  --bs-primary-600: #0b48ae;
  --bs-primary-700: #08379e;
  --bs-primary-800: #05268e;
  --bs-primary-900: #00157C;
  --bs-primary-rgb: 14, 89, 190;
  --bs-secondary-rgb: 198, 199, 214;
  --bs-success-rgb: 30, 186, 98;
  --bs-info-rgb: 19, 204, 187;
  --bs-warning-rgb: 255, 208, 34;
  --bs-danger-rgb: 252, 67, 92;
  --bs-light-rgb: 239, 241, 249;
  --bs-dark-rgb: 17, 17, 26;
  --bs-gray-100-rgb: 239, 241, 249;
  --bs-gray-200-rgb: 231, 232, 241;
  --bs-gray-300-rgb: 218, 219, 231;
  --bs-gray-400-rgb: 198, 199, 214;
  --bs-gray-500-rgb: 158, 160, 185;
  --bs-gray-600-rgb: 120, 122, 145;
  --bs-gray-700-rgb: 67, 68, 83;
  --bs-gray-800-rgb: 30, 30, 39;
  --bs-gray-900-rgb: 17, 17, 26;
  --bs-primary-100-rgb: 229, 246, 255;
  --bs-primary-200-rgb: 197, 224, 251;
  --bs-primary-300-rgb: 121, 168, 223;
  --bs-primary-400-rgb: 67, 129, 207;
  --bs-primary-500-rgb: 14, 89, 190;
  --bs-primary-600-rgb: 11, 72, 174;
  --bs-primary-700-rgb: 8, 55, 158;
  --bs-primary-800-rgb: 5, 38, 142;
  --bs-primary-900-rgb: 0, 21, 124;
  --bs-primary-text-emphasis: rgb(5.6, 35.6, 76);
  --bs-secondary-text-emphasis: rgb(79.2, 79.6, 85.6);
  --bs-success-text-emphasis: rgb(12, 74.4, 39.2);
  --bs-info-text-emphasis: rgb(7.6, 81.6, 74.8);
  --bs-warning-text-emphasis: rgb(102, 83.2, 13.6);
  --bs-danger-text-emphasis: rgb(100.8, 26.8, 36.8);
  --bs-light-text-emphasis: #434453;
  --bs-dark-text-emphasis: #434453;
  --bs-primary-bg-subtle: rgb(206.8, 221.8, 242);
  --bs-secondary-bg-subtle: rgb(243.6, 243.8, 246.8);
  --bs-success-bg-subtle: rgb(210, 241.2, 223.6);
  --bs-info-bg-subtle: rgb(207.8, 244.8, 241.4);
  --bs-warning-bg-subtle: rgb(255, 245.6, 210.8);
  --bs-danger-bg-subtle: rgb(254.4, 217.4, 222.4);
  --bs-light-bg-subtle: #f7f8fc;
  --bs-dark-bg-subtle: #c6c7d6;
  --bs-primary-border-subtle: rgb(158.6, 188.6, 229);
  --bs-secondary-border-subtle: rgb(232.2, 232.6, 238.6);
  --bs-success-border-subtle: rgb(165, 227.4, 192.2);
  --bs-info-border-subtle: rgb(160.6, 234.6, 227.8);
  --bs-warning-border-subtle: rgb(255, 236.2, 166.6);
  --bs-danger-border-subtle: rgb(253.8, 179.8, 189.8);
  --bs-light-border-subtle: #e7e8f1;
  --bs-dark-border-subtle: #9ea0b9;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 0.88rem;
  --bs-body-font-weight: 500;
  --bs-body-line-height: 1.5;
  --bs-body-color: #11111a;
  --bs-body-color-rgb: 17, 17, 26;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(17, 17, 26, 0.75);
  --bs-secondary-color-rgb: 17, 17, 26;
  --bs-secondary-bg: #e7e8f1;
  --bs-secondary-bg-rgb: 231, 232, 241;
  --bs-tertiary-color: rgba(17, 17, 26, 0.5);
  --bs-tertiary-color-rgb: 17, 17, 26;
  --bs-tertiary-bg: #eff1f9;
  --bs-tertiary-bg-rgb: 239, 241, 249;
  --bs-heading-color: inherit;
  --bs-link-color: #0b48ae;
  --bs-link-color-rgb: 11, 72, 174;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(8.8, 57.6, 139.2);
  --bs-link-hover-color-rgb: 9, 58, 139;
  --bs-code-color: #eb62d0;
  --bs-highlight-color: #11111a;
  --bs-highlight-bg: rgb(255, 245.6, 210.8);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dadbe7;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.35rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.45rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0.02rem 0.1rem 0.45rem 0rem rgba(62, 50, 147, 0.13);
  --bs-box-shadow-sm: 0.01rem 0.05rem 0.15rem 0rem rgba(62, 50, 147, 0.15);
  --bs-box-shadow-lg: 0.045rem 0.2rem 1.35rem 0rem rgba(62, 50, 147, 0.1);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(14, 89, 190, 0.25);
  --bs-form-valid-color: #1eba62;
  --bs-form-valid-border-color: #1eba62;
  --bs-form-invalid-color: #fc435c;
  --bs-form-invalid-border-color: #fc435c;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dadbe7;
  --bs-body-color-rgb: 218, 219, 231;
  --bs-body-bg: #11111a;
  --bs-body-bg-rgb: 17, 17, 26;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(218, 219, 231, 0.75);
  --bs-secondary-color-rgb: 218, 219, 231;
  --bs-secondary-bg: #1e1e27;
  --bs-secondary-bg-rgb: 30, 30, 39;
  --bs-tertiary-color: rgba(218, 219, 231, 0.5);
  --bs-tertiary-color-rgb: 218, 219, 231;
  --bs-tertiary-bg: rgb(23.5, 23.5, 32.5);
  --bs-tertiary-bg-rgb: 24, 24, 33;
  --bs-primary-text-emphasis: rgb(110.4, 155.4, 216);
  --bs-secondary-text-emphasis: rgb(220.8, 221.4, 230.4);
  --bs-success-text-emphasis: rgb(120, 213.6, 160.8);
  --bs-info-text-emphasis: rgb(113.4, 224.4, 214.2);
  --bs-warning-text-emphasis: rgb(255, 226.8, 122.4);
  --bs-danger-text-emphasis: rgb(253.2, 142.2, 157.2);
  --bs-light-text-emphasis: #eff1f9;
  --bs-dark-text-emphasis: #dadbe7;
  --bs-primary-bg-subtle: rgb(2.8, 17.8, 38);
  --bs-secondary-bg-subtle: rgb(39.6, 39.8, 42.8);
  --bs-success-bg-subtle: rgb(6, 37.2, 19.6);
  --bs-info-bg-subtle: rgb(3.8, 40.8, 37.4);
  --bs-warning-bg-subtle: rgb(51, 41.6, 6.8);
  --bs-danger-bg-subtle: rgb(50.4, 13.4, 18.4);
  --bs-light-bg-subtle: #1e1e27;
  --bs-dark-bg-subtle: rgb(15, 15, 19.5);
  --bs-primary-border-subtle: rgb(8.4, 53.4, 114);
  --bs-secondary-border-subtle: rgb(118.8, 119.4, 128.4);
  --bs-success-border-subtle: rgb(18, 111.6, 58.8);
  --bs-info-border-subtle: rgb(11.4, 122.4, 112.2);
  --bs-warning-border-subtle: rgb(153, 124.8, 20.4);
  --bs-danger-border-subtle: rgb(151.2, 40.2, 55.2);
  --bs-light-border-subtle: #434453;
  --bs-dark-border-subtle: #1e1e27;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(110.4, 155.4, 216);
  --bs-link-hover-color: rgb(139.32, 175.32, 223.8);
  --bs-link-color-rgb: 110, 155, 216;
  --bs-link-hover-color-rgb: 139, 175, 224;
  --bs-code-color: rgb(243, 160.8, 226.8);
  --bs-highlight-color: #dadbe7;
  --bs-highlight-bg: rgb(102, 83.2, 13.6);
  --bs-border-color: #434453;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(120, 213.6, 160.8);
  --bs-form-valid-border-color: rgb(120, 213.6, 160.8);
  --bs-form-invalid-color: rgb(253.2, 142.2, 157.2);
  --bs-form-invalid-border-color: rgb(253.2, 142.2, 157.2);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-family: "MuseoSans", sans-serif;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.345rem + 1.14vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.2rem;
  }
}

h2, .h2 {
  font-size: calc(1.301rem + 0.612vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.76rem;
  }
}

h3, .h3 {
  font-size: calc(1.279rem + 0.348vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.54rem;
  }
}

h4, .h4 {
  font-size: calc(1.257rem + 0.084vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.32rem;
  }
}

h5, .h5 {
  font-size: 1.1rem;
}

h6, .h6 {
  font-size: 0.88rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: 900;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  font-weight: 500;
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.1rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.1rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #787a91;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 2rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: #e5f6ff;
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: #eff1f9;
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.8, 221.8, 242);
  --bs-table-border-color: rgb(165.44, 177.44, 193.6);
  --bs-table-striped-bg: rgb(196.46, 210.71, 229.9);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(243.6, 243.8, 246.8);
  --bs-table-border-color: rgb(194.88, 195.04, 197.44);
  --bs-table-striped-bg: rgb(231.42, 231.61, 234.46);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(210, 241.2, 223.6);
  --bs-table-border-color: rgb(168, 192.96, 178.88);
  --bs-table-striped-bg: rgb(199.5, 229.14, 212.42);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(207.8, 244.8, 241.4);
  --bs-table-border-color: rgb(166.24, 195.84, 193.12);
  --bs-table-striped-bg: rgb(197.41, 232.56, 229.33);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(255, 245.6, 210.8);
  --bs-table-border-color: rgb(204, 196.48, 168.64);
  --bs-table-striped-bg: rgb(242.25, 233.32, 200.26);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(254.4, 217.4, 222.4);
  --bs-table-border-color: rgb(203.52, 173.92, 177.92);
  --bs-table-striped-bg: rgb(241.68, 206.53, 211.28);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #eff1f9;
  --bs-table-border-color: rgb(191.2, 192.8, 199.2);
  --bs-table-striped-bg: rgb(227.05, 228.95, 236.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #11111a;
  --bs-table-border-color: rgb(64.6, 64.6, 71.8);
  --bs-table-striped-bg: rgb(28.9, 28.9, 37.45);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: white;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: white;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.45rem + var(--bs-border-width));
  padding-bottom: calc(0.45rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.525rem + var(--bs-border-width));
  padding-bottom: calc(0.525rem + var(--bs-border-width));
  font-size: 0.8096rem;
}

.col-form-label-sm {
  padding-top: calc(0.35rem + var(--bs-border-width));
  padding-bottom: calc(0.35rem + var(--bs-border-width));
  font-size: 0.7392rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.45rem 1.1rem;
  font-family: "MuseoSans", sans-serif;
  font-size: 0.88rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: rgb(134.5, 172, 222.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(14, 89, 190, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.45rem 1.1rem;
  margin: -0.45rem -1.1rem;
  margin-inline-end: 1.1rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.45rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.7rem + calc(var(--bs-border-width) * 2));
  padding: 0.35rem 0.85rem;
  font-size: 0.7392rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.35rem 0.85rem;
  margin: -0.35rem -0.85rem;
  margin-inline-end: 0.85rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.05rem + calc(var(--bs-border-width) * 2));
  padding: 0.525rem 1.6rem;
  font-size: 0.8096rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.525rem 1.6rem;
  margin: -0.525rem -1.6rem;
  margin-inline-end: 1.6rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.9rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.7rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1.05rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.9rem + calc(var(--bs-border-width) * 2));
  padding: 0.45rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.7rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1.05rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.45rem 3.3rem 0.45rem 1.1rem;
  font-family: "MuseoSans", sans-serif;
  font-size: 0.88rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 1.1rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(134.5, 172, 222.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(14, 89, 190, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 1.1rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.35rem;
  padding-bottom: 0.35rem;
  padding-left: 0.85rem;
  font-size: 0.7392rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.525rem;
  padding-bottom: 0.525rem;
  padding-left: 1.6rem;
  font-size: 0.8096rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.32rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(134.5, 172, 222.5);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(14, 89, 190, 0.25);
}
.form-check-input:checked {
  background-color: #0E59BE;
  border-color: #0E59BE;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0E59BE;
  border-color: #0E59BE;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(14, 89, 190, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(14, 89, 190, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0E59BE;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(182.7, 205.2, 235.5);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0E59BE;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(182.7, 205.2, 235.5);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 1.1rem;
  overflow: hidden;
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 1.1rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 1.1rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.55rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > textarea:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #787a91;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.45rem 1.1rem;
  font-size: 0.88rem;
  font-weight: 500;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.525rem 1.6rem;
  font-size: 0.8096rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.35rem 0.85rem;
  font-size: 0.7392rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 4.4rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7392rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.9rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.225rem) center;
  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.9rem);
  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 6.05rem;
  background-position: right 1.1rem center, center right 3.3rem;
  background-size: 16px 12px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.9rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7392rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.9rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.225rem) center;
  background-size: calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.9rem);
  background-position: top calc(0.375em + 0.225rem) right calc(0.375em + 0.225rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 6.05rem;
  background-position: right 1.1rem center, center right 3.3rem;
  background-size: 16px 12px, calc(0.75em + 0.45rem) calc(0.75em + 0.45rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.9rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 1.1rem;
  --bs-btn-padding-y: 0.45rem;
  --bs-btn-font-family: MuseoSans, sans-serif;
  --bs-btn-font-size: 0.88rem;
  --bs-btn-font-weight: 500;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0E59BE;
  --bs-btn-border-color: #0E59BE;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(11.9, 75.65, 161.5);
  --bs-btn-hover-border-color: rgb(11.2, 71.2, 152);
  --bs-btn-focus-shadow-rgb: 50, 114, 200;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(11.2, 71.2, 152);
  --bs-btn-active-border-color: rgb(10.5, 66.75, 142.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0E59BE;
  --bs-btn-disabled-border-color: #0E59BE;
}

.btn-secondary {
  --bs-btn-color: #000;
  --bs-btn-bg: #c6c7d6;
  --bs-btn-border-color: #c6c7d6;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(206.55, 207.4, 220.15);
  --bs-btn-hover-border-color: rgb(203.7, 204.6, 218.1);
  --bs-btn-focus-shadow-rgb: 168, 169, 182;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(209.4, 210.2, 222.2);
  --bs-btn-active-border-color: rgb(203.7, 204.6, 218.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #c6c7d6;
  --bs-btn-disabled-border-color: #c6c7d6;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #1eba62;
  --bs-btn-border-color: #1eba62;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(25.5, 158.1, 83.3);
  --bs-btn-hover-border-color: rgb(24, 148.8, 78.4);
  --bs-btn-focus-shadow-rgb: 64, 196, 122;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(24, 148.8, 78.4);
  --bs-btn-active-border-color: rgb(22.5, 139.5, 73.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #1eba62;
  --bs-btn-disabled-border-color: #1eba62;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #13ccbb;
  --bs-btn-border-color: #13ccbb;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(54.4, 211.65, 197.2);
  --bs-btn-hover-border-color: rgb(42.6, 209.1, 193.8);
  --bs-btn-focus-shadow-rgb: 16, 173, 159;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(66.2, 214.2, 200.6);
  --bs-btn-active-border-color: rgb(42.6, 209.1, 193.8);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #13ccbb;
  --bs-btn-disabled-border-color: #13ccbb;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffd022;
  --bs-btn-border-color: #ffd022;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 215.05, 67.15);
  --bs-btn-hover-border-color: rgb(255, 212.7, 56.1);
  --bs-btn-focus-shadow-rgb: 217, 177, 29;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 217.4, 78.2);
  --bs-btn-active-border-color: rgb(255, 212.7, 56.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffd022;
  --bs-btn-disabled-border-color: #ffd022;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #fc435c;
  --bs-btn-border-color: #fc435c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(214.2, 56.95, 78.2);
  --bs-btn-hover-border-color: rgb(201.6, 53.6, 73.6);
  --bs-btn-focus-shadow-rgb: 252, 95, 116;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(201.6, 53.6, 73.6);
  --bs-btn-active-border-color: rgb(189, 50.25, 69);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #fc435c;
  --bs-btn-disabled-border-color: #fc435c;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #eff1f9;
  --bs-btn-border-color: #eff1f9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(203.15, 204.85, 211.65);
  --bs-btn-hover-border-color: rgb(191.2, 192.8, 199.2);
  --bs-btn-focus-shadow-rgb: 203, 205, 212;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(191.2, 192.8, 199.2);
  --bs-btn-active-border-color: rgb(179.25, 180.75, 186.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #eff1f9;
  --bs-btn-disabled-border-color: #eff1f9;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #11111a;
  --bs-btn-border-color: #11111a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(52.7, 52.7, 60.35);
  --bs-btn-hover-border-color: rgb(40.8, 40.8, 48.9);
  --bs-btn-focus-shadow-rgb: 53, 53, 60;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(64.6, 64.6, 71.8);
  --bs-btn-active-border-color: rgb(40.8, 40.8, 48.9);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #11111a;
  --bs-btn-disabled-border-color: #11111a;
}

.btn-gray-100 {
  --bs-btn-color: #000;
  --bs-btn-bg: #eff1f9;
  --bs-btn-border-color: #eff1f9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(241.4, 243.1, 249.9);
  --bs-btn-hover-border-color: rgb(240.6, 242.4, 249.6);
  --bs-btn-focus-shadow-rgb: 203, 205, 212;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(242.2, 243.8, 250.2);
  --bs-btn-active-border-color: rgb(240.6, 242.4, 249.6);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #eff1f9;
  --bs-btn-disabled-border-color: #eff1f9;
}

.btn-gray-200 {
  --bs-btn-color: #000;
  --bs-btn-bg: #e7e8f1;
  --bs-btn-border-color: #e7e8f1;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(234.6, 235.45, 243.1);
  --bs-btn-hover-border-color: rgb(233.4, 234.3, 242.4);
  --bs-btn-focus-shadow-rgb: 196, 197, 205;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(235.8, 236.6, 243.8);
  --bs-btn-active-border-color: rgb(233.4, 234.3, 242.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #e7e8f1;
  --bs-btn-disabled-border-color: #e7e8f1;
}

.btn-gray-300 {
  --bs-btn-color: #000;
  --bs-btn-bg: #dadbe7;
  --bs-btn-border-color: #dadbe7;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(223.55, 224.4, 234.6);
  --bs-btn-hover-border-color: rgb(221.7, 222.6, 233.4);
  --bs-btn-focus-shadow-rgb: 185, 186, 196;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(225.4, 226.2, 235.8);
  --bs-btn-active-border-color: rgb(221.7, 222.6, 233.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #dadbe7;
  --bs-btn-disabled-border-color: #dadbe7;
}

.btn-gray-400 {
  --bs-btn-color: #000;
  --bs-btn-bg: #c6c7d6;
  --bs-btn-border-color: #c6c7d6;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(206.55, 207.4, 220.15);
  --bs-btn-hover-border-color: rgb(203.7, 204.6, 218.1);
  --bs-btn-focus-shadow-rgb: 168, 169, 182;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(209.4, 210.2, 222.2);
  --bs-btn-active-border-color: rgb(203.7, 204.6, 218.1);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #c6c7d6;
  --bs-btn-disabled-border-color: #c6c7d6;
}

.btn-gray-500 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #9ea0b9;
  --bs-btn-border-color: #9ea0b9;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(134.3, 136, 157.25);
  --bs-btn-hover-border-color: rgb(126.4, 128, 148);
  --bs-btn-focus-shadow-rgb: 173, 174, 196;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(126.4, 128, 148);
  --bs-btn-active-border-color: rgb(118.5, 120, 138.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #9ea0b9;
  --bs-btn-disabled-border-color: #9ea0b9;
}

.btn-gray-600 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #787a91;
  --bs-btn-border-color: #787a91;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(102, 103.7, 123.25);
  --bs-btn-hover-border-color: rgb(96, 97.6, 116);
  --bs-btn-focus-shadow-rgb: 140, 142, 162;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(96, 97.6, 116);
  --bs-btn-active-border-color: rgb(90, 91.5, 108.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #787a91;
  --bs-btn-disabled-border-color: #787a91;
}

.btn-gray-700 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #434453;
  --bs-btn-border-color: #434453;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(56.95, 57.8, 70.55);
  --bs-btn-hover-border-color: rgb(53.6, 54.4, 66.4);
  --bs-btn-focus-shadow-rgb: 95, 96, 109;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(53.6, 54.4, 66.4);
  --bs-btn-active-border-color: rgb(50.25, 51, 62.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #434453;
  --bs-btn-disabled-border-color: #434453;
}

.btn-gray-800 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #1e1e27;
  --bs-btn-border-color: #1e1e27;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(25.5, 25.5, 33.15);
  --bs-btn-hover-border-color: rgb(24, 24, 31.2);
  --bs-btn-focus-shadow-rgb: 64, 64, 71;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(24, 24, 31.2);
  --bs-btn-active-border-color: rgb(22.5, 22.5, 29.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #1e1e27;
  --bs-btn-disabled-border-color: #1e1e27;
}

.btn-gray-900 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #11111a;
  --bs-btn-border-color: #11111a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(14.45, 14.45, 22.1);
  --bs-btn-hover-border-color: rgb(13.6, 13.6, 20.8);
  --bs-btn-focus-shadow-rgb: 53, 53, 60;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(13.6, 13.6, 20.8);
  --bs-btn-active-border-color: rgb(12.75, 12.75, 19.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #11111a;
  --bs-btn-disabled-border-color: #11111a;
}

.btn-primary-100 {
  --bs-btn-color: #000;
  --bs-btn-bg: #e5f6ff;
  --bs-btn-border-color: #e5f6ff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(232.9, 247.35, 255);
  --bs-btn-hover-border-color: rgb(231.6, 246.9, 255);
  --bs-btn-focus-shadow-rgb: 195, 209, 217;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(234.2, 247.8, 255);
  --bs-btn-active-border-color: rgb(231.6, 246.9, 255);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #e5f6ff;
  --bs-btn-disabled-border-color: #e5f6ff;
}

.btn-primary-200 {
  --bs-btn-color: #000;
  --bs-btn-bg: #C5E0FB;
  --bs-btn-border-color: #C5E0FB;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(205.7, 228.65, 251.6);
  --bs-btn-hover-border-color: rgb(202.8, 227.1, 251.4);
  --bs-btn-focus-shadow-rgb: 167, 190, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(208.6, 230.2, 251.8);
  --bs-btn-active-border-color: rgb(202.8, 227.1, 251.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #C5E0FB;
  --bs-btn-disabled-border-color: #C5E0FB;
}

.btn-primary-300 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #79a8df;
  --bs-btn-border-color: #79a8df;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(102.85, 142.8, 189.55);
  --bs-btn-hover-border-color: rgb(96.8, 134.4, 178.4);
  --bs-btn-focus-shadow-rgb: 141, 181, 228;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(96.8, 134.4, 178.4);
  --bs-btn-active-border-color: rgb(90.75, 126, 167.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #79a8df;
  --bs-btn-disabled-border-color: #79a8df;
}

.btn-primary-400 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #4381cf;
  --bs-btn-border-color: #4381cf;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(56.95, 109.65, 175.95);
  --bs-btn-hover-border-color: rgb(53.6, 103.2, 165.6);
  --bs-btn-focus-shadow-rgb: 95, 148, 214;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(53.6, 103.2, 165.6);
  --bs-btn-active-border-color: rgb(50.25, 96.75, 155.25);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #4381cf;
  --bs-btn-disabled-border-color: #4381cf;
}

.btn-primary-500 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0E59BE;
  --bs-btn-border-color: #0E59BE;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(11.9, 75.65, 161.5);
  --bs-btn-hover-border-color: rgb(11.2, 71.2, 152);
  --bs-btn-focus-shadow-rgb: 50, 114, 200;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(11.2, 71.2, 152);
  --bs-btn-active-border-color: rgb(10.5, 66.75, 142.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0E59BE;
  --bs-btn-disabled-border-color: #0E59BE;
}

.btn-primary-600 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0b48ae;
  --bs-btn-border-color: #0b48ae;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(9.35, 61.2, 147.9);
  --bs-btn-hover-border-color: rgb(8.8, 57.6, 139.2);
  --bs-btn-focus-shadow-rgb: 48, 99, 186;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(8.8, 57.6, 139.2);
  --bs-btn-active-border-color: rgb(8.25, 54, 130.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0b48ae;
  --bs-btn-disabled-border-color: #0b48ae;
}

.btn-primary-700 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #08379e;
  --bs-btn-border-color: #08379e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(6.8, 46.75, 134.3);
  --bs-btn-hover-border-color: rgb(6.4, 44, 126.4);
  --bs-btn-focus-shadow-rgb: 45, 85, 173;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(6.4, 44, 126.4);
  --bs-btn-active-border-color: rgb(6, 41.25, 118.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #08379e;
  --bs-btn-disabled-border-color: #08379e;
}

.btn-primary-800 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #05268e;
  --bs-btn-border-color: #05268e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(4.25, 32.3, 120.7);
  --bs-btn-hover-border-color: rgb(4, 30.4, 113.6);
  --bs-btn-focus-shadow-rgb: 43, 71, 159;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(4, 30.4, 113.6);
  --bs-btn-active-border-color: rgb(3.75, 28.5, 106.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #05268e;
  --bs-btn-disabled-border-color: #05268e;
}

.btn-primary-900 {
  --bs-btn-color: #fff;
  --bs-btn-bg: #00157C;
  --bs-btn-border-color: #00157C;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(0, 17.85, 105.4);
  --bs-btn-hover-border-color: rgb(0, 16.8, 99.2);
  --bs-btn-focus-shadow-rgb: 38, 56, 144;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(0, 16.8, 99.2);
  --bs-btn-active-border-color: rgb(0, 15.75, 93);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #00157C;
  --bs-btn-disabled-border-color: #00157C;
}

.btn-outline-primary {
  --bs-btn-color: #0E59BE;
  --bs-btn-border-color: #0E59BE;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0E59BE;
  --bs-btn-hover-border-color: #0E59BE;
  --bs-btn-focus-shadow-rgb: 14, 89, 190;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0E59BE;
  --bs-btn-active-border-color: #0E59BE;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0E59BE;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0E59BE;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #c6c7d6;
  --bs-btn-border-color: #c6c7d6;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #c6c7d6;
  --bs-btn-hover-border-color: #c6c7d6;
  --bs-btn-focus-shadow-rgb: 198, 199, 214;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7d6;
  --bs-btn-active-border-color: #c6c7d6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #c6c7d6;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #c6c7d6;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #1eba62;
  --bs-btn-border-color: #1eba62;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1eba62;
  --bs-btn-hover-border-color: #1eba62;
  --bs-btn-focus-shadow-rgb: 30, 186, 98;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1eba62;
  --bs-btn-active-border-color: #1eba62;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #1eba62;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #1eba62;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #13ccbb;
  --bs-btn-border-color: #13ccbb;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #13ccbb;
  --bs-btn-hover-border-color: #13ccbb;
  --bs-btn-focus-shadow-rgb: 19, 204, 187;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #13ccbb;
  --bs-btn-active-border-color: #13ccbb;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #13ccbb;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #13ccbb;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffd022;
  --bs-btn-border-color: #ffd022;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffd022;
  --bs-btn-hover-border-color: #ffd022;
  --bs-btn-focus-shadow-rgb: 255, 208, 34;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffd022;
  --bs-btn-active-border-color: #ffd022;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffd022;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffd022;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #fc435c;
  --bs-btn-border-color: #fc435c;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #fc435c;
  --bs-btn-hover-border-color: #fc435c;
  --bs-btn-focus-shadow-rgb: 252, 67, 92;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #fc435c;
  --bs-btn-active-border-color: #fc435c;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fc435c;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #fc435c;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #eff1f9;
  --bs-btn-border-color: #eff1f9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #eff1f9;
  --bs-btn-hover-border-color: #eff1f9;
  --bs-btn-focus-shadow-rgb: 239, 241, 249;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eff1f9;
  --bs-btn-active-border-color: #eff1f9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #eff1f9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #eff1f9;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #11111a;
  --bs-btn-border-color: #11111a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #11111a;
  --bs-btn-hover-border-color: #11111a;
  --bs-btn-focus-shadow-rgb: 17, 17, 26;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #11111a;
  --bs-btn-active-border-color: #11111a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #11111a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #11111a;
  --bs-gradient: none;
}

.btn-outline-gray-100 {
  --bs-btn-color: #eff1f9;
  --bs-btn-border-color: #eff1f9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #eff1f9;
  --bs-btn-hover-border-color: #eff1f9;
  --bs-btn-focus-shadow-rgb: 239, 241, 249;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #eff1f9;
  --bs-btn-active-border-color: #eff1f9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #eff1f9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #eff1f9;
  --bs-gradient: none;
}

.btn-outline-gray-200 {
  --bs-btn-color: #e7e8f1;
  --bs-btn-border-color: #e7e8f1;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #e7e8f1;
  --bs-btn-hover-border-color: #e7e8f1;
  --bs-btn-focus-shadow-rgb: 231, 232, 241;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #e7e8f1;
  --bs-btn-active-border-color: #e7e8f1;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e7e8f1;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e7e8f1;
  --bs-gradient: none;
}

.btn-outline-gray-300 {
  --bs-btn-color: #dadbe7;
  --bs-btn-border-color: #dadbe7;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #dadbe7;
  --bs-btn-hover-border-color: #dadbe7;
  --bs-btn-focus-shadow-rgb: 218, 219, 231;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #dadbe7;
  --bs-btn-active-border-color: #dadbe7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dadbe7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dadbe7;
  --bs-gradient: none;
}

.btn-outline-gray-400 {
  --bs-btn-color: #c6c7d6;
  --bs-btn-border-color: #c6c7d6;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #c6c7d6;
  --bs-btn-hover-border-color: #c6c7d6;
  --bs-btn-focus-shadow-rgb: 198, 199, 214;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7d6;
  --bs-btn-active-border-color: #c6c7d6;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #c6c7d6;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #c6c7d6;
  --bs-gradient: none;
}

.btn-outline-gray-500 {
  --bs-btn-color: #9ea0b9;
  --bs-btn-border-color: #9ea0b9;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #9ea0b9;
  --bs-btn-hover-border-color: #9ea0b9;
  --bs-btn-focus-shadow-rgb: 158, 160, 185;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #9ea0b9;
  --bs-btn-active-border-color: #9ea0b9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #9ea0b9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #9ea0b9;
  --bs-gradient: none;
}

.btn-outline-gray-600 {
  --bs-btn-color: #787a91;
  --bs-btn-border-color: #787a91;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #787a91;
  --bs-btn-hover-border-color: #787a91;
  --bs-btn-focus-shadow-rgb: 120, 122, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #787a91;
  --bs-btn-active-border-color: #787a91;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #787a91;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #787a91;
  --bs-gradient: none;
}

.btn-outline-gray-700 {
  --bs-btn-color: #434453;
  --bs-btn-border-color: #434453;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #434453;
  --bs-btn-hover-border-color: #434453;
  --bs-btn-focus-shadow-rgb: 67, 68, 83;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #434453;
  --bs-btn-active-border-color: #434453;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #434453;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #434453;
  --bs-gradient: none;
}

.btn-outline-gray-800 {
  --bs-btn-color: #1e1e27;
  --bs-btn-border-color: #1e1e27;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #1e1e27;
  --bs-btn-hover-border-color: #1e1e27;
  --bs-btn-focus-shadow-rgb: 30, 30, 39;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #1e1e27;
  --bs-btn-active-border-color: #1e1e27;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #1e1e27;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #1e1e27;
  --bs-gradient: none;
}

.btn-outline-gray-900 {
  --bs-btn-color: #11111a;
  --bs-btn-border-color: #11111a;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #11111a;
  --bs-btn-hover-border-color: #11111a;
  --bs-btn-focus-shadow-rgb: 17, 17, 26;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #11111a;
  --bs-btn-active-border-color: #11111a;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #11111a;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #11111a;
  --bs-gradient: none;
}

.btn-outline-primary-100 {
  --bs-btn-color: #e5f6ff;
  --bs-btn-border-color: #e5f6ff;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #e5f6ff;
  --bs-btn-hover-border-color: #e5f6ff;
  --bs-btn-focus-shadow-rgb: 229, 246, 255;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #e5f6ff;
  --bs-btn-active-border-color: #e5f6ff;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #e5f6ff;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #e5f6ff;
  --bs-gradient: none;
}

.btn-outline-primary-200 {
  --bs-btn-color: #C5E0FB;
  --bs-btn-border-color: #C5E0FB;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #C5E0FB;
  --bs-btn-hover-border-color: #C5E0FB;
  --bs-btn-focus-shadow-rgb: 197, 224, 251;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #C5E0FB;
  --bs-btn-active-border-color: #C5E0FB;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #C5E0FB;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #C5E0FB;
  --bs-gradient: none;
}

.btn-outline-primary-300 {
  --bs-btn-color: #79a8df;
  --bs-btn-border-color: #79a8df;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #79a8df;
  --bs-btn-hover-border-color: #79a8df;
  --bs-btn-focus-shadow-rgb: 121, 168, 223;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #79a8df;
  --bs-btn-active-border-color: #79a8df;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #79a8df;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #79a8df;
  --bs-gradient: none;
}

.btn-outline-primary-400 {
  --bs-btn-color: #4381cf;
  --bs-btn-border-color: #4381cf;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4381cf;
  --bs-btn-hover-border-color: #4381cf;
  --bs-btn-focus-shadow-rgb: 67, 129, 207;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4381cf;
  --bs-btn-active-border-color: #4381cf;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #4381cf;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #4381cf;
  --bs-gradient: none;
}

.btn-outline-primary-500 {
  --bs-btn-color: #0E59BE;
  --bs-btn-border-color: #0E59BE;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0E59BE;
  --bs-btn-hover-border-color: #0E59BE;
  --bs-btn-focus-shadow-rgb: 14, 89, 190;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0E59BE;
  --bs-btn-active-border-color: #0E59BE;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0E59BE;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0E59BE;
  --bs-gradient: none;
}

.btn-outline-primary-600 {
  --bs-btn-color: #0b48ae;
  --bs-btn-border-color: #0b48ae;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b48ae;
  --bs-btn-hover-border-color: #0b48ae;
  --bs-btn-focus-shadow-rgb: 11, 72, 174;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0b48ae;
  --bs-btn-active-border-color: #0b48ae;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0b48ae;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0b48ae;
  --bs-gradient: none;
}

.btn-outline-primary-700 {
  --bs-btn-color: #08379e;
  --bs-btn-border-color: #08379e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #08379e;
  --bs-btn-hover-border-color: #08379e;
  --bs-btn-focus-shadow-rgb: 8, 55, 158;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #08379e;
  --bs-btn-active-border-color: #08379e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #08379e;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #08379e;
  --bs-gradient: none;
}

.btn-outline-primary-800 {
  --bs-btn-color: #05268e;
  --bs-btn-border-color: #05268e;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #05268e;
  --bs-btn-hover-border-color: #05268e;
  --bs-btn-focus-shadow-rgb: 5, 38, 142;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #05268e;
  --bs-btn-active-border-color: #05268e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #05268e;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #05268e;
  --bs-gradient: none;
}

.btn-outline-primary-900 {
  --bs-btn-color: #00157C;
  --bs-btn-border-color: #00157C;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #00157C;
  --bs-btn-hover-border-color: #00157C;
  --bs-btn-focus-shadow-rgb: 0, 21, 124;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #00157C;
  --bs-btn-active-border-color: #00157C;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #00157C;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #00157C;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 500;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #787a91;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 48, 99, 186;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.525rem;
  --bs-btn-padding-x: 1.6rem;
  --bs-btn-font-size: 0.8096rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.35rem;
  --bs-btn-padding-x: 0.85rem;
  --bs-btn-font-size: 0.7392rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.88rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0E59BE;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #787a91;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 500;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.7392rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dadbe7;
  --bs-dropdown-bg: #1e1e27;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dadbe7;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0E59BE;
  --bs-dropdown-link-disabled-color: #9ea0b9;
  --bs-dropdown-header-color: #9ea0b9;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * var(--bs-border-width));
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.825rem;
  padding-left: 0.825rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.6375rem;
  padding-left: 0.6375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 1.2rem;
  padding-left: 1.2rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * var(--bs-border-width));
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 0.7rem;
  --bs-nav-link-padding-y: 0.4rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(14, 89, 190, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #08379e;
  --bs-nav-pills-link-active-bg: #C5E0FB;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.4528rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 0.8096rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 0.8096rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.4rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.85);
  --bs-navbar-hover-color: #fff;
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
  .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
  .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
  .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
  .card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.1rem;
  --bs-accordion-btn-padding-y: 0.6rem;
  --bs-accordion-btn-color: #434453;
  --bs-accordion-btn-bg: #e7e8f1;
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(14, 89, 190, 0.25);
  --bs-accordion-body-padding-x: 1.1rem;
  --bs-accordion-body-padding-y: 0.6rem;
  --bs-accordion-active-color: #08379e;
  --bs-accordion-active-bg: #C5E0FB;
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.88rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 0.88rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(14, 89, 190, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0E59BE;
  --bs-pagination-active-border-color: #0E59BE;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * var(--bs-border-width));
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 0.8096rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.7392rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

.alert-gray-100 {
  --bs-alert-color: var(--bs-gray-100-text-emphasis);
  --bs-alert-bg: var(--bs-gray-100-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-100-border-subtle);
  --bs-alert-link-color: var(--bs-gray-100-text-emphasis);
}

.alert-gray-200 {
  --bs-alert-color: var(--bs-gray-200-text-emphasis);
  --bs-alert-bg: var(--bs-gray-200-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-200-border-subtle);
  --bs-alert-link-color: var(--bs-gray-200-text-emphasis);
}

.alert-gray-300 {
  --bs-alert-color: var(--bs-gray-300-text-emphasis);
  --bs-alert-bg: var(--bs-gray-300-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-300-border-subtle);
  --bs-alert-link-color: var(--bs-gray-300-text-emphasis);
}

.alert-gray-400 {
  --bs-alert-color: var(--bs-gray-400-text-emphasis);
  --bs-alert-bg: var(--bs-gray-400-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-400-border-subtle);
  --bs-alert-link-color: var(--bs-gray-400-text-emphasis);
}

.alert-gray-500 {
  --bs-alert-color: var(--bs-gray-500-text-emphasis);
  --bs-alert-bg: var(--bs-gray-500-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-500-border-subtle);
  --bs-alert-link-color: var(--bs-gray-500-text-emphasis);
}

.alert-gray-600 {
  --bs-alert-color: var(--bs-gray-600-text-emphasis);
  --bs-alert-bg: var(--bs-gray-600-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-600-border-subtle);
  --bs-alert-link-color: var(--bs-gray-600-text-emphasis);
}

.alert-gray-700 {
  --bs-alert-color: var(--bs-gray-700-text-emphasis);
  --bs-alert-bg: var(--bs-gray-700-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-700-border-subtle);
  --bs-alert-link-color: var(--bs-gray-700-text-emphasis);
}

.alert-gray-800 {
  --bs-alert-color: var(--bs-gray-800-text-emphasis);
  --bs-alert-bg: var(--bs-gray-800-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-800-border-subtle);
  --bs-alert-link-color: var(--bs-gray-800-text-emphasis);
}

.alert-gray-900 {
  --bs-alert-color: var(--bs-gray-900-text-emphasis);
  --bs-alert-bg: var(--bs-gray-900-bg-subtle);
  --bs-alert-border-color: var(--bs-gray-900-border-subtle);
  --bs-alert-link-color: var(--bs-gray-900-text-emphasis);
}

.alert-primary-100 {
  --bs-alert-color: var(--bs-primary-100-text-emphasis);
  --bs-alert-bg: var(--bs-primary-100-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-100-border-subtle);
  --bs-alert-link-color: var(--bs-primary-100-text-emphasis);
}

.alert-primary-200 {
  --bs-alert-color: var(--bs-primary-200-text-emphasis);
  --bs-alert-bg: var(--bs-primary-200-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-200-border-subtle);
  --bs-alert-link-color: var(--bs-primary-200-text-emphasis);
}

.alert-primary-300 {
  --bs-alert-color: var(--bs-primary-300-text-emphasis);
  --bs-alert-bg: var(--bs-primary-300-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-300-border-subtle);
  --bs-alert-link-color: var(--bs-primary-300-text-emphasis);
}

.alert-primary-400 {
  --bs-alert-color: var(--bs-primary-400-text-emphasis);
  --bs-alert-bg: var(--bs-primary-400-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-400-border-subtle);
  --bs-alert-link-color: var(--bs-primary-400-text-emphasis);
}

.alert-primary-500 {
  --bs-alert-color: var(--bs-primary-500-text-emphasis);
  --bs-alert-bg: var(--bs-primary-500-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-500-border-subtle);
  --bs-alert-link-color: var(--bs-primary-500-text-emphasis);
}

.alert-primary-600 {
  --bs-alert-color: var(--bs-primary-600-text-emphasis);
  --bs-alert-bg: var(--bs-primary-600-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-600-border-subtle);
  --bs-alert-link-color: var(--bs-primary-600-text-emphasis);
}

.alert-primary-700 {
  --bs-alert-color: var(--bs-primary-700-text-emphasis);
  --bs-alert-bg: var(--bs-primary-700-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-700-border-subtle);
  --bs-alert-link-color: var(--bs-primary-700-text-emphasis);
}

.alert-primary-800 {
  --bs-alert-color: var(--bs-primary-800-text-emphasis);
  --bs-alert-bg: var(--bs-primary-800-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-800-border-subtle);
  --bs-alert-link-color: var(--bs-primary-800-text-emphasis);
}

.alert-primary-900 {
  --bs-alert-color: var(--bs-primary-900-text-emphasis);
  --bs-alert-bg: var(--bs-primary-900-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-900-border-subtle);
  --bs-alert-link-color: var(--bs-primary-900-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.66rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0E59BE;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0E59BE;
  --bs-list-group-active-border-color: #0E59BE;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.list-group-item-gray-100 {
  --bs-list-group-color: var(--bs-gray-100-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-100-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-100-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-100-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-100-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-100-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-100-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-100-text-emphasis);
}

.list-group-item-gray-200 {
  --bs-list-group-color: var(--bs-gray-200-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-200-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-200-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-200-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-200-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-200-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-200-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-200-text-emphasis);
}

.list-group-item-gray-300 {
  --bs-list-group-color: var(--bs-gray-300-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-300-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-300-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-300-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-300-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-300-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-300-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-300-text-emphasis);
}

.list-group-item-gray-400 {
  --bs-list-group-color: var(--bs-gray-400-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-400-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-400-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-400-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-400-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-400-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-400-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-400-text-emphasis);
}

.list-group-item-gray-500 {
  --bs-list-group-color: var(--bs-gray-500-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-500-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-500-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-500-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-500-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-500-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-500-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-500-text-emphasis);
}

.list-group-item-gray-600 {
  --bs-list-group-color: var(--bs-gray-600-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-600-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-600-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-600-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-600-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-600-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-600-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-600-text-emphasis);
}

.list-group-item-gray-700 {
  --bs-list-group-color: var(--bs-gray-700-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-700-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-700-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-700-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-700-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-700-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-700-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-700-text-emphasis);
}

.list-group-item-gray-800 {
  --bs-list-group-color: var(--bs-gray-800-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-800-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-800-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-800-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-800-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-800-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-800-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-800-text-emphasis);
}

.list-group-item-gray-900 {
  --bs-list-group-color: var(--bs-gray-900-text-emphasis);
  --bs-list-group-bg: var(--bs-gray-900-bg-subtle);
  --bs-list-group-border-color: var(--bs-gray-900-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-gray-900-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-gray-900-border-subtle);
  --bs-list-group-active-color: var(--bs-gray-900-bg-subtle);
  --bs-list-group-active-bg: var(--bs-gray-900-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-gray-900-text-emphasis);
}

.list-group-item-primary-100 {
  --bs-list-group-color: var(--bs-primary-100-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-100-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-100-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-100-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-100-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-100-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-100-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-100-text-emphasis);
}

.list-group-item-primary-200 {
  --bs-list-group-color: var(--bs-primary-200-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-200-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-200-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-200-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-200-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-200-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-200-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-200-text-emphasis);
}

.list-group-item-primary-300 {
  --bs-list-group-color: var(--bs-primary-300-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-300-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-300-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-300-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-300-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-300-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-300-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-300-text-emphasis);
}

.list-group-item-primary-400 {
  --bs-list-group-color: var(--bs-primary-400-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-400-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-400-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-400-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-400-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-400-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-400-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-400-text-emphasis);
}

.list-group-item-primary-500 {
  --bs-list-group-color: var(--bs-primary-500-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-500-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-500-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-500-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-500-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-500-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-500-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-500-text-emphasis);
}

.list-group-item-primary-600 {
  --bs-list-group-color: var(--bs-primary-600-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-600-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-600-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-600-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-600-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-600-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-600-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-600-text-emphasis);
}

.list-group-item-primary-700 {
  --bs-list-group-color: var(--bs-primary-700-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-700-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-700-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-700-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-700-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-700-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-700-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-700-text-emphasis);
}

.list-group-item-primary-800 {
  --bs-list-group-color: var(--bs-primary-800-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-800-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-800-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-800-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-800-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-800-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-800-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-800-text-emphasis);
}

.list-group-item-primary-900 {
  --bs-list-group-color: var(--bs-primary-900-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-900-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-900-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-900-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-900-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-900-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-900-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-900-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(14, 89, 190, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.35rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

[data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 2rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1055;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 900px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.7392rem;
  --bs-tooltip-color: #fff;
  --bs-tooltip-bg: #1e1e27;
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 1;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.7392rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: #c6c7d6;
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 0.88rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: #fff;
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 500;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}

[data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #000 !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-100 {
  color: #000 !important;
  background-color: RGBA(var(--bs-gray-100-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-200 {
  color: #000 !important;
  background-color: RGBA(var(--bs-gray-200-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-300 {
  color: #000 !important;
  background-color: RGBA(var(--bs-gray-300-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-400 {
  color: #000 !important;
  background-color: RGBA(var(--bs-gray-400-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-500 {
  color: #fff !important;
  background-color: RGBA(var(--bs-gray-500-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-600 {
  color: #fff !important;
  background-color: RGBA(var(--bs-gray-600-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-700 {
  color: #fff !important;
  background-color: RGBA(var(--bs-gray-700-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-800 {
  color: #fff !important;
  background-color: RGBA(var(--bs-gray-800-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-gray-900 {
  color: #fff !important;
  background-color: RGBA(var(--bs-gray-900-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-100 {
  color: #000 !important;
  background-color: RGBA(var(--bs-primary-100-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-200 {
  color: #000 !important;
  background-color: RGBA(var(--bs-primary-200-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-300 {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-300-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-400 {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-400-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-500 {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-500-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-600 {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-600-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-700 {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-700-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-800 {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-800-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-primary-900 {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-900-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(11, 71, 152, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(11, 71, 152, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(209, 210, 222, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(209, 210, 222, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(24, 149, 78, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(24, 149, 78, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(66, 214, 201, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(66, 214, 201, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 217, 78, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 217, 78, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(202, 54, 74, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(202, 54, 74, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(242, 244, 250, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(242, 244, 250, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(14, 14, 21, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(14, 14, 21, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-100 {
  color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-100:hover, .link-gray-100:focus {
  color: RGBA(242, 244, 250, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(242, 244, 250, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-200 {
  color: RGBA(var(--bs-gray-200-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-200-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-200:hover, .link-gray-200:focus {
  color: RGBA(236, 237, 244, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(236, 237, 244, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-300 {
  color: RGBA(var(--bs-gray-300-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-300-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-300:hover, .link-gray-300:focus {
  color: RGBA(225, 226, 236, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(225, 226, 236, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-400 {
  color: RGBA(var(--bs-gray-400-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-400-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-400:hover, .link-gray-400:focus {
  color: RGBA(209, 210, 222, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(209, 210, 222, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-500 {
  color: RGBA(var(--bs-gray-500-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-500-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-500:hover, .link-gray-500:focus {
  color: RGBA(126, 128, 148, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(126, 128, 148, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-600 {
  color: RGBA(var(--bs-gray-600-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-600-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-600:hover, .link-gray-600:focus {
  color: RGBA(96, 98, 116, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(96, 98, 116, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-700 {
  color: RGBA(var(--bs-gray-700-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-700-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-700:hover, .link-gray-700:focus {
  color: RGBA(54, 54, 66, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(54, 54, 66, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-800 {
  color: RGBA(var(--bs-gray-800-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-800-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-800:hover, .link-gray-800:focus {
  color: RGBA(24, 24, 31, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(24, 24, 31, var(--bs-link-underline-opacity, 1)) !important;
}

.link-gray-900 {
  color: RGBA(var(--bs-gray-900-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-gray-900-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-gray-900:hover, .link-gray-900:focus {
  color: RGBA(14, 14, 21, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(14, 14, 21, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-100 {
  color: RGBA(var(--bs-primary-100-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-100-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary-100:hover, .link-primary-100:focus {
  color: RGBA(234, 248, 255, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(234, 248, 255, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-200 {
  color: RGBA(var(--bs-primary-200-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-200-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary-200:hover, .link-primary-200:focus {
  color: RGBA(209, 230, 252, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(209, 230, 252, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-300 {
  color: RGBA(var(--bs-primary-300-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-300-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary-300:hover, .link-primary-300:focus {
  color: RGBA(97, 134, 178, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(97, 134, 178, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-400 {
  color: RGBA(var(--bs-primary-400-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-400-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary-400:hover, .link-primary-400:focus {
  color: RGBA(54, 103, 166, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(54, 103, 166, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-500 {
  color: RGBA(var(--bs-primary-500-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-500-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary-500:hover, .link-primary-500:focus {
  color: RGBA(11, 71, 152, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(11, 71, 152, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-600 {
  color: RGBA(var(--bs-primary-600-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-600-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary-600:hover, .link-primary-600:focus {
  color: RGBA(9, 58, 139, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(9, 58, 139, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-700 {
  color: RGBA(var(--bs-primary-700-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-700-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary-700:hover, .link-primary-700:focus {
  color: RGBA(6, 44, 126, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(6, 44, 126, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-800 {
  color: RGBA(var(--bs-primary-800-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-800-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary-800:hover, .link-primary-800:focus {
  color: RGBA(4, 30, 114, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(4, 30, 114, var(--bs-link-underline-opacity, 1)) !important;
}

.link-primary-900 {
  color: RGBA(var(--bs-primary-900-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-900-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary-900:hover, .link-primary-900:focus {
  color: RGBA(0, 17, 99, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(0, 17, 99, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-100 {
  --bs-focus-ring-color: rgba(var(--bs-gray-100-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-200 {
  --bs-focus-ring-color: rgba(var(--bs-gray-200-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-300 {
  --bs-focus-ring-color: rgba(var(--bs-gray-300-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-400 {
  --bs-focus-ring-color: rgba(var(--bs-gray-400-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-500 {
  --bs-focus-ring-color: rgba(var(--bs-gray-500-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-600 {
  --bs-focus-ring-color: rgba(var(--bs-gray-600-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-700 {
  --bs-focus-ring-color: rgba(var(--bs-gray-700-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-800 {
  --bs-focus-ring-color: rgba(var(--bs-gray-800-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-gray-900 {
  --bs-focus-ring-color: rgba(var(--bs-gray-900-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-100 {
  --bs-focus-ring-color: rgba(var(--bs-primary-100-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-200 {
  --bs-focus-ring-color: rgba(var(--bs-primary-200-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-300 {
  --bs-focus-ring-color: rgba(var(--bs-primary-300-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-400 {
  --bs-focus-ring-color: rgba(var(--bs-primary-400-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-500 {
  --bs-focus-ring-color: rgba(var(--bs-primary-500-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-600 {
  --bs-focus-ring-color: rgba(var(--bs-primary-600-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-700 {
  --bs-focus-ring-color: rgba(var(--bs-primary-700-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-800 {
  --bs-focus-ring-color: rgba(var(--bs-primary-800-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-primary-900 {
  --bs-focus-ring-color: rgba(var(--bs-primary-900-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-100 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-100-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-200 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-200-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-300 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-300-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-400 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-400-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-500 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-500-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-600 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-600-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-700 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-700-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-800 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-800-rgb), var(--bs-border-opacity)) !important;
}

.border-gray-900 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-gray-900-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-100 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-100-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-200 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-200-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-300 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-300-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-400 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-400-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-500 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-500-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-600 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-600-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-700 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-700-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-800 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-800-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-900 {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-900-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.345rem + 1.14vw) !important;
}

.fs-2 {
  font-size: calc(1.301rem + 0.612vw) !important;
}

.fs-3 {
  font-size: calc(1.279rem + 0.348vw) !important;
}

.fs-4 {
  font-size: calc(1.257rem + 0.084vw) !important;
}

.fs-5 {
  font-size: 1.1rem !important;
}

.fs-6 {
  font-size: 0.88rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: 100 !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 500 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: 900 !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-100 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-100-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-200 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-200-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-300 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-300-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-400 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-400-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-500 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-500-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-600 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-600-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-700 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-700-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-800 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-800-rgb), var(--bs-text-opacity)) !important;
}

.text-gray-900 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-gray-900-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-100 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-100-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-200 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-200-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-300 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-300-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-400 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-400-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-500 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-500-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-600 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-600-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-700 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-700-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-800 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-800-rgb), var(--bs-text-opacity)) !important;
}

.text-primary-900 {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-900-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-100 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-100-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-200 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-200-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-300 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-300-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-400 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-400-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-500 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-500-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-600 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-600-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-700 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-700-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-800 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-800-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-gray-900 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-gray-900-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-100 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-100-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-200 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-200-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-300 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-300-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-400 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-400-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-500 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-500-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-600 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-600-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-700 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-700-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-800 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-800-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-primary-900 {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-900-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-100-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-200-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-300-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-400-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-500 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-500-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-600-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-700-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-800-rgb), var(--bs-bg-opacity)) !important;
}

.bg-gray-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-gray-900-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-100 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-100-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-200 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-200-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-300 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-300-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-400 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-400-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-500 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-500-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-600 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-600-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-700 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-700-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-800 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-800-rgb), var(--bs-bg-opacity)) !important;
}

.bg-primary-900 {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-900-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -1rem !important;
  }
  .me-md-n4 {
    margin-right: -1.5rem !important;
  }
  .me-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -1rem !important;
  }
  .m-xxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxl-n5 {
    margin: -3rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.2rem !important;
  }
  .fs-2 {
    font-size: 1.76rem !important;
  }
  .fs-3 {
    font-size: 1.54rem !important;
  }
  .fs-4 {
    font-size: 1.32rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
button {
  font-family: "MuseoSans", sans-serif !important;
}

.btn i, button i {
  margin-left: -5px;
  margin-right: -5px;
}

.btn-secondary {
  background: white !important;
  color: #1e1e27 !important;
  box-shadow: 0.01rem 0.05rem 0.15rem 0rem rgba(62, 50, 147, 0.15);
}
.btn-secondary:hover {
  background: #c6c7d6 !important;
}

@media (max-width: 1399.98px) {
  .container-fluid, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
    padding-right: 1rem;
    padding-left: 1rem;
  }
}
@font-face {
  font-family: "MuseoSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "MuseoSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "MuseoSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "MuseoSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype");
  font-weight: 700;
  font-style: normal;
}
@font-face {
  font-family: "MuseoSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("truetype");
  font-weight: 900;
  font-style: normal;
}
body {
  padding-top: 78px;
  font-family: "MuseoSans", sans-serif;
}

h6, .h6 {
  font-weight: 700;
}

.section-content {
  position: fixed;
  top: 65px;
  bottom: 0;
  overflow: auto;
  width: 100%;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-default {
  cursor: default;
}

.zindex-0 {
  z-index: 0;
}

.zindex-1 {
  z-index: 1;
}

.zindex-10 {
  z-index: 10;
}

.zindex-100 {
  z-index: 100;
}

.zindex-1000 {
  z-index: 1000;
}

.zindex-2 {
  z-index: 2;
}

.zindex-20 {
  z-index: 20;
}

.zindex-200 {
  z-index: 200;
}

.zindex-2000 {
  z-index: 2000;
}

.zindex-3 {
  z-index: 3;
}

.zindex-30 {
  z-index: 30;
}

.zindex-300 {
  z-index: 300;
}

.zindex-3000 {
  z-index: 3000;
}

.zindex-4 {
  z-index: 4;
}

.zindex-40 {
  z-index: 40;
}

.zindex-400 {
  z-index: 400;
}

.zindex-4000 {
  z-index: 4000;
}

.zindex-5 {
  z-index: 5;
}

.zindex-50 {
  z-index: 50;
}

.zindex-500 {
  z-index: 500;
}

.zindex-5000 {
  z-index: 5000;
}

.zindex-6 {
  z-index: 6;
}

.zindex-60 {
  z-index: 60;
}

.zindex-600 {
  z-index: 600;
}

.zindex-6000 {
  z-index: 6000;
}

.zindex-7 {
  z-index: 7;
}

.zindex-70 {
  z-index: 70;
}

.zindex-700 {
  z-index: 700;
}

.zindex-7000 {
  z-index: 7000;
}

.zindex-8 {
  z-index: 8;
}

.zindex-80 {
  z-index: 80;
}

.zindex-800 {
  z-index: 800;
}

.zindex-8000 {
  z-index: 8000;
}

.zindex-9 {
  z-index: 9;
}

.zindex-90 {
  z-index: 90;
}

.zindex-900 {
  z-index: 900;
}

.zindex-9000 {
  z-index: 9000;
}

.light-v-scroll {
  height: 100%;
  overflow-x: hidden;
  padding: 0 8px 0 0;
  overflow-y: auto;
  /* width */
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.light-v-scroll::-webkit-scrollbar {
  width: 8px;
}
.light-v-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.light-v-scroll::-webkit-scrollbar-thumb {
  background: #e7e8f1;
  border-radius: 4px;
}
.light-v-scroll::-webkit-scrollbar-thumb:hover {
  background: #dadbe7;
}

.height-full-min-60 {
  height: calc(100vh - 60px);
}

.height-full-min-61 {
  height: calc(100vh - 61px);
}

.height-full-min-62 {
  height: calc(100vh - 62px);
}

.height-full-min-63 {
  height: calc(100vh - 63px);
}

.height-full-min-64 {
  height: calc(100vh - 64px);
}

.height-full-min-65 {
  height: calc(100vh - 65px);
}

.height-full-min-66 {
  height: calc(100vh - 66px);
}

.height-full-min-67 {
  height: calc(100vh - 67px);
}

.height-full-min-68 {
  height: calc(100vh - 68px);
}

.height-full-min-69 {
  height: calc(100vh - 69px);
}

.height-full-min-70 {
  height: calc(100vh - 70px);
}

.height-full-min-71 {
  height: calc(100vh - 71px);
}

.height-full-min-72 {
  height: calc(100vh - 72px);
}

.height-full-min-73 {
  height: calc(100vh - 73px);
}

.height-full-min-74 {
  height: calc(100vh - 74px);
}

.height-full-min-75 {
  height: calc(100vh - 75px);
}

.height-full-min-76 {
  height: calc(100vh - 76px);
}

.height-full-min-77 {
  height: calc(100vh - 77px);
}

.height-full-min-78 {
  height: calc(100vh - 78px);
}

.height-full-min-79 {
  height: calc(100vh - 79px);
}

.height-full-min-80 {
  height: calc(100vh - 80px);
}

.height-full-min-81 {
  height: calc(100vh - 81px);
}

.height-full-min-82 {
  height: calc(100vh - 82px);
}

.height-full-min-83 {
  height: calc(100vh - 83px);
}

.height-full-min-84 {
  height: calc(100vh - 84px);
}

.height-full-min-85 {
  height: calc(100vh - 85px);
}

.height-full-min-86 {
  height: calc(100vh - 86px);
}

.height-full-min-87 {
  height: calc(100vh - 87px);
}

.height-full-min-88 {
  height: calc(100vh - 88px);
}

.height-full-min-89 {
  height: calc(100vh - 89px);
}

.height-full-min-90 {
  height: calc(100vh - 90px);
}

.height-full-min-91 {
  height: calc(100vh - 91px);
}

.height-full-min-92 {
  height: calc(100vh - 92px);
}

.height-full-min-93 {
  height: calc(100vh - 93px);
}

.height-full-min-94 {
  height: calc(100vh - 94px);
}

.height-full-min-95 {
  height: calc(100vh - 95px);
}

.height-full-min-96 {
  height: calc(100vh - 96px);
}

.height-full-min-97 {
  height: calc(100vh - 97px);
}

.height-full-min-98 {
  height: calc(100vh - 98px);
}

.height-full-min-99 {
  height: calc(100vh - 99px);
}

.height-full-min-100 {
  height: calc(100vh - 100px);
}

.height-full-min-101 {
  height: calc(100vh - 101px);
}

.height-full-min-102 {
  height: calc(100vh - 102px);
}

.height-full-min-103 {
  height: calc(100vh - 103px);
}

.height-full-min-104 {
  height: calc(100vh - 104px);
}

.height-full-min-105 {
  height: calc(100vh - 105px);
}

.height-full-min-106 {
  height: calc(100vh - 106px);
}

.height-full-min-107 {
  height: calc(100vh - 107px);
}

.height-full-min-108 {
  height: calc(100vh - 108px);
}

.height-full-min-109 {
  height: calc(100vh - 109px);
}

.height-full-min-110 {
  height: calc(100vh - 110px);
}

.height-full-min-111 {
  height: calc(100vh - 111px);
}

.height-full-min-112 {
  height: calc(100vh - 112px);
}

.height-full-min-113 {
  height: calc(100vh - 113px);
}

.height-full-min-114 {
  height: calc(100vh - 114px);
}

.height-full-min-115 {
  height: calc(100vh - 115px);
}

.height-full-min-116 {
  height: calc(100vh - 116px);
}

.height-full-min-117 {
  height: calc(100vh - 117px);
}

.height-full-min-118 {
  height: calc(100vh - 118px);
}

.height-full-min-119 {
  height: calc(100vh - 119px);
}

.height-full-min-120 {
  height: calc(100vh - 120px);
}

.height-full-min-121 {
  height: calc(100vh - 121px);
}

.height-full-min-122 {
  height: calc(100vh - 122px);
}

.height-full-min-123 {
  height: calc(100vh - 123px);
}

.height-full-min-124 {
  height: calc(100vh - 124px);
}

.height-full-min-125 {
  height: calc(100vh - 125px);
}

.height-full-min-126 {
  height: calc(100vh - 126px);
}

.height-full-min-127 {
  height: calc(100vh - 127px);
}

.height-full-min-128 {
  height: calc(100vh - 128px);
}

.height-full-min-129 {
  height: calc(100vh - 129px);
}

.height-full-min-130 {
  height: calc(100vh - 130px);
}

.height-full-min-131 {
  height: calc(100vh - 131px);
}

.height-full-min-132 {
  height: calc(100vh - 132px);
}

.height-full-min-133 {
  height: calc(100vh - 133px);
}

.height-full-min-134 {
  height: calc(100vh - 134px);
}

.height-full-min-135 {
  height: calc(100vh - 135px);
}

.height-full-min-136 {
  height: calc(100vh - 136px);
}

.height-full-min-137 {
  height: calc(100vh - 137px);
}

.height-full-min-138 {
  height: calc(100vh - 138px);
}

.height-full-min-139 {
  height: calc(100vh - 139px);
}

.height-full-min-140 {
  height: calc(100vh - 140px);
}

.height-full-min-141 {
  height: calc(100vh - 141px);
}

.height-full-min-142 {
  height: calc(100vh - 142px);
}

.height-full-min-143 {
  height: calc(100vh - 143px);
}

.height-full-min-144 {
  height: calc(100vh - 144px);
}

.height-full-min-145 {
  height: calc(100vh - 145px);
}

.height-full-min-146 {
  height: calc(100vh - 146px);
}

.height-full-min-147 {
  height: calc(100vh - 147px);
}

.height-full-min-148 {
  height: calc(100vh - 148px);
}

.height-full-min-149 {
  height: calc(100vh - 149px);
}

.height-full-min-150 {
  height: calc(100vh - 150px);
}

.height-full-min-151 {
  height: calc(100vh - 151px);
}

.height-full-min-152 {
  height: calc(100vh - 152px);
}

.height-full-min-153 {
  height: calc(100vh - 153px);
}

.height-full-min-154 {
  height: calc(100vh - 154px);
}

.height-full-min-155 {
  height: calc(100vh - 155px);
}

.height-full-min-156 {
  height: calc(100vh - 156px);
}

.height-full-min-157 {
  height: calc(100vh - 157px);
}

.height-full-min-158 {
  height: calc(100vh - 158px);
}

.height-full-min-159 {
  height: calc(100vh - 159px);
}

.height-full-min-160 {
  height: calc(100vh - 160px);
}

.height-full-min-161 {
  height: calc(100vh - 161px);
}

.height-full-min-162 {
  height: calc(100vh - 162px);
}

.height-full-min-163 {
  height: calc(100vh - 163px);
}

.height-full-min-164 {
  height: calc(100vh - 164px);
}

.height-full-min-165 {
  height: calc(100vh - 165px);
}

.height-full-min-166 {
  height: calc(100vh - 166px);
}

.height-full-min-167 {
  height: calc(100vh - 167px);
}

.height-full-min-168 {
  height: calc(100vh - 168px);
}

.height-full-min-169 {
  height: calc(100vh - 169px);
}

.height-full-min-170 {
  height: calc(100vh - 170px);
}

.height-full-min-171 {
  height: calc(100vh - 171px);
}

.height-full-min-172 {
  height: calc(100vh - 172px);
}

.height-full-min-173 {
  height: calc(100vh - 173px);
}

.height-full-min-174 {
  height: calc(100vh - 174px);
}

.height-full-min-175 {
  height: calc(100vh - 175px);
}

.height-full-min-176 {
  height: calc(100vh - 176px);
}

.height-full-min-177 {
  height: calc(100vh - 177px);
}

.height-full-min-178 {
  height: calc(100vh - 178px);
}

.height-full-min-179 {
  height: calc(100vh - 179px);
}

.height-full-min-180 {
  height: calc(100vh - 180px);
}

.height-full-min-181 {
  height: calc(100vh - 181px);
}

.height-full-min-182 {
  height: calc(100vh - 182px);
}

.height-full-min-183 {
  height: calc(100vh - 183px);
}

.height-full-min-184 {
  height: calc(100vh - 184px);
}

.height-full-min-185 {
  height: calc(100vh - 185px);
}

.height-full-min-186 {
  height: calc(100vh - 186px);
}

.height-full-min-187 {
  height: calc(100vh - 187px);
}

.height-full-min-188 {
  height: calc(100vh - 188px);
}

.height-full-min-189 {
  height: calc(100vh - 189px);
}

.height-full-min-190 {
  height: calc(100vh - 190px);
}

.height-full-min-191 {
  height: calc(100vh - 191px);
}

.height-full-min-192 {
  height: calc(100vh - 192px);
}

.height-full-min-193 {
  height: calc(100vh - 193px);
}

.height-full-min-194 {
  height: calc(100vh - 194px);
}

.height-full-min-195 {
  height: calc(100vh - 195px);
}

.height-full-min-196 {
  height: calc(100vh - 196px);
}

.height-full-min-197 {
  height: calc(100vh - 197px);
}

.height-full-min-198 {
  height: calc(100vh - 198px);
}

.height-full-min-199 {
  height: calc(100vh - 199px);
}

.height-full-min-200 {
  height: calc(100vh - 200px);
}

.height-full-min-201 {
  height: calc(100vh - 201px);
}

.height-full-min-202 {
  height: calc(100vh - 202px);
}

.height-full-min-203 {
  height: calc(100vh - 203px);
}

.height-full-min-204 {
  height: calc(100vh - 204px);
}

.height-full-min-205 {
  height: calc(100vh - 205px);
}

.height-full-min-206 {
  height: calc(100vh - 206px);
}

.height-full-min-207 {
  height: calc(100vh - 207px);
}

.height-full-min-208 {
  height: calc(100vh - 208px);
}

.height-full-min-209 {
  height: calc(100vh - 209px);
}

.height-full-min-210 {
  height: calc(100vh - 210px);
}

.height-full-min-211 {
  height: calc(100vh - 211px);
}

.height-full-min-212 {
  height: calc(100vh - 212px);
}

.height-full-min-213 {
  height: calc(100vh - 213px);
}

.height-full-min-214 {
  height: calc(100vh - 214px);
}

.height-full-min-215 {
  height: calc(100vh - 215px);
}

.height-full-min-216 {
  height: calc(100vh - 216px);
}

.height-full-min-217 {
  height: calc(100vh - 217px);
}

.height-full-min-218 {
  height: calc(100vh - 218px);
}

.height-full-min-219 {
  height: calc(100vh - 219px);
}

.height-full-min-220 {
  height: calc(100vh - 220px);
}

.height-full-min-221 {
  height: calc(100vh - 221px);
}

.height-full-min-222 {
  height: calc(100vh - 222px);
}

.height-full-min-223 {
  height: calc(100vh - 223px);
}

.height-full-min-224 {
  height: calc(100vh - 224px);
}

.height-full-min-225 {
  height: calc(100vh - 225px);
}

.height-full-min-226 {
  height: calc(100vh - 226px);
}

.height-full-min-227 {
  height: calc(100vh - 227px);
}

.height-full-min-228 {
  height: calc(100vh - 228px);
}

.height-full-min-229 {
  height: calc(100vh - 229px);
}

.height-full-min-230 {
  height: calc(100vh - 230px);
}

.height-full-min-231 {
  height: calc(100vh - 231px);
}

.height-full-min-232 {
  height: calc(100vh - 232px);
}

.height-full-min-233 {
  height: calc(100vh - 233px);
}

.height-full-min-234 {
  height: calc(100vh - 234px);
}

.height-full-min-235 {
  height: calc(100vh - 235px);
}

.height-full-min-236 {
  height: calc(100vh - 236px);
}

.height-full-min-237 {
  height: calc(100vh - 237px);
}

.height-full-min-238 {
  height: calc(100vh - 238px);
}

.height-full-min-239 {
  height: calc(100vh - 239px);
}

.height-full-min-240 {
  height: calc(100vh - 240px);
}

.height-full-min-241 {
  height: calc(100vh - 241px);
}

.height-full-min-242 {
  height: calc(100vh - 242px);
}

.height-full-min-243 {
  height: calc(100vh - 243px);
}

.height-full-min-244 {
  height: calc(100vh - 244px);
}

.height-full-min-245 {
  height: calc(100vh - 245px);
}

.height-full-min-246 {
  height: calc(100vh - 246px);
}

.height-full-min-247 {
  height: calc(100vh - 247px);
}

.height-full-min-248 {
  height: calc(100vh - 248px);
}

.height-full-min-249 {
  height: calc(100vh - 249px);
}

.height-full-min-250 {
  height: calc(100vh - 250px);
}

.height-full-min-251 {
  height: calc(100vh - 251px);
}

.height-full-min-252 {
  height: calc(100vh - 252px);
}

.height-full-min-253 {
  height: calc(100vh - 253px);
}

.height-full-min-254 {
  height: calc(100vh - 254px);
}

.height-full-min-255 {
  height: calc(100vh - 255px);
}

.height-full-min-256 {
  height: calc(100vh - 256px);
}

.height-full-min-257 {
  height: calc(100vh - 257px);
}

.height-full-min-258 {
  height: calc(100vh - 258px);
}

.height-full-min-259 {
  height: calc(100vh - 259px);
}

.height-full-min-260 {
  height: calc(100vh - 260px);
}

.height-full-min-261 {
  height: calc(100vh - 261px);
}

.height-full-min-262 {
  height: calc(100vh - 262px);
}

.height-full-min-263 {
  height: calc(100vh - 263px);
}

.height-full-min-264 {
  height: calc(100vh - 264px);
}

.height-full-min-265 {
  height: calc(100vh - 265px);
}

.height-full-min-266 {
  height: calc(100vh - 266px);
}

.height-full-min-267 {
  height: calc(100vh - 267px);
}

.height-full-min-268 {
  height: calc(100vh - 268px);
}

.height-full-min-269 {
  height: calc(100vh - 269px);
}

.height-full-min-270 {
  height: calc(100vh - 270px);
}

.height-full-min-271 {
  height: calc(100vh - 271px);
}

.height-full-min-272 {
  height: calc(100vh - 272px);
}

.height-full-min-273 {
  height: calc(100vh - 273px);
}

.height-full-min-274 {
  height: calc(100vh - 274px);
}

.height-full-min-275 {
  height: calc(100vh - 275px);
}

.height-full-min-276 {
  height: calc(100vh - 276px);
}

.height-full-min-277 {
  height: calc(100vh - 277px);
}

.height-full-min-278 {
  height: calc(100vh - 278px);
}

.height-full-min-279 {
  height: calc(100vh - 279px);
}

.height-full-min-280 {
  height: calc(100vh - 280px);
}

.height-full-min-281 {
  height: calc(100vh - 281px);
}

.height-full-min-282 {
  height: calc(100vh - 282px);
}

.height-full-min-283 {
  height: calc(100vh - 283px);
}

.height-full-min-284 {
  height: calc(100vh - 284px);
}

.height-full-min-285 {
  height: calc(100vh - 285px);
}

.height-full-min-286 {
  height: calc(100vh - 286px);
}

.height-full-min-287 {
  height: calc(100vh - 287px);
}

.height-full-min-288 {
  height: calc(100vh - 288px);
}

.height-full-min-289 {
  height: calc(100vh - 289px);
}

.height-full-min-290 {
  height: calc(100vh - 290px);
}

.height-full-min-291 {
  height: calc(100vh - 291px);
}

.height-full-min-292 {
  height: calc(100vh - 292px);
}

.height-full-min-293 {
  height: calc(100vh - 293px);
}

.height-full-min-294 {
  height: calc(100vh - 294px);
}

.height-full-min-295 {
  height: calc(100vh - 295px);
}

.height-full-min-296 {
  height: calc(100vh - 296px);
}

.height-full-min-297 {
  height: calc(100vh - 297px);
}

.height-full-min-298 {
  height: calc(100vh - 298px);
}

.height-full-min-299 {
  height: calc(100vh - 299px);
}

.height-full-min-300 {
  height: calc(100vh - 300px);
}

.height-full-min-301 {
  height: calc(100vh - 301px);
}

.height-full-min-302 {
  height: calc(100vh - 302px);
}

.height-full-min-303 {
  height: calc(100vh - 303px);
}

.height-full-min-304 {
  height: calc(100vh - 304px);
}

.height-full-min-305 {
  height: calc(100vh - 305px);
}

.height-full-min-306 {
  height: calc(100vh - 306px);
}

.height-full-min-307 {
  height: calc(100vh - 307px);
}

.height-full-min-308 {
  height: calc(100vh - 308px);
}

.height-full-min-309 {
  height: calc(100vh - 309px);
}

.height-full-min-310 {
  height: calc(100vh - 310px);
}

.height-full-min-311 {
  height: calc(100vh - 311px);
}

.height-full-min-312 {
  height: calc(100vh - 312px);
}

.height-full-min-313 {
  height: calc(100vh - 313px);
}

.height-full-min-314 {
  height: calc(100vh - 314px);
}

.height-full-min-315 {
  height: calc(100vh - 315px);
}

.height-full-min-316 {
  height: calc(100vh - 316px);
}

.height-full-min-317 {
  height: calc(100vh - 317px);
}

.height-full-min-318 {
  height: calc(100vh - 318px);
}

.height-full-min-319 {
  height: calc(100vh - 319px);
}

.height-full-min-320 {
  height: calc(100vh - 320px);
}

.height-full-min-321 {
  height: calc(100vh - 321px);
}

.height-full-min-322 {
  height: calc(100vh - 322px);
}

.height-full-min-323 {
  height: calc(100vh - 323px);
}

.height-full-min-324 {
  height: calc(100vh - 324px);
}

.height-full-min-325 {
  height: calc(100vh - 325px);
}

.height-full-min-326 {
  height: calc(100vh - 326px);
}

.height-full-min-327 {
  height: calc(100vh - 327px);
}

.height-full-min-328 {
  height: calc(100vh - 328px);
}

.height-full-min-329 {
  height: calc(100vh - 329px);
}

.height-full-min-330 {
  height: calc(100vh - 330px);
}

.height-full-min-331 {
  height: calc(100vh - 331px);
}

.height-full-min-332 {
  height: calc(100vh - 332px);
}

.height-full-min-333 {
  height: calc(100vh - 333px);
}

.height-full-min-334 {
  height: calc(100vh - 334px);
}

.height-full-min-335 {
  height: calc(100vh - 335px);
}

.height-full-min-336 {
  height: calc(100vh - 336px);
}

.height-full-min-337 {
  height: calc(100vh - 337px);
}

.height-full-min-338 {
  height: calc(100vh - 338px);
}

.height-full-min-339 {
  height: calc(100vh - 339px);
}

.height-full-min-340 {
  height: calc(100vh - 340px);
}

.height-full-min-341 {
  height: calc(100vh - 341px);
}

.height-full-min-342 {
  height: calc(100vh - 342px);
}

.height-full-min-343 {
  height: calc(100vh - 343px);
}

.height-full-min-344 {
  height: calc(100vh - 344px);
}

.height-full-min-345 {
  height: calc(100vh - 345px);
}

.height-full-min-346 {
  height: calc(100vh - 346px);
}

.height-full-min-347 {
  height: calc(100vh - 347px);
}

.height-full-min-348 {
  height: calc(100vh - 348px);
}

.height-full-min-349 {
  height: calc(100vh - 349px);
}

.height-full-min-350 {
  height: calc(100vh - 350px);
}

.height-full-min-351 {
  height: calc(100vh - 351px);
}

.height-full-min-352 {
  height: calc(100vh - 352px);
}

.height-full-min-353 {
  height: calc(100vh - 353px);
}

.height-full-min-354 {
  height: calc(100vh - 354px);
}

.height-full-min-355 {
  height: calc(100vh - 355px);
}

.height-full-min-356 {
  height: calc(100vh - 356px);
}

.height-full-min-357 {
  height: calc(100vh - 357px);
}

.height-full-min-358 {
  height: calc(100vh - 358px);
}

.height-full-min-359 {
  height: calc(100vh - 359px);
}

.height-full-min-360 {
  height: calc(100vh - 360px);
}

.height-full-min-361 {
  height: calc(100vh - 361px);
}

.height-full-min-362 {
  height: calc(100vh - 362px);
}

.height-full-min-363 {
  height: calc(100vh - 363px);
}

.height-full-min-364 {
  height: calc(100vh - 364px);
}

.height-full-min-365 {
  height: calc(100vh - 365px);
}

.height-full-min-366 {
  height: calc(100vh - 366px);
}

.height-full-min-367 {
  height: calc(100vh - 367px);
}

.height-full-min-368 {
  height: calc(100vh - 368px);
}

.height-full-min-369 {
  height: calc(100vh - 369px);
}

.height-full-min-370 {
  height: calc(100vh - 370px);
}

.height-full-min-371 {
  height: calc(100vh - 371px);
}

.height-full-min-372 {
  height: calc(100vh - 372px);
}

.height-full-min-373 {
  height: calc(100vh - 373px);
}

.height-full-min-374 {
  height: calc(100vh - 374px);
}

.height-full-min-375 {
  height: calc(100vh - 375px);
}

.height-full-min-376 {
  height: calc(100vh - 376px);
}

.height-full-min-377 {
  height: calc(100vh - 377px);
}

.height-full-min-378 {
  height: calc(100vh - 378px);
}

.height-full-min-379 {
  height: calc(100vh - 379px);
}

.height-full-min-380 {
  height: calc(100vh - 380px);
}

.height-full-min-381 {
  height: calc(100vh - 381px);
}

.height-full-min-382 {
  height: calc(100vh - 382px);
}

.height-full-min-383 {
  height: calc(100vh - 383px);
}

.height-full-min-384 {
  height: calc(100vh - 384px);
}

.height-full-min-385 {
  height: calc(100vh - 385px);
}

.height-full-min-386 {
  height: calc(100vh - 386px);
}

.height-full-min-387 {
  height: calc(100vh - 387px);
}

.height-full-min-388 {
  height: calc(100vh - 388px);
}

.height-full-min-389 {
  height: calc(100vh - 389px);
}

.height-full-min-390 {
  height: calc(100vh - 390px);
}

.height-full-min-391 {
  height: calc(100vh - 391px);
}

.height-full-min-392 {
  height: calc(100vh - 392px);
}

.height-full-min-393 {
  height: calc(100vh - 393px);
}

.height-full-min-394 {
  height: calc(100vh - 394px);
}

.height-full-min-395 {
  height: calc(100vh - 395px);
}

.height-full-min-396 {
  height: calc(100vh - 396px);
}

.height-full-min-397 {
  height: calc(100vh - 397px);
}

.height-full-min-398 {
  height: calc(100vh - 398px);
}

.height-full-min-399 {
  height: calc(100vh - 399px);
}

.height-full-min-400 {
  height: calc(100vh - 400px);
}

.height-full-min-401 {
  height: calc(100vh - 401px);
}

.height-full-min-402 {
  height: calc(100vh - 402px);
}

.height-full-min-403 {
  height: calc(100vh - 403px);
}

.height-full-min-404 {
  height: calc(100vh - 404px);
}

.height-full-min-405 {
  height: calc(100vh - 405px);
}

.height-full-min-406 {
  height: calc(100vh - 406px);
}

.height-full-min-407 {
  height: calc(100vh - 407px);
}

.height-full-min-408 {
  height: calc(100vh - 408px);
}

.height-full-min-409 {
  height: calc(100vh - 409px);
}

.height-full-min-410 {
  height: calc(100vh - 410px);
}

.height-full-min-411 {
  height: calc(100vh - 411px);
}

.height-full-min-412 {
  height: calc(100vh - 412px);
}

.height-full-min-413 {
  height: calc(100vh - 413px);
}

.height-full-min-414 {
  height: calc(100vh - 414px);
}

.height-full-min-415 {
  height: calc(100vh - 415px);
}

.height-full-min-416 {
  height: calc(100vh - 416px);
}

.height-full-min-417 {
  height: calc(100vh - 417px);
}

.height-full-min-418 {
  height: calc(100vh - 418px);
}

.height-full-min-419 {
  height: calc(100vh - 419px);
}

.height-full-min-420 {
  height: calc(100vh - 420px);
}

.height-full-min-421 {
  height: calc(100vh - 421px);
}

.height-full-min-422 {
  height: calc(100vh - 422px);
}

.height-full-min-423 {
  height: calc(100vh - 423px);
}

.height-full-min-424 {
  height: calc(100vh - 424px);
}

.height-full-min-425 {
  height: calc(100vh - 425px);
}

.height-full-min-426 {
  height: calc(100vh - 426px);
}

.height-full-min-427 {
  height: calc(100vh - 427px);
}

.height-full-min-428 {
  height: calc(100vh - 428px);
}

.height-full-min-429 {
  height: calc(100vh - 429px);
}

.height-full-min-430 {
  height: calc(100vh - 430px);
}

.height-full-min-431 {
  height: calc(100vh - 431px);
}

.height-full-min-432 {
  height: calc(100vh - 432px);
}

.height-full-min-433 {
  height: calc(100vh - 433px);
}

.height-full-min-434 {
  height: calc(100vh - 434px);
}

.height-full-min-435 {
  height: calc(100vh - 435px);
}

.height-full-min-436 {
  height: calc(100vh - 436px);
}

.height-full-min-437 {
  height: calc(100vh - 437px);
}

.height-full-min-438 {
  height: calc(100vh - 438px);
}

.height-full-min-439 {
  height: calc(100vh - 439px);
}

.height-full-min-440 {
  height: calc(100vh - 440px);
}

.height-full-min-441 {
  height: calc(100vh - 441px);
}

.height-full-min-442 {
  height: calc(100vh - 442px);
}

.height-full-min-443 {
  height: calc(100vh - 443px);
}

.height-full-min-444 {
  height: calc(100vh - 444px);
}

.height-full-min-445 {
  height: calc(100vh - 445px);
}

.height-full-min-446 {
  height: calc(100vh - 446px);
}

.height-full-min-447 {
  height: calc(100vh - 447px);
}

.height-full-min-448 {
  height: calc(100vh - 448px);
}

.height-full-min-449 {
  height: calc(100vh - 449px);
}

.height-full-min-450 {
  height: calc(100vh - 450px);
}

.height-full-min-451 {
  height: calc(100vh - 451px);
}

.height-full-min-452 {
  height: calc(100vh - 452px);
}

.height-full-min-453 {
  height: calc(100vh - 453px);
}

.height-full-min-454 {
  height: calc(100vh - 454px);
}

.height-full-min-455 {
  height: calc(100vh - 455px);
}

.height-full-min-456 {
  height: calc(100vh - 456px);
}

.height-full-min-457 {
  height: calc(100vh - 457px);
}

.height-full-min-458 {
  height: calc(100vh - 458px);
}

.height-full-min-459 {
  height: calc(100vh - 459px);
}

.height-full-min-460 {
  height: calc(100vh - 460px);
}

.height-full-min-461 {
  height: calc(100vh - 461px);
}

.height-full-min-462 {
  height: calc(100vh - 462px);
}

.height-full-min-463 {
  height: calc(100vh - 463px);
}

.height-full-min-464 {
  height: calc(100vh - 464px);
}

.height-full-min-465 {
  height: calc(100vh - 465px);
}

.height-full-min-466 {
  height: calc(100vh - 466px);
}

.height-full-min-467 {
  height: calc(100vh - 467px);
}

.height-full-min-468 {
  height: calc(100vh - 468px);
}

.height-full-min-469 {
  height: calc(100vh - 469px);
}

.height-full-min-470 {
  height: calc(100vh - 470px);
}

.height-full-min-471 {
  height: calc(100vh - 471px);
}

.height-full-min-472 {
  height: calc(100vh - 472px);
}

.height-full-min-473 {
  height: calc(100vh - 473px);
}

.height-full-min-474 {
  height: calc(100vh - 474px);
}

.height-full-min-475 {
  height: calc(100vh - 475px);
}

.height-full-min-476 {
  height: calc(100vh - 476px);
}

.height-full-min-477 {
  height: calc(100vh - 477px);
}

.height-full-min-478 {
  height: calc(100vh - 478px);
}

.height-full-min-479 {
  height: calc(100vh - 479px);
}

.height-full-min-480 {
  height: calc(100vh - 480px);
}

.height-full-min-481 {
  height: calc(100vh - 481px);
}

.height-full-min-482 {
  height: calc(100vh - 482px);
}

.height-full-min-483 {
  height: calc(100vh - 483px);
}

.height-full-min-484 {
  height: calc(100vh - 484px);
}

.height-full-min-485 {
  height: calc(100vh - 485px);
}

.height-full-min-486 {
  height: calc(100vh - 486px);
}

.height-full-min-487 {
  height: calc(100vh - 487px);
}

.height-full-min-488 {
  height: calc(100vh - 488px);
}

.height-full-min-489 {
  height: calc(100vh - 489px);
}

.height-full-min-490 {
  height: calc(100vh - 490px);
}

.height-full-min-491 {
  height: calc(100vh - 491px);
}

.height-full-min-492 {
  height: calc(100vh - 492px);
}

.height-full-min-493 {
  height: calc(100vh - 493px);
}

.height-full-min-494 {
  height: calc(100vh - 494px);
}

.height-full-min-495 {
  height: calc(100vh - 495px);
}

.height-full-min-496 {
  height: calc(100vh - 496px);
}

.height-full-min-497 {
  height: calc(100vh - 497px);
}

.height-full-min-498 {
  height: calc(100vh - 498px);
}

.height-full-min-499 {
  height: calc(100vh - 499px);
}

.height-full-min-500 {
  height: calc(100vh - 500px);
}

.height-full-min-501 {
  height: calc(100vh - 501px);
}

.height-full-min-502 {
  height: calc(100vh - 502px);
}

.height-full-min-503 {
  height: calc(100vh - 503px);
}

.height-full-min-504 {
  height: calc(100vh - 504px);
}

.height-full-min-505 {
  height: calc(100vh - 505px);
}

.height-full-min-506 {
  height: calc(100vh - 506px);
}

.height-full-min-507 {
  height: calc(100vh - 507px);
}

.height-full-min-508 {
  height: calc(100vh - 508px);
}

.height-full-min-509 {
  height: calc(100vh - 509px);
}

.height-full-min-510 {
  height: calc(100vh - 510px);
}

.highlight {
  color: #11111a;
  background: #fdfa2c;
}

.input-icon-space {
  padding-left: 35px;
}

.input-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: inherit;
  font-weight: 700;
  z-index: 10;
}

.global-search-close-btn {
  right: 46px;
  height: 26px;
  width: 26px;
  padding-left: 0px;
  top: 50%;
  margin-top: -13px;
  position: absolute;
  align-items: center;
  justify-content: center;
  font-size: inherit;
  font-weight: 700;
  z-index: 10;
}

.hloader {
  background: #e7e8f1;
  height: 10px;
  border-radius: 3px;
  overflow: hidden;
  position: relative;
  width: 100%;
  display: inline-block;
}
.hloader::before, .hloader::after {
  background: #dadbe7;
  content: "";
  display: block;
  height: 10px;
  left: 0;
  position: absolute;
  top: 0;
  transform: translate3d(-100%, 0, 0);
  width: 50%;
}
.hloader::before {
  animation: hloader 1.5s infinite;
}
.hloader::after {
  animation: hloader 2.5s -1s infinite;
}
@keyframes hloader {
  0% {
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    transform: translate3d(200%, 0, 0);
  }
}

.light-dropdown .dropdown-toggle {
  background: none;
  border: none;
  color: inherit;
  padding: 0;
  margin: 0;
  line-height: 0;
  border-radius: 50px;
}
.light-dropdown .dropdown-toggle.btn-primary.dropdown-toggle {
  color: inherit;
  background-color: transparent;
  border-color: transparent;
}
.light-dropdown .dropdown-toggle.btn-primary.dropdown-toggle:focus {
  box-shadow: none;
  outline: 0 !important;
}
.light-dropdown .dropdown-toggle:before, .light-dropdown .dropdown-toggle:after {
  display: none !important;
}

.no-btn-caret .dropdown-toggle:after {
  display: none;
}
.no-btn-caret:after {
  display: none;
}

tbody {
  border-top: none !important;
}

.material-icons {
  font-size: inherit;
  line-height: inherit;
  display: flex;
}

.i-lg {
  transform: scale(1.3) translateY(1px);
}

.bubble-tags-container {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  border-radius: 20px;
  padding: 1px 7px 1px 8px;
}
.bubble-tags-container .bubble {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-left: 3px;
  position: relative;
}
.bubble-tags-container .bubble:hover .label {
  display: flex;
  position: absolute;
  white-space: nowrap;
  z-index: 9999;
  top: -24px;
  border-radius: 20px;
  padding: 0px 7px;
  font-size: 0.9rem;
  left: -5px;
}
.bubble-tags-container .bubble .label {
  display: none;
}

table {
  border-collapse: inherit;
  border-spacing: 0;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/assets/scss/BootstrapOverride.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/Responsive.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACqDG;EAAS,oCAAA;AD7C5B;;AC8CmB;EAAS,oCAAA;AD1C5B;;AC2CmB;EAAS,oCAAA;ADvC5B;;ACwCmB;EAAS,oCAAA;ADpC5B;;ACqCmB;EAAS,oCAAA;ADjC5B;;ACkCmB;EAAS,oCAAA;AD9B5B;;AC+BmB;EAAS,oCAAA;AD3B5B;;AC4BmB;EAAS,oCAAA;ADxB5B;;ACyBmB;EAAS,oCAAA;ADrB5B;;ACuBsB;EAAS,oCAAA;ADnB/B;;ACoBsB;EAAS,oCAAA;ADhB/B;;ACiBsB;EAAS,oCAAA;ADb/B;;ACcsB;EAAS,oCAAA;ADV/B;;ACWsB;EAAS,oCAAA;ADP/B;;ACQsB;EAAS,oCAAA;ADJ/B;;ACKsB;EAAS,oCAAA;ADD/B;;ACEsB;EAAS,oCAAA;ADE/B;;ACDsB;EAAS,oCAAA;ADK/B;;AC4CA;;2DAAA;AAIA,8DAAA;AC3HE;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAIA,6BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,mCAAA;EAAA,kCAAA;EAAA,iCAAA;EAAA,iCAAA;EAAA,gCAAA;EAAA,gCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,mDAAA;EAAA,+CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,kDAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,8CAAA;EAAA,+CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,sDAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,kDAAA;EAAA,mDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,4BALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,gCAAA;EACA,+BAAA;EAEA,4CAAA;EACA,qCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,oEAAA;EACA,wEAAA;EACA,uEAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,8CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AHmHF;;AKnOI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,sDAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,kDAAA;EAAA,mDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,+CAAA;EAAA,0CAAA;EAAA,yCAAA;EAAA,0CAAA;EAAA,4CAAA;EAAA,6BAAA;EAAA,sCAAA;EAIA,+CAAA;EAAA,sDAAA;EAAA,gDAAA;EAAA,gDAAA;EAAA,iDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,uCAAA;EACA,6BAAA;EACA,uCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,6CAAA;EACA,oDAAA;EACA,iDAAA;EACA,wDAAA;AHmHJ;;AM3RA;;;EAGE,sBAAA;AN8RF;;AM/QI;EANJ;IAOM,uBAAA;ENmRJ;AACF;;AMtQA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;ANyQF;;AMhQA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;APtX9B;;AMzPA;EACE,aAAA;EACA,qBCwjB4B;EDvjB5B,oCL+B4B;EK7B5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;AN2PF;;AMxPA;EFuMQ,kCAAA;AJqDR;AIjNI;EE3CJ;IF8MQ,iBAAA;EJkDN;AACF;;AM5PA;EFkMQ,mCAAA;AJ8DR;AI1NI;EEtCJ;IFyMQ,kBAAA;EJ2DN;AACF;;AMhQA;EF6LQ,mCAAA;AJuER;AInOI;EEjCJ;IFoMQ,kBAAA;EJoEN;AACF;;AMpQA;EFwLQ,mCAAA;AJgFR;AI5OI;EE5BJ;IF+LQ,kBAAA;EJ6EN;AACF;;AMxQA;EF+KM,iBALI;AJkGV;;AMvQA;EF0KM,kBALI;AJsGV;;AMhQA;EACE,aAAA;EACA,mBCwV0B;APrF5B;;AMzPA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;AN4PF;;AMtPA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ANyPF;;AMnPA;;EAEE,kBAAA;ANsPF;;AMnPA;;;EAGE,aAAA;EACA,mBAAA;ANsPF;;AMnPA;;;;EAIE,gBAAA;ANsPF;;AMnPA;EACE,gBLjE4B;ADuT9B;;AMjPA;EACE,qBAAA;EACA,cAAA;ANoPF;;AM9OA;EACE,gBAAA;ANiPF;;AMzOA;;EAEE,gBLxF4B;ADoU9B;;AMpOA;EF6EM,kBALI;AJgKV;;AMjOA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;ANoOF;;AM3NA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;AN8NF;;AM3NA;EAAM,eAAA;AN+NN;;AM9NA;EAAM,WAAA;ANkON;;AM7NA;EACE,gEAAA;EACA,0BCgNwC;APgB1C;AM9NE;EACE,mDAAA;ANgOJ;;AMrNE;EAEE,cAAA;EACA,qBAAA;ANuNJ;;AMhNA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AJ2MV;;AM5MA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AJmNV;AM3ME;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;AN6MJ;;AMzMA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;AN4MF;AMzME;EACE,cAAA;AN2MJ;;AMvMA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBC25CkC;ED15ClC,sCC25CkC;EChsDhC,sBAAA;ARgfJ;AMxME;EACE,UAAA;EF7BE,cALI;AJ6OV;;AMhMA;EACE,gBAAA;ANmMF;;AM7LA;;EAEE,sBAAA;ANgMF;;AMxLA;EACE,oBAAA;EACA,yBAAA;AN2LF;;AMxLA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;AN2LF;;AMpLA;EACE,gBLzP4B;EK0P5B,mBAAA;EACA,gCAAA;ANuLF;;AMpLA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ANuLF;;AM/KA;EACE,qBAAA;ANkLF;;AM5KA;EAEE,gBAAA;AN8KF;;AMtKA;EACE,UAAA;ANyKF;;AMpKA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ANuKF;;AMnKA;;EAEE,oBAAA;ANsKF;;AMjKA;EACE,eAAA;ANoKF;;AMjKA;EAGE,iBAAA;ANkKF;AM/JE;EACE,UAAA;ANiKJ;;AM1JA;EACE,wBAAA;AN6JF;;AMrJA;;;;EAIE,0BAAA;ANwJF;AMrJI;;;;EACE,eAAA;AN0JN;;AMnJA;EACE,UAAA;EACA,kBAAA;ANsJF;;AMjJA;EACE,gBAAA;ANoJF;;AM1IA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AN6IF;;AMrIA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EDjN5B,oBAAA;EFnNM,iCAAA;AJ2VR;AIvfI;EEyWJ;IFtMQ,iBAAA;EJwVN;AACF;AM1IE;EACE,WAAA;AN4IJ;;AMrIA;;;;;;;EAOE,UAAA;ANwIF;;AMrIA;EACE,YAAA;ANwIF;;AM/HA;EACE,6BAAA;EACA,oBAAA;ANkIF;;AM1HA;;;;;;;CAAA;AAWA;EACE,wBAAA;AN0HF;;AMrHA;EACE,UAAA;ANwHF;;AMjHA;EACE,aAAA;EACA,0BAAA;ANoHF;;AM/GA;EACE,qBAAA;ANkHF;;AM7GA;EACE,SAAA;ANgHF;;AMzGA;EACE,kBAAA;EACA,eAAA;AN4GF;;AMpGA;EACE,wBAAA;ANuGF;;AM/FA;EACE,wBAAA;ANkGF;;ASvqBA;ELmQM,iBALI;EK5PR,gBFwoB4B;APkC9B;;ASrqBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJ2aR;AIvkBI;EKpGF;ILuQM,eAAA;EJwaN;AACF;;AShrBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJsbR;AIllBI;EKpGF;ILuQM,iBAAA;EJmbN;AACF;;AS3rBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJicR;AI7lBI;EKpGF;ILuQM,eAAA;EJ8bN;AACF;;AStsBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJ4cR;AIxmBI;EKpGF;ILuQM,iBAAA;EJycN;AACF;;ASjtBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJudR;AInnBI;EKpGF;ILuQM,eAAA;EJodN;AACF;;AS5tBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AJkeR;AI9nBI;EKpGF;ILuQM,iBAAA;EJ+dN;AACF;;AS/sBA;ECvDE,eAAA;EACA,gBAAA;AV0wBF;;AS/sBA;EC5DE,eAAA;EACA,gBAAA;AV+wBF;;ASjtBA;EACE,qBAAA;ATotBF;ASltBE;EACE,oBFsoB0B;AP8E9B;;AS1sBA;EL8MM,kBALI;EKvMR,yBAAA;AT6sBF;;ASzsBA;EACE,mBFiUO;EH1HH,iBALI;AJ2gBV;AS1sBE;EACE,gBAAA;AT4sBJ;;ASxsBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cR7FS;ADwyBX;ASzsBE;EACE,aAAA;AT2sBJ;;AW3yBA;ECIE,eAAA;EAGA,YAAA;AZyyBF;;AW1yBA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AZkzBF;;AWpyBA;EAEE,qBAAA;AXsyBF;;AWnyBA;EACE,qBAAA;EACA,cAAA;AXsyBF;;AWnyBA;EPyPM,kBALI;EOlPR,gCJkjDkC;AP5wBpC;;Aax0BE;;;;;;;ECHA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;Adq1BF;;Ae/xBI;EF5CE;IACE,gBNkee;EP6WrB;AACF;AeryBI;EF5CE;IACE,gBNkee;EPkXrB;AACF;Ae1yBI;EF5CE;IACE,gBNkee;EPuXrB;AACF;Ae/yBI;EF5CE;IACE,iBNkee;EP4XrB;AACF;AepzBI;EF5CE;IACE,iBNkee;EPiYrB;AACF;AgBp3BA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AhB03BJ;;AgBr3BE;ECNA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AjB83BF;AgB53BI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AjBw3BF;;AiBz0BM;EACE,SAAA;AjB40BR;;AiBz0BM;EApCJ,cAAA;EACA,WAAA;AjBi3BF;;AiBn2BE;EACE,cAAA;EACA,WAAA;AjBs2BJ;;AiBx2BE;EACE,cAAA;EACA,UAAA;AjB22BJ;;AiB72BE;EACE,cAAA;EACA,mBAAA;AjBg3BJ;;AiBl3BE;EACE,cAAA;EACA,UAAA;AjBq3BJ;;AiBv3BE;EACE,cAAA;EACA,UAAA;AjB03BJ;;AiB53BE;EACE,cAAA;EACA,mBAAA;AjB+3BJ;;AiBh2BM;EAhDJ,cAAA;EACA,WAAA;AjBo5BF;;AiB/1BU;EAhEN,cAAA;EACA,kBAAA;AjBm6BJ;;AiBp2BU;EAhEN,cAAA;EACA,mBAAA;AjBw6BJ;;AiBz2BU;EAhEN,cAAA;EACA,UAAA;AjB66BJ;;AiB92BU;EAhEN,cAAA;EACA,mBAAA;AjBk7BJ;;AiBn3BU;EAhEN,cAAA;EACA,mBAAA;AjBu7BJ;;AiBx3BU;EAhEN,cAAA;EACA,UAAA;AjB47BJ;;AiB73BU;EAhEN,cAAA;EACA,mBAAA;AjBi8BJ;;AiBl4BU;EAhEN,cAAA;EACA,mBAAA;AjBs8BJ;;AiBv4BU;EAhEN,cAAA;EACA,UAAA;AjB28BJ;;AiB54BU;EAhEN,cAAA;EACA,mBAAA;AjBg9BJ;;AiBj5BU;EAhEN,cAAA;EACA,mBAAA;AjBq9BJ;;AiBt5BU;EAhEN,cAAA;EACA,WAAA;AjB09BJ;;AiBn5BY;EAxDV,wBAAA;AjB+8BF;;AiBv5BY;EAxDV,yBAAA;AjBm9BF;;AiB35BY;EAxDV,gBAAA;AjBu9BF;;AiB/5BY;EAxDV,yBAAA;AjB29BF;;AiBn6BY;EAxDV,yBAAA;AjB+9BF;;AiBv6BY;EAxDV,gBAAA;AjBm+BF;;AiB36BY;EAxDV,yBAAA;AjBu+BF;;AiB/6BY;EAxDV,yBAAA;AjB2+BF;;AiBn7BY;EAxDV,gBAAA;AjB++BF;;AiBv7BY;EAxDV,yBAAA;AjBm/BF;;AiB37BY;EAxDV,yBAAA;AjBu/BF;;AiBp7BQ;;EAEE,gBAAA;AjBu7BV;;AiBp7BQ;;EAEE,gBAAA;AjBu7BV;;AiB97BQ;;EAEE,sBAAA;AjBi8BV;;AiB97BQ;;EAEE,sBAAA;AjBi8BV;;AiBx8BQ;;EAEE,qBAAA;AjB28BV;;AiBx8BQ;;EAEE,qBAAA;AjB28BV;;AiBl9BQ;;EAEE,mBAAA;AjBq9BV;;AiBl9BQ;;EAEE,mBAAA;AjBq9BV;;AiB59BQ;;EAEE,qBAAA;AjB+9BV;;AiB59BQ;;EAEE,qBAAA;AjB+9BV;;AiBt+BQ;;EAEE,mBAAA;AjBy+BV;;AiBt+BQ;;EAEE,mBAAA;AjBy+BV;;AeniCI;EEUE;IACE,SAAA;EjB6hCN;EiB1hCI;IApCJ,cAAA;IACA,WAAA;EjBikCA;EiBnjCA;IACE,cAAA;IACA,WAAA;EjBqjCF;EiBvjCA;IACE,cAAA;IACA,UAAA;EjByjCF;EiB3jCA;IACE,cAAA;IACA,mBAAA;EjB6jCF;EiB/jCA;IACE,cAAA;IACA,UAAA;EjBikCF;EiBnkCA;IACE,cAAA;IACA,UAAA;EjBqkCF;EiBvkCA;IACE,cAAA;IACA,mBAAA;EjBykCF;EiB1iCI;IAhDJ,cAAA;IACA,WAAA;EjB6lCA;EiBxiCQ;IAhEN,cAAA;IACA,kBAAA;EjB2mCF;EiB5iCQ;IAhEN,cAAA;IACA,mBAAA;EjB+mCF;EiBhjCQ;IAhEN,cAAA;IACA,UAAA;EjBmnCF;EiBpjCQ;IAhEN,cAAA;IACA,mBAAA;EjBunCF;EiBxjCQ;IAhEN,cAAA;IACA,mBAAA;EjB2nCF;EiB5jCQ;IAhEN,cAAA;IACA,UAAA;EjB+nCF;EiBhkCQ;IAhEN,cAAA;IACA,mBAAA;EjBmoCF;EiBpkCQ;IAhEN,cAAA;IACA,mBAAA;EjBuoCF;EiBxkCQ;IAhEN,cAAA;IACA,UAAA;EjB2oCF;EiB5kCQ;IAhEN,cAAA;IACA,mBAAA;EjB+oCF;EiBhlCQ;IAhEN,cAAA;IACA,mBAAA;EjBmpCF;EiBplCQ;IAhEN,cAAA;IACA,WAAA;EjBupCF;EiBhlCU;IAxDV,cAAA;EjB2oCA;EiBnlCU;IAxDV,wBAAA;EjB8oCA;EiBtlCU;IAxDV,yBAAA;EjBipCA;EiBzlCU;IAxDV,gBAAA;EjBopCA;EiB5lCU;IAxDV,yBAAA;EjBupCA;EiB/lCU;IAxDV,yBAAA;EjB0pCA;EiBlmCU;IAxDV,gBAAA;EjB6pCA;EiBrmCU;IAxDV,yBAAA;EjBgqCA;EiBxmCU;IAxDV,yBAAA;EjBmqCA;EiB3mCU;IAxDV,gBAAA;EjBsqCA;EiB9mCU;IAxDV,yBAAA;EjByqCA;EiBjnCU;IAxDV,yBAAA;EjB4qCA;EiBzmCM;;IAEE,gBAAA;EjB2mCR;EiBxmCM;;IAEE,gBAAA;EjB0mCR;EiBjnCM;;IAEE,sBAAA;EjBmnCR;EiBhnCM;;IAEE,sBAAA;EjBknCR;EiBznCM;;IAEE,qBAAA;EjB2nCR;EiBxnCM;;IAEE,qBAAA;EjB0nCR;EiBjoCM;;IAEE,mBAAA;EjBmoCR;EiBhoCM;;IAEE,mBAAA;EjBkoCR;EiBzoCM;;IAEE,qBAAA;EjB2oCR;EiBxoCM;;IAEE,qBAAA;EjB0oCR;EiBjpCM;;IAEE,mBAAA;EjBmpCR;EiBhpCM;;IAEE,mBAAA;EjBkpCR;AACF;Ae7sCI;EEUE;IACE,SAAA;EjBssCN;EiBnsCI;IApCJ,cAAA;IACA,WAAA;EjB0uCA;EiB5tCA;IACE,cAAA;IACA,WAAA;EjB8tCF;EiBhuCA;IACE,cAAA;IACA,UAAA;EjBkuCF;EiBpuCA;IACE,cAAA;IACA,mBAAA;EjBsuCF;EiBxuCA;IACE,cAAA;IACA,UAAA;EjB0uCF;EiB5uCA;IACE,cAAA;IACA,UAAA;EjB8uCF;EiBhvCA;IACE,cAAA;IACA,mBAAA;EjBkvCF;EiBntCI;IAhDJ,cAAA;IACA,WAAA;EjBswCA;EiBjtCQ;IAhEN,cAAA;IACA,kBAAA;EjBoxCF;EiBrtCQ;IAhEN,cAAA;IACA,mBAAA;EjBwxCF;EiBztCQ;IAhEN,cAAA;IACA,UAAA;EjB4xCF;EiB7tCQ;IAhEN,cAAA;IACA,mBAAA;EjBgyCF;EiBjuCQ;IAhEN,cAAA;IACA,mBAAA;EjBoyCF;EiBruCQ;IAhEN,cAAA;IACA,UAAA;EjBwyCF;EiBzuCQ;IAhEN,cAAA;IACA,mBAAA;EjB4yCF;EiB7uCQ;IAhEN,cAAA;IACA,mBAAA;EjBgzCF;EiBjvCQ;IAhEN,cAAA;IACA,UAAA;EjBozCF;EiBrvCQ;IAhEN,cAAA;IACA,mBAAA;EjBwzCF;EiBzvCQ;IAhEN,cAAA;IACA,mBAAA;EjB4zCF;EiB7vCQ;IAhEN,cAAA;IACA,WAAA;EjBg0CF;EiBzvCU;IAxDV,cAAA;EjBozCA;EiB5vCU;IAxDV,wBAAA;EjBuzCA;EiB/vCU;IAxDV,yBAAA;EjB0zCA;EiBlwCU;IAxDV,gBAAA;EjB6zCA;EiBrwCU;IAxDV,yBAAA;EjBg0CA;EiBxwCU;IAxDV,yBAAA;EjBm0CA;EiB3wCU;IAxDV,gBAAA;EjBs0CA;EiB9wCU;IAxDV,yBAAA;EjBy0CA;EiBjxCU;IAxDV,yBAAA;EjB40CA;EiBpxCU;IAxDV,gBAAA;EjB+0CA;EiBvxCU;IAxDV,yBAAA;EjBk1CA;EiB1xCU;IAxDV,yBAAA;EjBq1CA;EiBlxCM;;IAEE,gBAAA;EjBoxCR;EiBjxCM;;IAEE,gBAAA;EjBmxCR;EiB1xCM;;IAEE,sBAAA;EjB4xCR;EiBzxCM;;IAEE,sBAAA;EjB2xCR;EiBlyCM;;IAEE,qBAAA;EjBoyCR;EiBjyCM;;IAEE,qBAAA;EjBmyCR;EiB1yCM;;IAEE,mBAAA;EjB4yCR;EiBzyCM;;IAEE,mBAAA;EjB2yCR;EiBlzCM;;IAEE,qBAAA;EjBozCR;EiBjzCM;;IAEE,qBAAA;EjBmzCR;EiB1zCM;;IAEE,mBAAA;EjB4zCR;EiBzzCM;;IAEE,mBAAA;EjB2zCR;AACF;Aet3CI;EEUE;IACE,SAAA;EjB+2CN;EiB52CI;IApCJ,cAAA;IACA,WAAA;EjBm5CA;EiBr4CA;IACE,cAAA;IACA,WAAA;EjBu4CF;EiBz4CA;IACE,cAAA;IACA,UAAA;EjB24CF;EiB74CA;IACE,cAAA;IACA,mBAAA;EjB+4CF;EiBj5CA;IACE,cAAA;IACA,UAAA;EjBm5CF;EiBr5CA;IACE,cAAA;IACA,UAAA;EjBu5CF;EiBz5CA;IACE,cAAA;IACA,mBAAA;EjB25CF;EiB53CI;IAhDJ,cAAA;IACA,WAAA;EjB+6CA;EiB13CQ;IAhEN,cAAA;IACA,kBAAA;EjB67CF;EiB93CQ;IAhEN,cAAA;IACA,mBAAA;EjBi8CF;EiBl4CQ;IAhEN,cAAA;IACA,UAAA;EjBq8CF;EiBt4CQ;IAhEN,cAAA;IACA,mBAAA;EjBy8CF;EiB14CQ;IAhEN,cAAA;IACA,mBAAA;EjB68CF;EiB94CQ;IAhEN,cAAA;IACA,UAAA;EjBi9CF;EiBl5CQ;IAhEN,cAAA;IACA,mBAAA;EjBq9CF;EiBt5CQ;IAhEN,cAAA;IACA,mBAAA;EjBy9CF;EiB15CQ;IAhEN,cAAA;IACA,UAAA;EjB69CF;EiB95CQ;IAhEN,cAAA;IACA,mBAAA;EjBi+CF;EiBl6CQ;IAhEN,cAAA;IACA,mBAAA;EjBq+CF;EiBt6CQ;IAhEN,cAAA;IACA,WAAA;EjBy+CF;EiBl6CU;IAxDV,cAAA;EjB69CA;EiBr6CU;IAxDV,wBAAA;EjBg+CA;EiBx6CU;IAxDV,yBAAA;EjBm+CA;EiB36CU;IAxDV,gBAAA;EjBs+CA;EiB96CU;IAxDV,yBAAA;EjBy+CA;EiBj7CU;IAxDV,yBAAA;EjB4+CA;EiBp7CU;IAxDV,gBAAA;EjB++CA;EiBv7CU;IAxDV,yBAAA;EjBk/CA;EiB17CU;IAxDV,yBAAA;EjBq/CA;EiB77CU;IAxDV,gBAAA;EjBw/CA;EiBh8CU;IAxDV,yBAAA;EjB2/CA;EiBn8CU;IAxDV,yBAAA;EjB8/CA;EiB37CM;;IAEE,gBAAA;EjB67CR;EiB17CM;;IAEE,gBAAA;EjB47CR;EiBn8CM;;IAEE,sBAAA;EjBq8CR;EiBl8CM;;IAEE,sBAAA;EjBo8CR;EiB38CM;;IAEE,qBAAA;EjB68CR;EiB18CM;;IAEE,qBAAA;EjB48CR;EiBn9CM;;IAEE,mBAAA;EjBq9CR;EiBl9CM;;IAEE,mBAAA;EjBo9CR;EiB39CM;;IAEE,qBAAA;EjB69CR;EiB19CM;;IAEE,qBAAA;EjB49CR;EiBn+CM;;IAEE,mBAAA;EjBq+CR;EiBl+CM;;IAEE,mBAAA;EjBo+CR;AACF;Ae/hDI;EEUE;IACE,SAAA;EjBwhDN;EiBrhDI;IApCJ,cAAA;IACA,WAAA;EjB4jDA;EiB9iDA;IACE,cAAA;IACA,WAAA;EjBgjDF;EiBljDA;IACE,cAAA;IACA,UAAA;EjBojDF;EiBtjDA;IACE,cAAA;IACA,mBAAA;EjBwjDF;EiB1jDA;IACE,cAAA;IACA,UAAA;EjB4jDF;EiB9jDA;IACE,cAAA;IACA,UAAA;EjBgkDF;EiBlkDA;IACE,cAAA;IACA,mBAAA;EjBokDF;EiBriDI;IAhDJ,cAAA;IACA,WAAA;EjBwlDA;EiBniDQ;IAhEN,cAAA;IACA,kBAAA;EjBsmDF;EiBviDQ;IAhEN,cAAA;IACA,mBAAA;EjB0mDF;EiB3iDQ;IAhEN,cAAA;IACA,UAAA;EjB8mDF;EiB/iDQ;IAhEN,cAAA;IACA,mBAAA;EjBknDF;EiBnjDQ;IAhEN,cAAA;IACA,mBAAA;EjBsnDF;EiBvjDQ;IAhEN,cAAA;IACA,UAAA;EjB0nDF;EiB3jDQ;IAhEN,cAAA;IACA,mBAAA;EjB8nDF;EiB/jDQ;IAhEN,cAAA;IACA,mBAAA;EjBkoDF;EiBnkDQ;IAhEN,cAAA;IACA,UAAA;EjBsoDF;EiBvkDQ;IAhEN,cAAA;IACA,mBAAA;EjB0oDF;EiB3kDQ;IAhEN,cAAA;IACA,mBAAA;EjB8oDF;EiB/kDQ;IAhEN,cAAA;IACA,WAAA;EjBkpDF;EiB3kDU;IAxDV,cAAA;EjBsoDA;EiB9kDU;IAxDV,wBAAA;EjByoDA;EiBjlDU;IAxDV,yBAAA;EjB4oDA;EiBplDU;IAxDV,gBAAA;EjB+oDA;EiBvlDU;IAxDV,yBAAA;EjBkpDA;EiB1lDU;IAxDV,yBAAA;EjBqpDA;EiB7lDU;IAxDV,gBAAA;EjBwpDA;EiBhmDU;IAxDV,yBAAA;EjB2pDA;EiBnmDU;IAxDV,yBAAA;EjB8pDA;EiBtmDU;IAxDV,gBAAA;EjBiqDA;EiBzmDU;IAxDV,yBAAA;EjBoqDA;EiB5mDU;IAxDV,yBAAA;EjBuqDA;EiBpmDM;;IAEE,gBAAA;EjBsmDR;EiBnmDM;;IAEE,gBAAA;EjBqmDR;EiB5mDM;;IAEE,sBAAA;EjB8mDR;EiB3mDM;;IAEE,sBAAA;EjB6mDR;EiBpnDM;;IAEE,qBAAA;EjBsnDR;EiBnnDM;;IAEE,qBAAA;EjBqnDR;EiB5nDM;;IAEE,mBAAA;EjB8nDR;EiB3nDM;;IAEE,mBAAA;EjB6nDR;EiBpoDM;;IAEE,qBAAA;EjBsoDR;EiBnoDM;;IAEE,qBAAA;EjBqoDR;EiB5oDM;;IAEE,mBAAA;EjB8oDR;EiB3oDM;;IAEE,mBAAA;EjB6oDR;AACF;AexsDI;EEUE;IACE,SAAA;EjBisDN;EiB9rDI;IApCJ,cAAA;IACA,WAAA;EjBquDA;EiBvtDA;IACE,cAAA;IACA,WAAA;EjBytDF;EiB3tDA;IACE,cAAA;IACA,UAAA;EjB6tDF;EiB/tDA;IACE,cAAA;IACA,mBAAA;EjBiuDF;EiBnuDA;IACE,cAAA;IACA,UAAA;EjBquDF;EiBvuDA;IACE,cAAA;IACA,UAAA;EjByuDF;EiB3uDA;IACE,cAAA;IACA,mBAAA;EjB6uDF;EiB9sDI;IAhDJ,cAAA;IACA,WAAA;EjBiwDA;EiB5sDQ;IAhEN,cAAA;IACA,kBAAA;EjB+wDF;EiBhtDQ;IAhEN,cAAA;IACA,mBAAA;EjBmxDF;EiBptDQ;IAhEN,cAAA;IACA,UAAA;EjBuxDF;EiBxtDQ;IAhEN,cAAA;IACA,mBAAA;EjB2xDF;EiB5tDQ;IAhEN,cAAA;IACA,mBAAA;EjB+xDF;EiBhuDQ;IAhEN,cAAA;IACA,UAAA;EjBmyDF;EiBpuDQ;IAhEN,cAAA;IACA,mBAAA;EjBuyDF;EiBxuDQ;IAhEN,cAAA;IACA,mBAAA;EjB2yDF;EiB5uDQ;IAhEN,cAAA;IACA,UAAA;EjB+yDF;EiBhvDQ;IAhEN,cAAA;IACA,mBAAA;EjBmzDF;EiBpvDQ;IAhEN,cAAA;IACA,mBAAA;EjBuzDF;EiBxvDQ;IAhEN,cAAA;IACA,WAAA;EjB2zDF;EiBpvDU;IAxDV,cAAA;EjB+yDA;EiBvvDU;IAxDV,wBAAA;EjBkzDA;EiB1vDU;IAxDV,yBAAA;EjBqzDA;EiB7vDU;IAxDV,gBAAA;EjBwzDA;EiBhwDU;IAxDV,yBAAA;EjB2zDA;EiBnwDU;IAxDV,yBAAA;EjB8zDA;EiBtwDU;IAxDV,gBAAA;EjBi0DA;EiBzwDU;IAxDV,yBAAA;EjBo0DA;EiB5wDU;IAxDV,yBAAA;EjBu0DA;EiB/wDU;IAxDV,gBAAA;EjB00DA;EiBlxDU;IAxDV,yBAAA;EjB60DA;EiBrxDU;IAxDV,yBAAA;EjBg1DA;EiB7wDM;;IAEE,gBAAA;EjB+wDR;EiB5wDM;;IAEE,gBAAA;EjB8wDR;EiBrxDM;;IAEE,sBAAA;EjBuxDR;EiBpxDM;;IAEE,sBAAA;EjBsxDR;EiB7xDM;;IAEE,qBAAA;EjB+xDR;EiB5xDM;;IAEE,qBAAA;EjB8xDR;EiBryDM;;IAEE,mBAAA;EjBuyDR;EiBpyDM;;IAEE,mBAAA;EjBsyDR;EiB7yDM;;IAEE,qBAAA;EjB+yDR;EiB5yDM;;IAEE,qBAAA;EjB8yDR;EiBrzDM;;IAEE,mBAAA;EjBuzDR;EiBpzDM;;IAEE,mBAAA;EjBszDR;AACF;AkB56DA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AlB26DF;AkBp6DE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AlBq6DJ;AkBl6DE;EACE,uBAAA;AlBo6DJ;AkBj6DE;EACE,sBAAA;AlBm6DJ;;AkB/5DA;EACE,+DAAA;AlBk6DF;;AkB35DA;EACE,iBAAA;AlB85DF;;AkBp5DE;EACE,wBAAA;AlBu5DJ;;AkBx4DE;EACE,sCAAA;AlB24DJ;AkBx4DI;EACE,sCAAA;AlB04DN;;AkBn4DE;EACE,sBAAA;AlBs4DJ;AkBn4DE;EACE,mBAAA;AlBq4DJ;;AkB33DE;EACE,oDAAA;EACA,8CAAA;AlB83DJ;;AkBx3DE;EACE,oDAAA;EACA,8CAAA;AlB23DJ;;AkBn3DA;EACE,oDAAA;EACA,8CAAA;AlBs3DF;;AkB92DE;EACE,mDAAA;EACA,6CAAA;AlBi3DJ;;AmB7/DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBy/DJ;;AmB3gEE;EAOE,sBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBugEJ;;AmBzhEE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,iDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBqhEJ;;AmBviEE;EAOE,sBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBmiEJ;;AmBrjEE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnBijEJ;;AmBnkEE;EAOE,sBAAA;EACA,uCAAA;EACA,oDAAA;EACA,kDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB+jEJ;;AmBjlEE;EAOE,sBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB6kEJ;;AmB/lEE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,6CAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AnB2lEJ;;AkB18DI;EACE,gBAAA;EACA,iCAAA;AlB68DN;;AexiEI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBm9DJ;AACF;Ae/iEI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBy9DJ;AACF;AerjEI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElB+9DJ;AACF;Ae3jEI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElBq+DJ;AACF;AejkEI;EGyFA;IACE,gBAAA;IACA,iCAAA;ElB2+DJ;AACF;AoB/oEA;EACE,qBbu2BsC;AP0yCxC;;AoBxoEA;EACE,mDAAA;EACA,sDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;AP0iD9B;;AoBroEA;EACE,oDAAA;EACA,uDAAA;EhBoQI,oBALI;AJ04DV;;AoBroEA;EACE,mDAAA;EACA,sDAAA;EhB8PI,oBALI;AJg5DV;;AqBtqEA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;APw0CxC;;AsB5qEA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,oCrB8G4B;EGyKxB,kBALI;EkBhRR,gBrBsG4B;EqBrG5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;AtB2qEF;AuB7qEM;EDhBN;ICiBQ,gBAAA;EvBgrEN;AACF;AsB9qEE;EACE,gBAAA;AtBgrEJ;AsB9qEI;EACE,eAAA;AtBgrEN;AsB3qEE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,oCf82BoC;Ee72BpC,UAAA;EAKE,iDfkhBkB;APupDxB;AsBrqEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;AtBypEJ;AsBppEE;EACE,cAAA;EACA,UAAA;AtBspEJ;AsBlpEE;EACE,gCf40BoC;Ee10BpC,UAAA;AtBmpEJ;AsB3oEE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;AtB0oEJ;AsBtoEE;EACE,uBAAA;EACA,wBAAA;EACA,yBrBqC0B;EqBpC1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;AtBwoEJ;AuB9tEM;ED0EJ;ICzEM,gBAAA;EvBiuEN;AACF;AsB1oEE;EACE,wCf47B8B;APgtClC;;AsBnoEA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;AtBsoEF;AsBpoEE;EACE,UAAA;AtBsoEJ;AsBnoEE;EAEE,gBAAA;EACA,eAAA;AtBooEJ;;AsBznEA;EACE,mEf4wBsC;Ee3wBtC,wBAAA;ElByII,oBALI;EIvQN,yCAAA;ARiwEJ;AsB1nEE;EACE,wBAAA;EACA,yBAAA;EACA,0BrBrB0B;ADipE9B;;AsBxnEA;EACE,oEfgwBsC;Ee/vBtC,wBAAA;ElB4HI,oBALI;EIvQN,yCAAA;AR6wEJ;AsBznEE;EACE,wBAAA;EACA,yBAAA;EACA,yBrBhC0B;AD2pE9B;;AsBnnEE;EACE,mEf6uBoC;APy4CxC;AsBnnEE;EACE,mEf0uBoC;AP24CxC;AsBlnEE;EACE,oEfuuBoC;AP64CxC;;AsB/mEA;EACE,WfquBsC;EepuBtC,+Df8tBsC;Ee7tBtC,gBrB9D4B;ADgrE9B;AsBhnEE;EACE,eAAA;AtBknEJ;AsB/mEE;EACE,oBAAA;EdvLA,sCAAA;ARyyEJ;AsB9mEE;EACE,oBAAA;Ed5LA,sCAAA;AR6yEJ;AsB7mEE;EAAoB,+Df8sBkB;APk6CxC;AsB/mEE;EAAoB,gEf8sBkB;APo6CxC;;AyBj0EA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,sCAAA;EACA,oCxB2G4B;EGyKxB,kBALI;EqB7QR,gBxBmG4B;EwBlG5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,wClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;AzBk0EF;AuBv0EM;EEfN;IFgBQ,gBAAA;EvB00EN;AACF;AyBr0EE;EACE,oClBs3BoC;EkBr3BpC,UAAA;EAKE,iDlBi+B4B;APk2ClC;AyB/zEE;EAEE,qBxB8F0B;EwB7F1B,sBAAA;AzBg0EJ;AyB7zEE;EAEE,wClBu1BoC;APu+CxC;AyBzzEE;EACE,kBAAA;EACA,uCAAA;AzB2zEJ;;AyBvzEA;EACE,oBxB6E4B;EwB5E5B,uBxB4E4B;EwB3E5B,qBxB4E4B;EGuJxB,oBALI;EIvQN,yCAAA;ARq2EJ;;AyBvzEA;EACE,qBxBuE4B;EwBtE5B,wBxBsE4B;EwBrE5B,oBxBsE4B;EGqJxB,oBALI;EIvQN,yCAAA;AR62EJ;;AyBrzEI;EACE,gEAAA;AzBwzEN;;A0Bh4EA;EACE,cAAA;EACA,mBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;AP89C1C;A0Bj4EE;EACE,WAAA;EACA,mBAAA;A1Bm4EJ;;A0B/3EA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;A1Bk4EF;A0Bh4EE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A1Bk4EJ;;A0B93EA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,yBAAA;A1Bg4EF;A0B73EE;ElB3BE,qBAAA;AR25EJ;A0B53EE;EAEE,kBnBm4BsC;AP0/C1C;A0B13EE;EACE,uBnB03BsC;APkgD1C;A0Bz3EE;EACE,oCnBs1BoC;EmBr1BpC,UAAA;EACA,iDnB8foB;AP63DxB;A0Bx3EE;EACE,yBzBjDO;EyBkDP,qBzBlDO;AD46EX;A0Bx3EI;EAII,iEAAA;A1Bu3ER;A0Bn3EI;EAII,iEAAA;A1Bk3ER;A0B72EE;EACE,yBzBtEO;EyBuEP,qBzBvEO;EyB4EL,iEAAA;A1B22EN;A0Bv2EE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;APugD3C;A0Bl2EI;EACE,eAAA;EACA,YnBy1BqC;AP2gD3C;;A0Bt1EA;EACE,mBnBo1BgC;APqgDlC;A0Bv1EE;EACE,4DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;A1Bw1EJ;AuB18EM;EG0GJ;IHzGM,gBAAA;EvB68EN;AACF;A0B31EI;EACE,4DAAA;A1B61EN;A0B11EI;EACE,iCnB60B4B;EmBx0B1B,4DAAA;A1Bw1ER;A0Bn1EE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;A1Bq1EJ;A0Bn1EI;EACE,oBAAA;EACA,cAAA;A1Bq1EN;;A0Bh1EA;EACE,qBAAA;EACA,kBnBsyBgC;AP6iDlC;;A0Bh1EA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A1Bm1EF;A0B/0EI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;AP2rD9B;;A0B10EI;EACE,4DAAA;A1B60EN;;A2BhgFA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A3BmgFF;A2BjgFE;EACE,UAAA;A3BmgFJ;A2B//EI;EAA0B,iEpB8gCa;APo/C3C;A2BjgFI;EAA0B,iEpB6gCa;APu/C3C;A2BjgFE;EACE,SAAA;A3BmgFJ;A2BhgFE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBvBaS;E0BeP,SpB6/BuC;EC1gCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A3BigFJ;AuBhhFM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EvBmhFN;AACF;A2BpgFI;EHjCF,0CjB8hCyC;AP0gD3C;A2BlgFE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;ARkiFJ;A2BhgFE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBvBaS;E0ByCP,SpBm+BuC;EC1gCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A3BigFJ;AuB1iFM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EvB6iFN;AACF;A2BpgFI;EH3DF,0CjB8hCyC;APoiD3C;A2BlgFE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;AR4jFJ;A2BhgFE;EACE,oBAAA;A3BkgFJ;A2BhgFI;EACE,2CpBg9BqC;APkjD3C;A2B//EI;EACE,2CpB48BqC;APqjD3C;;A4BxlFA;EACE,kBAAA;A5B2lFF;A4BzlFE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;APojDxC;A4BxlFE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELVE,gEKWF;A5B0lFJ;AuBjmFM;EKTJ;ILUM,gBAAA;EvBomFN;AACF;A4B5lFE;;EAEE,oBAAA;A5B8lFJ;A4B5lFI;;EACE,kBAAA;A5B+lFN;A4B5lFI;;;EAEE,qBrB0gCkC;EqBzgClC,wBrB0gCkC;APqlDxC;A4B5lFI;;EACE,qBrBqgCkC;EqBpgClC,wBrBqgCkC;AP0lDxC;A4B3lFE;EACE,qBrB+/BoC;EqB9/BpC,wBrB+/BoC;EqB9/BpC,oB3BiF0B;AD4gF9B;A4BtlFI;;;;EACE,8DrBy/BkC;APkmDxC;A4BtlFI;EACE,8DrBm/BkC;APqmDxC;A4BnlFI;;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,arBw+BkC;EqBv+BlC,WAAA;EACA,mCrBqzBkC;ECh3BpC,sCAAA;ARkpFJ;A4BnlFE;EACE,wCrBkzBoC;APmyDxC;A4BjlFI;EACE,sCAAA;A5BmlFN;A4B/kFE;;EAEE,c3BvFO;ADwqFX;;A6B3qFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A7B8qFF;A6B5qFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A7B8qFJ;A6B1qFE;;;EAGE,UAAA;A7B4qFJ;A6BtqFE;EACE,kBAAA;EACA,UAAA;A7BwqFJ;A6BtqFI;EACE,UAAA;A7BwqFN;;A6B7pFA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EzB8OI,kBALI;EyBvOR,gB5B6D4B;E4B5D5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;ARusFJ;;A6BvpFA;;;;EAIE,wBAAA;EzBwNI,oBALI;EIvQN,yCAAA;ARgtFJ;;A6BvpFA;;;;EAIE,wBAAA;EzB+MI,oBALI;EIvQN,yCAAA;ARytFJ;;A6BvpFA;;EAEE,qBAAA;A7B0pFF;;A6B7oFI;;;;ErBjEA,0BAAA;EACA,6BAAA;ARqtFJ;A6B5oFI;;;;ErB1EA,0BAAA;EACA,6BAAA;AR4tFJ;A6BtoFE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;ARmtFJ;A6BtoFE;;ErB9EE,yBAAA;EACA,4BAAA;ARwtFJ;;A8BhvFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;APgsDzB;;A8B/uFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,oBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;AR6wFJ;;A8B7uFI;;;;EAEE,cAAA;A9BkvFN;;A8BjyFI;EAqDE,+CvBuhCmB;EuBphCjB,mCvB81BgC;EuB71BhC,yDAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;A9B8uFR;A8B3uFM;EACE,+CvB4gCiB;EuBvgCf,2DvBugCe;APkuDzB;;A8B9yFI;EA+EI,mCvBu0BgC;EuBt0BhC,gFAAA;A9BmuFR;;A8BnzFI;EAuFE,+CvBq/BmB;AP2uDzB;A8B7tFQ;EAEE,iEAAA;EACA,sBvBq5B8B;EuBp5B9B,6DAAA;EACA,yEAAA;A9B8tFV;A8B1tFM;EACE,+CvBw+BiB;EuBn+Bf,2DvBm+Be;APqvDzB;;A8Bj0FI;EAkHI,wCAAA;A9BmtFR;;A8Br0FI;EAyHE,+CvBm9BmB;AP6vDzB;A8B9sFM;EACE,4CvBg9BiB;APgwDzB;A8B7sFM;EACE,2DvB48BiB;APmwDzB;A8B5sFM;EACE,iCvBw8BiB;APswDzB;;A8BzsFI;EACE,kBAAA;A9B4sFN;;A8Bt1FI;;;;;EAoJM,UAAA;A9B0sFV;;A8B10FE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;AP0xDzB;;A8Bz0FE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,oBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;ARu2FJ;;A8Bv0FI;;;;EAEE,cAAA;A9B40FN;;A8B33FI;EAqDE,iDvBuhCmB;EuBphCjB,mCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;A9Bw0FR;A8Br0FM;EACE,iDvB4gCiB;EuBvgCf,0DvBugCe;AP4zDzB;;A8Bx4FI;EA+EI,mCvBu0BgC;EuBt0BhC,gFAAA;A9B6zFR;;A8B74FI;EAuFE,iDvBq/BmB;APq0DzB;A8BvzFQ;EAEE,kEAAA;EACA,sBvBq5B8B;EuBp5B9B,6DAAA;EACA,yEAAA;A9BwzFV;A8BpzFM;EACE,iDvBw+BiB;EuBn+Bf,0DvBm+Be;AP+0DzB;;A8B35FI;EAkHI,wCAAA;A9B6yFR;;A8B/5FI;EAyHE,iDvBm9BmB;APu1DzB;A8BxyFM;EACE,8CvBg9BiB;AP01DzB;A8BvyFM;EACE,0DvB48BiB;AP61DzB;A8BtyFM;EACE,mCvBw8BiB;APg2DzB;;A8BnyFI;EACE,kBAAA;A9BsyFN;;A8Bh7FI;;;;;EAsJM,UAAA;A9BkyFV;;A+B17FA;EAEE,0BAAA;EACA,2BAAA;EACA,2CAAA;E3BuRI,2BALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A/Bw7FF;AuB58FM;EQhBN;IRiBQ,gBAAA;EvB+8FN;AACF;A+B37FE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A/B47FJ;A+Bz7FE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A/B07FJ;A+Bv7FE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A/Bq7FN;A+Bj7FE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A/B+6FN;A+B36FE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A/Bu6FJ;A+Bp6FI;EAKI,0CAAA;A/Bk6FR;A+B75FE;EAKI,0CAAA;A/B25FN;A+Bv5FE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A/Bs5FJ;;A+B14FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC6/FF;;A+B35FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC8gGF;;A+B56FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC+hGF;;A+B77FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCgjGF;;A+B98FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,kDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCikGF;;A+B/9FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,mDAAA;EACA,uCAAA;EACA,2BAAA;EACA,0CAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCklGF;;A+Bh/FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,8CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,yDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCmmGF;;A+BjgGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhConGF;;A+BlhGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCqoGF;;A+BniGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCspGF;;A+BpjGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCuqGF;;A+BrkGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCwrGF;;A+BtlGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCysGF;;A+BvmGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,+CAAA;EACA,wCAAA;EACA,2BAAA;EACA,sCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC0tGF;;A+BxnGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,kDAAA;EACA,sCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC2uGF;;A+BzoGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,8CAAA;EACA,qCAAA;EACA,2BAAA;EACA,qCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC4vGF;;A+B1pGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC6wGF;;A+B3qGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC8xGF;;A+B5rGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,sDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhC+yGF;;A+B7sGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,oDAAA;EACA,wCAAA;EACA,2BAAA;EACA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCg0GF;;A+B9tGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCi1GF;;A+B/uGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCk2GF;;A+BhwGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,kDAAA;EACA,sCAAA;EACA,2BAAA;EACA,yCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCm3GF;;A+BjxGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,gDAAA;EACA,sCAAA;EACA,2BAAA;EACA,uCAAA;EACA,kDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCo4GF;;A+BlyGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,gDAAA;EACA,sCAAA;EACA,2BAAA;EACA,uCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCq5GF;;A+BnzGE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,uCAAA;EACA,+CAAA;EACA,sCAAA;EACA,2BAAA;EACA,sCAAA;EACA,+CAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;AhCs6GF;;A+B1yGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC85GF;;A+B3zGE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC+6GF;;A+B50GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCg8GF;;A+B71GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCi9GF;;A+B92GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCk+GF;;A+B/3GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCm/GF;;A+Bh5GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCogHF;;A+Bj6GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCqhHF;;A+Bl7GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCsiHF;;A+Bn8GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCujHF;;A+Bp9GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCwkHF;;A+Br+GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCylHF;;A+Bt/GE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC0mHF;;A+BvgHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC2nHF;;A+BxhHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC4oHF;;A+BziHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC6pHF;;A+B1jHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC8qHF;;A+B3kHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhC+rHF;;A+B5lHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCgtHF;;A+B7mHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCiuHF;;A+B9nHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCkvHF;;A+B/oHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCmwHF;;A+BhqHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCoxHF;;A+BjrHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCqyHF;;A+BlsHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCszHF;;A+BntHE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;AhCu0HF;;A+BxtHA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,sCAAA;EAEA,0BxB8QwC;AP48G1C;A+BhtHE;EACE,0BAAA;A/BktHJ;A+B/sHE;EACE,gCAAA;A/BitHJ;;A+BtsHA;ECjJE,4BAAA;EACA,0BAAA;E5B8NI,6BALI;E4BvNR,kDAAA;AhC21HF;;A+BzsHA;ECrJE,2BAAA;EACA,2BAAA;E5B8NI,6BALI;E4BvNR,kDAAA;AhCk2HF;;AiCr6HA;EVgBM,gCUfJ;AjCw6HF;AuBr5HM;EUpBN;IVqBQ,gBAAA;EvBw5HN;AACF;AiC36HE;EACE,UAAA;AjC66HJ;;AiCv6HE;EACE,aAAA;AjC06HJ;;AiCt6HA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AjCy6HF;AuBv6HM;EULN;IVMQ,gBAAA;EvB06HN;AACF;AiC56HE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AjC86HJ;AuBj7HM;EUAJ;IVCM,gBAAA;EvBo7HN;AACF;;AkCz8HA;;;;;;EAME,kBAAA;AlC48HF;;AkCz8HA;EACE,mBAAA;AlC48HF;AmCp7HI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AnC49HF;AmCl6HI;EACE,cAAA;AnCo6HN;;AkCl9HA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,gCALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;AR4/HJ;AkC/8HE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AlCi9HJ;;AkCz7HI;EACE,oBAAA;AlC47HN;AkC17HM;EACE,WAAA;EACA,OAAA;AlC47HR;;AkCx7HI;EACE,kBAAA;AlC27HN;AkCz7HM;EACE,QAAA;EACA,UAAA;AlC27HR;;Aer+HI;EmB4BA;IACE,oBAAA;ElC68HJ;EkC38HI;IACE,WAAA;IACA,OAAA;ElC68HN;EkCz8HE;IACE,kBAAA;ElC28HJ;EkCz8HI;IACE,QAAA;IACA,UAAA;ElC28HN;AACF;Aet/HI;EmB4BA;IACE,oBAAA;ElC69HJ;EkC39HI;IACE,WAAA;IACA,OAAA;ElC69HN;EkCz9HE;IACE,kBAAA;ElC29HJ;EkCz9HI;IACE,QAAA;IACA,UAAA;ElC29HN;AACF;AetgII;EmB4BA;IACE,oBAAA;ElC6+HJ;EkC3+HI;IACE,WAAA;IACA,OAAA;ElC6+HN;EkCz+HE;IACE,kBAAA;ElC2+HJ;EkCz+HI;IACE,QAAA;IACA,UAAA;ElC2+HN;AACF;AethII;EmB4BA;IACE,oBAAA;ElC6/HJ;EkC3/HI;IACE,WAAA;IACA,OAAA;ElC6/HN;EkCz/HE;IACE,kBAAA;ElC2/HJ;EkCz/HI;IACE,QAAA;IACA,UAAA;ElC2/HN;AACF;AetiII;EmB4BA;IACE,oBAAA;ElC6gIJ;EkC3gII;IACE,WAAA;IACA,OAAA;ElC6gIN;EkCzgIE;IACE,kBAAA;ElC2gIJ;EkCzgII;IACE,QAAA;IACA,UAAA;ElC2gIN;AACF;AkClgIE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AlCogIJ;AmCxlII;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AnCynIF;AmCtkII;EACE,cAAA;AnCwkIN;;AkCxgIE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AlC2gIJ;AmC7mII;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AnCuoIF;AmC3lII;EACE,cAAA;AnC6lIN;AkCnhII;EACE,iBAAA;AlCqhIN;;AkC/gIE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AlCkhIJ;AmCroII;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AnCuoIN;AmC5nIM;EACE,aAAA;AnC8nIR;AmC3nIM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AnCiqIF;AmC3nII;EACE,cAAA;AnC6nIN;AkCliII;EACE,iBAAA;AlCoiIN;;AkC7hIA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AlCgiIF;;AkC1hIA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gBjCnE4B;EiCoE5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;ARosIJ;AkC3hIE;EAEE,0CAAA;EV1LF,kDU4LuB;AlC2hIzB;AkCxhIE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AlCyhIzB;AkCthIE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AlCuhIJ;;AkCjhIA;EACE,cAAA;AlCohIF;;AkChhIA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,oBALI;E8B5DR,sCAAA;EACA,mBAAA;AlCmhIF;;AkC/gIA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AlCkhIF;;AkC9gIA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AlCghIF;;AoCtwIA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;ApCywIF;AoCvwIE;;EACE,kBAAA;EACA,cAAA;ApC0wIJ;AoCrwIE;;;;;;;;;;;;EAME,UAAA;ApC6wIJ;;AoCxwIA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;ApC2wIF;AoCzwIE;EACE,WAAA;ApC2wIJ;;AoCvwIA;E5BhBI,sCAAA;AR2xIJ;AoCvwIE;;EAEE,8CAAA;ApCywIJ;AoCrwIE;;;E5BVE,0BAAA;EACA,6BAAA;ARoxIJ;AoCjwIE;;;E5BNE,yBAAA;EACA,4BAAA;AR4wIJ;;AoCpvIA;EACE,uBAAA;EACA,sBAAA;ApCuvIF;AoCrvIE;EAGE,cAAA;ApCqvIJ;AoClvIE;EACE,eAAA;ApCovIJ;;AoChvIA;EACE,wBAAA;EACA,uBAAA;ApCmvIF;;AoChvIA;EACE,qBAAA;EACA,oBAAA;ApCmvIF;;AoC/tIA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;ApCkuIF;AoChuIE;;EAEE,WAAA;ApCkuIJ;AoC/tIE;;EAEE,6CAAA;ApCiuIJ;AoC7tIE;;E5B1FE,6BAAA;EACA,4BAAA;AR2zIJ;AoCztIE;;;E5BjHE,yBAAA;EACA,0BAAA;AR+0IJ;;AqCv2IA;EAEE,+BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArCs2IF;;AqCn2IA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ArCs2IF;AuBl3IM;EcGN;IdFQ,gBAAA;EvBq3IN;AACF;AqCz2IE;EAEE,qCAAA;ArC02IJ;AqCt2IE;EACE,UAAA;EACA,iD9BkhBoB;APs1HxB;AqCp2IE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ArCq2IJ;;AqC71IA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ArC61IF;AqC31IE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;AR24IJ;AqC51II;EAGE,kBAAA;EACA,wDAAA;ArC41IN;AqCx1IE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ArC01IJ;AqCv1IE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;AR05IJ;;AqC/0IA;EAEE,qDAAA;EACA,yCAAA;EACA,sCAAA;ArCi1IF;AqC90IE;E7B5FE,gDAAA;AR66IJ;AqC70IE;;EAEE,4CAAA;EbjHF,oDakHuB;ArC+0IzB;;AqCt0IA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ArCs0IF;AqCp0IE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ArCs0IJ;AqCp0II;EAEE,iCAAA;ArCq0IN;AqCj0IE;;EAEE,gBpCpC0B;EoCqC1B,gDAAA;EACA,iCAAA;ArCm0IJ;;AqCzzIE;;EAEE,cAAA;EACA,kBAAA;ArC4zIJ;;AqCvzIE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;ArC0zIJ;;AqCpzIE;;EACE,WAAA;ArCwzIJ;;AqC9yIE;EACE,aAAA;ArCizIJ;AqC/yIE;EACE,cAAA;ArCizIJ;;AsC9+IA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,sCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,wCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AtC8+IF;AsCx+IE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AtCg/IJ;AsC59IA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;AtC89IF;AsC59IE;EAEE,yCAAA;AtC69IJ;;AsCn9IA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AtCk9IF;AsC/8II;EAEE,oCAAA;AtCg9IN;AsC58IE;EACE,gBAAA;AtC88IJ;;AsCr8IA;EACE,mBrC4DkC;EqC3DlC,sBrC2DkC;EqC1DlC,6BAAA;AtCw8IF;AsCt8IE;;;EAGE,oCAAA;AtCw8IJ;;AsC37IA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;AtC47IF;;AsCx7IA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;AtC27IF;AuBpkJM;EeiIN;IfhIQ,gBAAA;EvBukJN;AACF;AsC97IE;EACE,qBAAA;AtCg8IJ;AsC77IE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AtC+7IJ;;AsCz7IA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AtC47IF;;AsCz7IA;EACE,yCAAA;EACA,gBAAA;AtC47IF;;AetjJI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtCm7IN;EsCj7IM;IACE,mBAAA;EtCm7IR;EsCj7IQ;IACE,kBAAA;EtCm7IV;EsCh7IQ;IACE,kDAAA;IACA,iDAAA;EtCk7IV;EsC96IM;IACE,iBAAA;EtCg7IR;EsC76IM;IACE,wBAAA;IACA,gBAAA;EtC+6IR;EsC56IM;IACE,aAAA;EtC86IR;EsC36IM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtC26IR;EsCx6IQ;IACE,aAAA;EtC06IV;EsCv6IQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCy6IV;AACF;AetmJI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtCk+IN;EsCh+IM;IACE,mBAAA;EtCk+IR;EsCh+IQ;IACE,kBAAA;EtCk+IV;EsC/9IQ;IACE,kDAAA;IACA,iDAAA;EtCi+IV;EsC79IM;IACE,iBAAA;EtC+9IR;EsC59IM;IACE,wBAAA;IACA,gBAAA;EtC89IR;EsC39IM;IACE,aAAA;EtC69IR;EsC19IM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtC09IR;EsCv9IQ;IACE,aAAA;EtCy9IV;EsCt9IQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCw9IV;AACF;AerpJI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtCihJN;EsC/gJM;IACE,mBAAA;EtCihJR;EsC/gJQ;IACE,kBAAA;EtCihJV;EsC9gJQ;IACE,kDAAA;IACA,iDAAA;EtCghJV;EsC5gJM;IACE,iBAAA;EtC8gJR;EsC3gJM;IACE,wBAAA;IACA,gBAAA;EtC6gJR;EsC1gJM;IACE,aAAA;EtC4gJR;EsCzgJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCygJR;EsCtgJQ;IACE,aAAA;EtCwgJV;EsCrgJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCugJV;AACF;AepsJI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtCgkJN;EsC9jJM;IACE,mBAAA;EtCgkJR;EsC9jJQ;IACE,kBAAA;EtCgkJV;EsC7jJQ;IACE,kDAAA;IACA,iDAAA;EtC+jJV;EsC3jJM;IACE,iBAAA;EtC6jJR;EsC1jJM;IACE,wBAAA;IACA,gBAAA;EtC4jJR;EsCzjJM;IACE,aAAA;EtC2jJR;EsCxjJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCwjJR;EsCrjJQ;IACE,aAAA;EtCujJV;EsCpjJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCsjJV;AACF;AenvJI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;EtC+mJN;EsC7mJM;IACE,mBAAA;EtC+mJR;EsC7mJQ;IACE,kBAAA;EtC+mJV;EsC5mJQ;IACE,kDAAA;IACA,iDAAA;EtC8mJV;EsC1mJM;IACE,iBAAA;EtC4mJR;EsCzmJM;IACE,wBAAA;IACA,gBAAA;EtC2mJR;EsCxmJM;IACE,aAAA;EtC0mJR;EsCvmJM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;EtCumJR;EsCpmJQ;IACE,aAAA;EtCsmJV;EsCnmJQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EtCqmJV;AACF;AsC5pJI;EAEI,iBAAA;EACA,2BAAA;AtC6pJR;AsC3pJQ;EACE,mBAAA;AtC6pJV;AsC3pJU;EACE,kBAAA;AtC6pJZ;AsC1pJU;EACE,kDAAA;EACA,iDAAA;AtC4pJZ;AsCxpJQ;EACE,iBAAA;AtC0pJV;AsCvpJQ;EACE,wBAAA;EACA,gBAAA;AtCypJV;AsCtpJQ;EACE,aAAA;AtCwpJV;AsCrpJQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;AtCqpJV;AsClpJU;EACE,aAAA;AtCopJZ;AsCjpJU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AtCmpJZ;;AsCloJA;;EAGE,4CAAA;EACA,6BAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AtCooJF;;AsC9nJI;EACE,qEAAA;AtCioJN;;AuC15JA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,8BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;AR46JJ;AuCv5JE;EACE,eAAA;EACA,cAAA;AvCy5JJ;AuCt5JE;EACE,mBAAA;EACA,sBAAA;AvCw5JJ;AuCt5JI;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;AR+6JJ;AuCt5JI;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;ARs6JJ;AuCn5JE;;EAEE,aAAA;AvCq5JJ;;AuCj5JA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AvCk5JF;;AuC/4JA;EACE,4CAAA;EACA,iCAAA;AvCk5JF;;AuC/4JA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AvCk5JF;;AuC/4JA;EACE,gBAAA;AvCk5JF;;AuC14JE;EACE,oCAAA;AvC64JJ;;AuCr4JA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AvCw4JF;AuCt4JE;E/B7FE,wFAAA;ARs+JJ;;AuCp4JA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AvCu4JF;AuCr4JE;E/BxGE,wFAAA;ARg/JJ;;AuC93JA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AvCi4JF;AuC/3JE;EACE,mCAAA;EACA,sCAAA;AvCi4JJ;;AuC73JA;EACE,uDAAA;EACA,sDAAA;AvCg4JF;;AuC53JA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;AR0gKJ;;AuC53JA;;;EAGE,WAAA;AvC+3JF;;AuC53JA;;E/B3II,0DAAA;EACA,2DAAA;AR4gKJ;;AuC73JA;;E/BlII,8DAAA;EACA,6DAAA;ARogKJ;;AuCt3JE;EACE,0CAAA;AvCy3JJ;Aep/JI;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EvCy3JF;EuCt3JE;IACE,SAAA;IACA,gBAAA;EvCw3JJ;EuCt3JI;IACE,cAAA;IACA,cAAA;EvCw3JN;EuCn3JM;I/B1KJ,0BAAA;IACA,6BAAA;ERgiKF;EuCp3JQ;;IAGE,0BAAA;EvCq3JV;EuCn3JQ;;IAGE,6BAAA;EvCo3JV;EuCh3JM;I/B3KJ,yBAAA;IACA,4BAAA;ER8hKF;EuCj3JQ;;IAGE,yBAAA;EvCk3JV;EuCh3JQ;;IAGE,4BAAA;EvCi3JV;AACF;;AwCrlKA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,oCAAA;EACA,oCAAA;EACA,iCAAA;EACA,8BAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,0EAAA;EACA,qCAAA;EACA,qCAAA;EACA,oCAAA;EACA,iCAAA;AxCulKF;;AwCnlKA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,kBALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AxCslKF;AuB7mKM;EiBUN;IjBTQ,gBAAA;EvBgnKN;AACF;AwCzlKE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AxC2lKJ;AwCzlKI;EACE,qDAAA;EACA,iDAAA;AxC2lKN;AwCtlKE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AxCwlKJ;AuBtoKM;EiBqCJ;IjBpCM,gBAAA;EvByoKN;AACF;AwC1lKE;EACE,UAAA;AxC4lKJ;AwCzlKE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AxC2lKJ;;AwCvlKA;EACE,gBAAA;AxC0lKF;;AwCvlKA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AxC0lKF;AwCxlKE;EhC7DE,yDAAA;EACA,0DAAA;ARwpKJ;AwCzlKI;EhChEA,+DAAA;EACA,gEAAA;AR4pKJ;AwCxlKE;EACE,aAAA;AxC0lKJ;AwCtlKE;EhC5DE,6DAAA;EACA,4DAAA;ARqpKJ;AwCtlKM;EhChEF,mEAAA;EACA,kEAAA;ARypKJ;AwCrlKI;EhCrEA,6DAAA;EACA,4DAAA;AR6pKJ;;AwCnlKA;EACE,8EAAA;AxCslKF;;AwC7kKE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;AR+rKJ;AwC9kKI;EAAgB,aAAA;AxCilKpB;AwChlKI;EAAe,gBAAA;AxCmlKnB;AwChlKI;;;EhCrHA,gBAAA;AR0sKJ;;AwC1kKI;EACE,iEAAA;EACA,wEAAA;AxC6kKN;;AyCluKA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;ARkuKJ;;AyC5tKE;EACE,iDAAA;AzC+tKJ;AyC7tKI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AzC+tKN;AyC3tKE;EACE,6CAAA;AzC6tKJ;;A0ClwKA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,kCALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,uEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AVuxKF;;A0ChwKA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;A1CmwKF;AuBpxKM;EmBQN;InBPQ,gBAAA;EvBuxKN;AACF;A0CtwKE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A1CuwKJ;A0CpwKE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;A1CswKJ;A0CnwKE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;A1CowKJ;A0CjwKE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A1CkwKJ;;A0C7vKE;EACE,8CnC8sCgC;APkjIpC;A0C3vKM;ElC9BF,0DAAA;EACA,6DAAA;AR4xKJ;A0CzvKM;ElClDF,2DAAA;EACA,8DAAA;AR8yKJ;;A0C5uKA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,oCALI;EuCnRR,yDAAA;A3Ck1KF;;A0C/uKA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,oCALI;EuCnRR,yDAAA;A3Cy1KF;;A4C31KA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;ARg2KJ;A4Cv1KE;EACE,aAAA;A5Cy1KJ;;A4Cp1KA;EACE,kBAAA;EACA,SAAA;A5Cu1KF;;A6Cv3KA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;AR23KJ;;A6Cn3KA;EAEE,cAAA;A7Cq3KF;;A6Cj3KA;EACE,gB5C+E4B;E4C9E5B,iCAAA;A7Co3KF;;A6C52KA;EACE,mBtCs+C8B;APy4HhC;A6C52KE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A7C82KJ;;A6Ct2KE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7Cy2KJ;;A6C72KE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A7Cg3KJ;;A6Cp3KE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7Cu3KJ;;A6C33KE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7C83KJ;;A6Cl4KE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A7Cq4KJ;;A6Cz4KE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A7C44KJ;;A6Ch5KE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A7Cm5KJ;;A6Cv5KE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A7C05KJ;;A6C95KE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A7Ci6KJ;;A6Cr6KE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A7Cw6KJ;;A6C56KE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A7C+6KJ;;A6Cn7KE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A7Cs7KJ;;A6C17KE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A7C67KJ;;A6Cj8KE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A7Co8KJ;;A6Cx8KE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A7C28KJ;;A6C/8KE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A7Ck9KJ;;A6Ct9KE;EACE,kDAAA;EACA,2CAAA;EACA,yDAAA;EACA,uDAAA;A7Cy9KJ;;A6C79KE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A7Cg+KJ;;A6Cp+KE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A7Cu+KJ;;A6C3+KE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A7C8+KJ;;A6Cl/KE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A7Cq/KJ;;A6Cz/KE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A7C4/KJ;;A6ChgLE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A7CmgLJ;;A6CvgLE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A7C0gLJ;;A6C9gLE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A7CihLJ;;A6CrhLE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,0DAAA;A7CwhLJ;;A8CplLE;EACE;IAAK,gDAAA;E9CwlLP;AACF;A8CplLA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;AR4lLJ;;A8C/kLA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A9CklLF;AuBvmLM;EuBYN;IvBXQ,gBAAA;EvB0mLN;AACF;;A8CplLA;EtBAE,qMAAA;EsBEA,oEAAA;A9CulLF;;A8CplLA;EACE,iBAAA;A9CulLF;;A8CplLA;EACE,WAAA;A9CulLF;;A8CnlLE;EACE,kDAAA;A9CslLJ;A8CnlLM;EAJJ;IAKM,eAAA;E9CslLN;AACF;;A+ClpLA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AR4pLJ;;A+C7oLA;EACE,qBAAA;EACA,sBAAA;A/CgpLF;A+C9oLE;EAEE,oCAAA;EACA,0BAAA;A/C+oLJ;;A+CvoLA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A/C0oLF;A+CxoLE;EvC9BE,+BAAA;EACA,gCAAA;ARyqLJ;A+CxoLE;EvCpBE,mCAAA;EACA,kCAAA;AR+pLJ;A+CxoLE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A/CyoLJ;A+CroLE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A/CuoLJ;A+CnoLE;EACE,mBAAA;A/CqoLJ;A+CnoLI;EACE,wDAAA;EACA,mDAAA;A/CqoLN;;A+C3nLA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A/C8nLF;A+C1nLI;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A/C2nLN;A+CxnLI;EACE,+CAAA;EACA,uDAAA;A/C0nLN;;A+C7mLI;EACE,mBAAA;A/CgnLN;A+C7mLQ;EvCzDJ,6DAAA;EAZA,0BAAA;ARsrLJ;A+C5mLQ;EvC1EJ,2DAAA;EAYA,4BAAA;AR8qLJ;A+C3mLQ;EACE,aAAA;A/C6mLV;A+C1mLQ;EACE,mDAAA;EACA,oBAAA;A/C4mLV;A+C1mLU;EACE,yDAAA;EACA,oDAAA;A/C4mLZ;;AepsLI;EgCgEA;IACE,mBAAA;E/CwoLJ;E+CroLM;IvCzDJ,6DAAA;IAZA,0BAAA;ER8sLF;E+CpoLM;IvC1EJ,2DAAA;IAYA,4BAAA;ERssLF;E+CnoLM;IACE,aAAA;E/CqoLR;E+CloLM;IACE,mDAAA;IACA,oBAAA;E/CooLR;E+CloLQ;IACE,yDAAA;IACA,oDAAA;E/CooLV;AACF;Ae7tLI;EgCgEA;IACE,mBAAA;E/CgqLJ;E+C7pLM;IvCzDJ,6DAAA;IAZA,0BAAA;ERsuLF;E+C5pLM;IvC1EJ,2DAAA;IAYA,4BAAA;ER8tLF;E+C3pLM;IACE,aAAA;E/C6pLR;E+C1pLM;IACE,mDAAA;IACA,oBAAA;E/C4pLR;E+C1pLQ;IACE,yDAAA;IACA,oDAAA;E/C4pLV;AACF;AervLI;EgCgEA;IACE,mBAAA;E/CwrLJ;E+CrrLM;IvCzDJ,6DAAA;IAZA,0BAAA;ER8vLF;E+CprLM;IvC1EJ,2DAAA;IAYA,4BAAA;ERsvLF;E+CnrLM;IACE,aAAA;E/CqrLR;E+ClrLM;IACE,mDAAA;IACA,oBAAA;E/CorLR;E+ClrLQ;IACE,yDAAA;IACA,oDAAA;E/CorLV;AACF;Ae7wLI;EgCgEA;IACE,mBAAA;E/CgtLJ;E+C7sLM;IvCzDJ,6DAAA;IAZA,0BAAA;ERsxLF;E+C5sLM;IvC1EJ,2DAAA;IAYA,4BAAA;ER8wLF;E+C3sLM;IACE,aAAA;E/C6sLR;E+C1sLM;IACE,mDAAA;IACA,oBAAA;E/C4sLR;E+C1sLQ;IACE,yDAAA;IACA,oDAAA;E/C4sLV;AACF;AeryLI;EgCgEA;IACE,mBAAA;E/CwuLJ;E+CruLM;IvCzDJ,6DAAA;IAZA,0BAAA;ER8yLF;E+CpuLM;IvC1EJ,2DAAA;IAYA,4BAAA;ERsyLF;E+CnuLM;IACE,aAAA;E/CquLR;E+CluLM;IACE,mDAAA;IACA,oBAAA;E/CouLR;E+CluLQ;IACE,yDAAA;IACA,oDAAA;E/CouLV;AACF;A+CvtLA;EvClJI,gBAAA;AR42LJ;A+CvtLE;EACE,mDAAA;A/CytLJ;A+CvtLI;EACE,sBAAA;A/CytLN;;A+C5sLE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/C+sLJ;;A+CztLE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A/C4tLJ;;A+CtuLE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/CyuLJ;;A+CnvLE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/CsvLJ;;A+ChwLE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A/CmwLJ;;A+C7wLE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A/CgxLJ;;A+C1xLE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A/C6xLJ;;A+CvyLE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A/C0yLJ;;A+CpzLE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;A/CuzLJ;;A+Cj0LE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;A/Co0LJ;;A+C90LE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;A/Ci1LJ;;A+C31LE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;A/C81LJ;;A+Cx2LE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;A/C22LJ;;A+Cr3LE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;A/Cw3LJ;;A+Cl4LE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;A/Cq4LJ;;A+C/4LE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;A/Ck5LJ;;A+C55LE;EACE,uDAAA;EACA,gDAAA;EACA,8DAAA;EACA,4DAAA;EACA,iEAAA;EACA,6DAAA;EACA,kEAAA;EACA,0DAAA;EACA,2DAAA;EACA,qEAAA;A/C+5LJ;;A+Cz6LE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A/C46LJ;;A+Ct7LE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A/Cy7LJ;;A+Cn8LE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A/Cs8LJ;;A+Ch9LE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A/Cm9LJ;;A+C79LE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A/Cg+LJ;;A+C1+LE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A/C6+LJ;;A+Cv/LE;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A/C0/LJ;;A+CpgME;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A/CugMJ;;A+CjhME;EACE,0DAAA;EACA,mDAAA;EACA,iEAAA;EACA,4DAAA;EACA,oEAAA;EACA,6DAAA;EACA,qEAAA;EACA,6DAAA;EACA,8DAAA;EACA,wEAAA;A/CohMJ;;AgDltMA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,kEAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,UzCupD2B;EyCtpD3B,WzCspD2B;EyCrpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,kCAAA;EACA,SAAA;ExCJE,sBAAA;EwCMF,oCAAA;AhDktMF;AgD/sME;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;AhDitMJ;AgD9sME;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;AhDgtMJ;AgD7sME;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;AhD8sMJ;;AgDtsMA;EAHE,iEAAA;AhD6sMF;;AgDtsMA;;EAEE,uBAAA;AhDysMF;;AKpvMI;E2CkCF,iEAAA;AhDstMF;;AiDvwMA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,wBAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;ARgxMJ;AiDrwME;EACE,UAAA;AjDuwMJ;AiDpwME;EACE,aAAA;AjDswMJ;;AiDlwMA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AjDowMF;AiDlwME;EACE,sCAAA;AjDowMJ;;AiDhwMA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;ARoyMJ;AiDlwME;EACE,oDAAA;EACA,sCAAA;AjDowMJ;;AiDhwMA;EACE,kCAAA;EACA,qBAAA;AjDmwMF;;AkDj0MA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sCAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AlD+zMF;;AkDxzMA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AlD0zMF;AkDvzME;EACE,8B3Cm8CgC;EgBh/C9B,mC2B8CF;AlDyzMJ;AuBn2MM;E2BwCJ;I3BvCM,gBAAA;EvBs2MN;AACF;AkD5zME;EACE,e3Cg8CgC;AP83JpC;AkD1zME;EACE,sB3C67CgC;AP+3JpC;;AkDxzMA;EACE,+CAAA;AlD2zMF;AkDzzME;EACE,gBAAA;EACA,gBAAA;AlD2zMJ;AkDxzME;EACE,gBAAA;AlD0zMJ;;AkDtzMA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AlDyzMF;;AkDrzMA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AlDqzMF;;AkDjzMA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AlDuzM9D;AmDn6ME;EAAS,UAAA;AnDs6MX;AmDr6ME;EAAS,mCD2GiF;AlD6zM5F;;AkDxzMA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;ARi6MJ;AkD1zME;EACE,kGAAA;EAEA,yDAAA;EACA,2DAAA;EACA,4DAAA;EACA,iBAAA;AlD2zMJ;;AkDtzMA;EACE,gBAAA;EACA,8CAAA;AlDyzMF;;AkDpzMA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AlDqzMF;;AkDjzMA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;ARk7MJ;AkDhzME;EACE,8CAAA;AlDkzMJ;;Aej6MI;EmCqHF;IACE,0BAAA;IACA,2CAAA;ElDgzMF;EkD5yMA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;ElD8yMF;EkD3yMA;IACE,uBAAA;ElD6yMF;AACF;Aeh7MI;EmCuIF;;IAEE,uBAAA;ElD4yMF;AACF;Aet7MI;EmC8IF;IACE,wBAAA;ElD2yMF;AACF;AkDlyMI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AlDoyMN;AkDlyMM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;ARk/MJ;AkDjyMM;;E1CjNF,gBAAA;ARs/MJ;AkDhyMM;EACE,gBAAA;AlDkyMR;;Aeh8MI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDwzMJ;EkDtzMI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ERsgNF;EkDrzMI;;I1CjNF,gBAAA;ER0gNF;EkDpzMI;IACE,gBAAA;ElDszMN;AACF;Aer9MI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElD40MJ;EkD10MI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ER0hNF;EkDz0MI;;I1CjNF,gBAAA;ER8hNF;EkDx0MI;IACE,gBAAA;ElD00MN;AACF;Aez+MI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDg2MJ;EkD91MI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ER8iNF;EkD71MI;;I1CjNF,gBAAA;ERkjNF;EkD51MI;IACE,gBAAA;ElD81MN;AACF;Ae7/MI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDo3MJ;EkDl3MI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ERkkNF;EkDj3MI;;I1CjNF,gBAAA;ERskNF;EkDh3MI;IACE,gBAAA;ElDk3MN;AACF;AejhNI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;ElDw4MJ;EkDt4MI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;ERslNF;EkDr4MI;;I1CjNF,gBAAA;ER0lNF;EkDp4MI;IACE,gBAAA;ElDs4MN;AACF;AoDhnNA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,iCALI;EgDjRR,wBAAA;EACA,wBAAA;EACA,mDAAA;EACA,uBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gBpD4G4B;EoD3G5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;ApDwnNF;AoDtnNE;EAAS,kCAAA;ApDynNX;AoDvnNE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ApDynNJ;AoDvnNI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDynNN;;AoDpnNA;EACE,iDAAA;ApDunNF;AoDrnNE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;ApDunNJ;;AoDnnNA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;ApDsnNF;AoDpnNE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;ApDsnNJ;;AoDlnNA,mBAAA;AAEA;EACE,8CAAA;ApDonNF;AoDlnNE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;ApDonNJ;;AoDhnNA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;ApDmnNF;AoDjnNE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;ApDmnNJ;;AoD/mNA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;ARmsNJ;;AsDttNA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,iCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,kCAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,sCALI;EkD5QR,kCAAA;EACA,4BAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gBpD4G4B;EoD3G5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;ARivNJ;AsD7tNE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AtD+tNJ;AsD7tNI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AtD8tNN;;AsDxtNE;EACE,oFAAA;AtD2tNJ;AsDztNI;EAEE,wFAAA;AtD0tNN;AsDvtNI;EACE,SAAA;EACA,gDAAA;AtDytNN;AsDttNI;EACE,sCAAA;EACA,sCAAA;AtDwtNN;;AsDntNA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;AtDqtNJ;AsDntNI;EAEE,kIAAA;AtDotNN;AsDjtNI;EACE,OAAA;EACA,kDAAA;AtDmtNN;AsDhtNI;EACE,oCAAA;EACA,wCAAA;AtDktNN;;AsD7sNA,mBAAA;AAGE;EACE,iFAAA;AtD8sNJ;AsD5sNI;EAEE,wFAAA;AtD6sNN;AsD1sNI;EACE,MAAA;EACA,mDAAA;AtD4sNN;AsDzsNI;EACE,mCAAA;EACA,yCAAA;AtD2sNN;AsDtsNE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;AtDwsNJ;;AsDpsNA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;AtDssNJ;AsDpsNI;EAEE,kIAAA;AtDqsNN;AsDlsNI;EACE,QAAA;EACA,iDAAA;AtDosNN;AsDjsNI;EACE,qCAAA;EACA,uCAAA;AtDmsNN;;AsD9rNA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AR60NJ;AsD/qNE;EACE,aAAA;AtDirNJ;;AsD7qNA;EACE,0EAAA;EACA,mCAAA;AtDgrNF;;AuDr2NA;EACE,kBAAA;AvDw2NF;;AuDr2NA;EACE,mBAAA;AvDw2NF;;AuDr2NA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AvDw2NF;AwD93NE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxDg4NJ;;AuDz2NA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AvD42NF;AuB33NM;EgCQN;IhCPQ,gBAAA;EvB83NN;AACF;;AuD92NA;;;EAGE,cAAA;AvDi3NF;;AuD92NA;;EAEE,2BAAA;AvDi3NF;;AuD92NA;;EAEE,4BAAA;AvDi3NF;;AuDx2NE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AvD22NJ;AuDx2NE;;;EAGE,UAAA;EACA,UAAA;AvD02NJ;AuDv2NE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AvDy2NJ;AuBl6NM;EgCqDJ;;IhCpDM,gBAAA;EvBs6NN;AACF;;AuDt2NA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WtDjGS;EsDkGT,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,SAAA;EACA,YhD4gDmC;EgBnmD/B,8BgCwFJ;AvDw2NF;AuB57NM;EgCkEN;;IhCjEQ,gBAAA;EvBg8NN;AACF;AuD32NE;;;EAEE,WtD5GO;EsD6GP,qBAAA;EACA,UAAA;EACA,YhDogDiC;AP02KrC;;AuD32NA;EACE,OAAA;AvD82NF;;AuD32NA;EACE,QAAA;AvD82NF;;AuDz2NA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AvD42NF;;AuDz2NA;EACE,0TAAA;AvD42NF;;AuD12NA;EACE,yTAAA;AvD62NF;;AuDr2NA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDq9CmC;EgDp9CnC,mBAAA;EACA,gBhDm9CmC;APo5KrC;AuDr2NE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB5mD/B,6BgCkKF;AvDs2NJ;AuBpgOM;EgC6IJ;IhC5IM,gBAAA;EvBugON;AACF;AuDx2NE;EACE,UhDw8CiC;APk6KrC;;AuDj2NA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,uCAAA;EACA,kBAAA;AvDo2NF;;AuDz1NA;EALE,uCAAA;EACA,iCAAA;EACA,2DAAA;AvDk2NF;;AuD31NA;;EAEE,uCAAA;EACA,iCAAA;EACA,mCAAA;AvD81NF;;AKziOI;EkD8LF,uCAAA;EACA,iCAAA;EACA,2DAAA;AvD+2NF;;AyD1jOA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AzD4jOF;;AyDxjOA;EACE;IAAK,0CAAA;EzD4jOL;AACF;AyDzjOA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AzDwjOF;;AyDrjOA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AzDujOF;;AyD9iOA;EACE;IACE,mBAAA;EzDijOF;EyD/iOA;IACE,UAAA;IACA,eAAA;EzDijOF;AACF;AyD7iOA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AzD4iOF;;AyDziOA;EACE,wBAAA;EACA,yBAAA;AzD4iOF;;AyDxiOE;EACE;;IAEE,kCAAA;EzD2iOJ;AACF;A0D3nOA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;A1D4nOF;;Ae/jOI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1D6mOJ;AACF;AuBxoOM;EmCYJ;InCXM,gBAAA;EvB2oON;AACF;AerlOI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1DonON;E0DjnOI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1DmnON;E0DhnOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1DknON;E0D/mOI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1DinON;E0D9mOI;IAEE,eAAA;E1D+mON;E0D5mOI;IAGE,mBAAA;E1D4mON;AACF;AezoOI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1D2mON;E0DzmOM;IACE,aAAA;E1D2mOR;E0DxmOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DymOR;AACF;;Ae7oOI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1D2rOJ;AACF;AuBttOM;EmCYJ;InCXM,gBAAA;EvBytON;AACF;AenqOI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1DksON;E0D/rOI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1DisON;E0D9rOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1DgsON;E0D7rOI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1D+rON;E0D5rOI;IAEE,eAAA;E1D6rON;E0D1rOI;IAGE,mBAAA;E1D0rON;AACF;AevtOI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DyrON;E0DvrOM;IACE,aAAA;E1DyrOR;E0DtrOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DurOR;AACF;;Ae3tOI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1DywOJ;AACF;AuBpyOM;EmCYJ;InCXM,gBAAA;EvBuyON;AACF;AejvOI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1DgxON;E0D7wOI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1D+wON;E0D5wOI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1D8wON;E0D3wOI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1D6wON;E0D1wOI;IAEE,eAAA;E1D2wON;E0DxwOI;IAGE,mBAAA;E1DwwON;AACF;AeryOI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1DuwON;E0DrwOM;IACE,aAAA;E1DuwOR;E0DpwOM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1DqwOR;AACF;;AezyOI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1Du1OJ;AACF;AuBl3OM;EmCYJ;InCXM,gBAAA;EvBq3ON;AACF;Ae/zOI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1D81ON;E0D31OI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1D61ON;E0D11OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1D41ON;E0Dz1OI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1D21ON;E0Dx1OI;IAEE,eAAA;E1Dy1ON;E0Dt1OI;IAGE,mBAAA;E1Ds1ON;AACF;Aen3OI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1Dq1ON;E0Dn1OM;IACE,aAAA;E1Dq1OR;E0Dl1OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1Dm1OR;AACF;;Aev3OI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;E1Dq6OJ;AACF;AuBh8OM;EmCYJ;InCXM,gBAAA;EvBm8ON;AACF;Ae74OI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E1D46ON;E0Dz6OI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E1D26ON;E0Dx6OI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E1D06ON;E0Dv6OI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E1Dy6ON;E0Dt6OI;IAEE,eAAA;E1Du6ON;E0Dp6OI;IAGE,mBAAA;E1Do6ON;AACF;Aej8OI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E1Dm6ON;E0Dj6OM;IACE,aAAA;E1Dm6OR;E0Dh6OM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E1Di6OR;AACF;;A0Dj/OE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;A1Dk/ON;AuB5gPM;EmCYJ;InCXM,gBAAA;EvB+gPN;AACF;A0Dr/OM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A1Du/OR;A0Dp/OM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A1Ds/OR;A0Dn/OM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A1Dq/OR;A0Dl/OM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A1Do/OR;A0Dj/OM;EAEE,eAAA;A1Dk/OR;A0D/+OM;EAGE,mBAAA;A1D++OR;;A0Dp9OA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sBlDGS;ADykPX;AmDzkPE;EAAS,UAAA;AnD4kPX;AmD3kPE;EAAS,Y5Cm+CyB;AP2mMpC;;A0Dh+OA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;A1Dm+OF;A0Dj+OE;EACE,4FAAA;EAEA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iBAAA;A1Dk+OJ;;A0D99OA;EACE,gBAAA;EACA,kDAAA;A1Di+OF;;A0D99OA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A1Di+OF;;A2DlnPA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;APq0MpC;A2DnnPE;EACE,qBAAA;EACA,WAAA;A3DqnPJ;;A2DhnPA;EACE,iBAAA;A3DmnPF;;A2DhnPA;EACE,iBAAA;A3DmnPF;;A2DhnPA;EACE,iBAAA;A3DmnPF;;A2D9mPE;EACE,mDAAA;A3DinPJ;;A2D7mPA;EACE;IACE,YpDmxCgC;EP61MlC;AACF;A2D7mPA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A3D+mPF;;A2D5mPA;EACE;IACE,uBAAA;E3D+mPF;AACF;AwD9pPE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AxDgqPJ;;A4DnqPE;EACE,sBAAA;EACA,iFAAA;A5DsqPJ;;A4DxqPE;EACE,sBAAA;EACA,mFAAA;A5D2qPJ;;A4D7qPE;EACE,sBAAA;EACA,iFAAA;A5DgrPJ;;A4DlrPE;EACE,sBAAA;EACA,8EAAA;A5DqrPJ;;A4DvrPE;EACE,sBAAA;EACA,iFAAA;A5D0rPJ;;A4D5rPE;EACE,sBAAA;EACA,gFAAA;A5D+rPJ;;A4DjsPE;EACE,sBAAA;EACA,+EAAA;A5DosPJ;;A4DtsPE;EACE,sBAAA;EACA,8EAAA;A5DysPJ;;A4D3sPE;EACE,sBAAA;EACA,kFAAA;A5D8sPJ;;A4DhtPE;EACE,sBAAA;EACA,kFAAA;A5DmtPJ;;A4DrtPE;EACE,sBAAA;EACA,kFAAA;A5DwtPJ;;A4D1tPE;EACE,sBAAA;EACA,kFAAA;A5D6tPJ;;A4D/tPE;EACE,sBAAA;EACA,kFAAA;A5DkuPJ;;A4DpuPE;EACE,sBAAA;EACA,kFAAA;A5DuuPJ;;A4DzuPE;EACE,sBAAA;EACA,kFAAA;A5D4uPJ;;A4D9uPE;EACE,sBAAA;EACA,kFAAA;A5DivPJ;;A4DnvPE;EACE,sBAAA;EACA,kFAAA;A5DsvPJ;;A4DxvPE;EACE,sBAAA;EACA,qFAAA;A5D2vPJ;;A4D7vPE;EACE,sBAAA;EACA,qFAAA;A5DgwPJ;;A4DlwPE;EACE,sBAAA;EACA,qFAAA;A5DqwPJ;;A4DvwPE;EACE,sBAAA;EACA,qFAAA;A5D0wPJ;;A4D5wPE;EACE,sBAAA;EACA,qFAAA;A5D+wPJ;;A4DjxPE;EACE,sBAAA;EACA,qFAAA;A5DoxPJ;;A4DtxPE;EACE,sBAAA;EACA,qFAAA;A5DyxPJ;;A4D3xPE;EACE,sBAAA;EACA,qFAAA;A5D8xPJ;;A4DhyPE;EACE,sBAAA;EACA,qFAAA;A5DmyPJ;;A6DryPE;EACE,wEAAA;EACA,kGAAA;A7DwyPJ;A6DryPM;EAGE,8DAAA;EACA,wFAAA;A7DqyPR;;A6D9yPE;EACE,0EAAA;EACA,oGAAA;A7DizPJ;A6D9yPM;EAGE,gEAAA;EACA,0FAAA;A7D8yPR;;A6DvzPE;EACE,wEAAA;EACA,kGAAA;A7D0zPJ;A6DvzPM;EAGE,8DAAA;EACA,wFAAA;A7DuzPR;;A6Dh0PE;EACE,qEAAA;EACA,+FAAA;A7Dm0PJ;A6Dh0PM;EAGE,+DAAA;EACA,yFAAA;A7Dg0PR;;A6Dz0PE;EACE,wEAAA;EACA,kGAAA;A7D40PJ;A6Dz0PM;EAGE,+DAAA;EACA,yFAAA;A7Dy0PR;;A6Dl1PE;EACE,uEAAA;EACA,iGAAA;A7Dq1PJ;A6Dl1PM;EAGE,8DAAA;EACA,wFAAA;A7Dk1PR;;A6D31PE;EACE,sEAAA;EACA,gGAAA;A7D81PJ;A6D31PM;EAGE,gEAAA;EACA,0FAAA;A7D21PR;;A6Dp2PE;EACE,qEAAA;EACA,+FAAA;A7Du2PJ;A6Dp2PM;EAGE,6DAAA;EACA,uFAAA;A7Do2PR;;A6D72PE;EACE,yEAAA;EACA,mGAAA;A7Dg3PJ;A6D72PM;EAGE,gEAAA;EACA,0FAAA;A7D62PR;;A6Dt3PE;EACE,yEAAA;EACA,mGAAA;A7Dy3PJ;A6Dt3PM;EAGE,gEAAA;EACA,0FAAA;A7Ds3PR;;A6D/3PE;EACE,yEAAA;EACA,mGAAA;A7Dk4PJ;A6D/3PM;EAGE,gEAAA;EACA,0FAAA;A7D+3PR;;A6Dx4PE;EACE,yEAAA;EACA,mGAAA;A7D24PJ;A6Dx4PM;EAGE,gEAAA;EACA,0FAAA;A7Dw4PR;;A6Dj5PE;EACE,yEAAA;EACA,mGAAA;A7Do5PJ;A6Dj5PM;EAGE,gEAAA;EACA,0FAAA;A7Di5PR;;A6D15PE;EACE,yEAAA;EACA,mGAAA;A7D65PJ;A6D15PM;EAGE,8DAAA;EACA,wFAAA;A7D05PR;;A6Dn6PE;EACE,yEAAA;EACA,mGAAA;A7Ds6PJ;A6Dn6PM;EAGE,6DAAA;EACA,uFAAA;A7Dm6PR;;A6D56PE;EACE,yEAAA;EACA,mGAAA;A7D+6PJ;A6D56PM;EAGE,6DAAA;EACA,uFAAA;A7D46PR;;A6Dr7PE;EACE,yEAAA;EACA,mGAAA;A7Dw7PJ;A6Dr7PM;EAGE,6DAAA;EACA,uFAAA;A7Dq7PR;;A6D97PE;EACE,4EAAA;EACA,sGAAA;A7Di8PJ;A6D97PM;EAGE,gEAAA;EACA,0FAAA;A7D87PR;;A6Dv8PE;EACE,4EAAA;EACA,sGAAA;A7D08PJ;A6Dv8PM;EAGE,gEAAA;EACA,0FAAA;A7Du8PR;;A6Dh9PE;EACE,4EAAA;EACA,sGAAA;A7Dm9PJ;A6Dh9PM;EAGE,+DAAA;EACA,yFAAA;A7Dg9PR;;A6Dz9PE;EACE,4EAAA;EACA,sGAAA;A7D49PJ;A6Dz9PM;EAGE,+DAAA;EACA,yFAAA;A7Dy9PR;;A6Dl+PE;EACE,4EAAA;EACA,sGAAA;A7Dq+PJ;A6Dl+PM;EAGE,8DAAA;EACA,wFAAA;A7Dk+PR;;A6D3+PE;EACE,4EAAA;EACA,sGAAA;A7D8+PJ;A6D3+PM;EAGE,6DAAA;EACA,uFAAA;A7D2+PR;;A6Dp/PE;EACE,4EAAA;EACA,sGAAA;A7Du/PJ;A6Dp/PM;EAGE,6DAAA;EACA,uFAAA;A7Do/PR;;A6D7/PE;EACE,4EAAA;EACA,sGAAA;A7DggQJ;A6D7/PM;EAGE,6DAAA;EACA,uFAAA;A7D6/PR;;A6DtgQE;EACE,4EAAA;EACA,sGAAA;A7DygQJ;A6DtgQM;EAGE,4DAAA;EACA,sFAAA;A7DsgQR;;A6D//PA;EACE,+EAAA;EACA,yGAAA;A7DkgQF;A6D//PI;EAEE,kFAAA;EACA,4GAAA;A7DggQN;;A8D1hQA;EACE,UAAA;EAEA,kJAAA;A9D4hQF;;A+D/hQA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;A/DkiQF;A+DhiQE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A/DkiQJ;AuB3hQM;EwCZJ;IxCaM,gBAAA;EvB8hQN;AACF;;A+DhiQI;EACE,mEAAA;A/DmiQN;;AgEtjQA;EACE,kBAAA;EACA,WAAA;AhEyjQF;AgEvjQE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AhEyjQJ;AgEtjQE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AhEwjQJ;;AgEnjQE;EACE,uBAAA;AhEsjQJ;;AgEvjQE;EACE,sBAAA;AhE0jQJ;;AgE3jQE;EACE,yBAAA;AhE8jQJ;;AgE/jQE;EACE,iCAAA;AhEkkQJ;;AiEvlQA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;APm/NpC;;AiEvlQA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;AP2/NpC;;AiEllQI;EACE,gBAAA;EACA,MAAA;EACA,a1DmlC8B;APkgOpC;;AiEllQI;EACE,gBAAA;EACA,SAAA;EACA,a1D6kC8B;APwgOpC;;AetjQI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EP+gOlC;EiE/lQE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EPohOlC;AACF;AenkQI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EP2hOlC;EiE3mQE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EPgiOlC;AACF;Ae/kQI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EPuiOlC;EiEvnQE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EP4iOlC;AACF;Ae3lQI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EPmjOlC;EiEnoQE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EPwjOlC;AACF;AevmQI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EP+jOlC;EiE/oQE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EPokOlC;AACF;AkEjrQA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AlEmrQF;;AkEhrQA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AlEmrQF;;AmE3rQA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;ApE4rQF;AoEzrQE;;EACE,6BAAA;ApE4rQJ;AoExrQE;;EACE,2BAAA;ApE2rQJ;;AqE9sQE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;ArEitQJ;;AsEztQA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AvE6tQF;;AwEnuQA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;AP2iP9B;;AyE1qQQ;EAOI,mCAAA;AzEuqQZ;;AyE9qQQ;EAOI,8BAAA;AzE2qQZ;;AyElrQQ;EAOI,iCAAA;AzE+qQZ;;AyEtrQQ;EAOI,iCAAA;AzEmrQZ;;AyE1rQQ;EAOI,sCAAA;AzEurQZ;;AyE9rQQ;EAOI,mCAAA;AzE2rQZ;;AyElsQQ;EAOI,sBAAA;AzE+rQZ;;AyEtsQQ;EAOI,uBAAA;AzEmsQZ;;AyE1sQQ;EAOI,sBAAA;AzEusQZ;;AyE9sQQ;EAOI,8BAAA;AzE2sQZ;;AyEltQQ;EAOI,4BAAA;AzE+sQZ;;AyEttQQ;EAOI,2BAAA;AzEmtQZ;;AyE1tQQ;EAOI,iCAAA;AzEutQZ;;AyE9tQQ;EAOI,2BAAA;AzE2tQZ;;AyEluQQ;EAOI,qBAAA;AzE+tQZ;;AyEtuQQ;EAOI,wBAAA;AzEmuQZ;;AyE1uQQ;EAOI,uBAAA;AzEuuQZ;;AyE9uQQ;EAOI,wBAAA;AzE2uQZ;;AyElvQQ;EAOI,qBAAA;AzE+uQZ;;AyEtvQQ;EAOI,yBAAA;AzEmvQZ;;AyE1vQQ;EAOI,2BAAA;AzEuvQZ;;AyE9vQQ;EAOI,4BAAA;AzE2vQZ;;AyElwQQ;EAOI,2BAAA;AzE+vQZ;;AyEtwQQ;EAOI,2BAAA;AzEmwQZ;;AyE1wQQ;EAOI,6BAAA;AzEuwQZ;;AyE9wQQ;EAOI,8BAAA;AzE2wQZ;;AyElxQQ;EAOI,6BAAA;AzE+wQZ;;AyEtxQQ;EAOI,2BAAA;AzEmxQZ;;AyE1xQQ;EAOI,6BAAA;AzEuxQZ;;AyE9xQQ;EAOI,8BAAA;AzE2xQZ;;AyElyQQ;EAOI,6BAAA;AzE+xQZ;;AyEtyQQ;EAOI,0BAAA;AzEmyQZ;;AyE1yQQ;EAOI,gCAAA;AzEuyQZ;;AyE9yQQ;EAOI,yBAAA;AzE2yQZ;;AyElzQQ;EAOI,wBAAA;AzE+yQZ;;AyEtzQQ;EAOI,+BAAA;AzEmzQZ;;AyE1zQQ;EAOI,yBAAA;AzEuzQZ;;AyE9zQQ;EAOI,6BAAA;AzE2zQZ;;AyEl0QQ;EAOI,8BAAA;AzE+zQZ;;AyEt0QQ;EAOI,wBAAA;AzEm0QZ;;AyE10QQ;EAOI,+BAAA;AzEu0QZ;;AyE90QQ;EAOI,wBAAA;AzE20QZ;;AyEl1QQ;EAOI,2CAAA;AzE+0QZ;;AyEt1QQ;EAOI,8CAAA;AzEm1QZ;;AyE11QQ;EAOI,8CAAA;AzEu1QZ;;AyE91QQ;EAOI,2BAAA;AzE21QZ;;AyE52QQ;EACE,gFAAA;AzE+2QV;;AyEh3QQ;EACE,kFAAA;AzEm3QV;;AyEp3QQ;EACE,gFAAA;AzEu3QV;;AyEx3QQ;EACE,6EAAA;AzE23QV;;AyE53QQ;EACE,gFAAA;AzE+3QV;;AyEh4QQ;EACE,+EAAA;AzEm4QV;;AyEp4QQ;EACE,8EAAA;AzEu4QV;;AyEx4QQ;EACE,6EAAA;AzE24QV;;AyE54QQ;EACE,iFAAA;AzE+4QV;;AyEh5QQ;EACE,iFAAA;AzEm5QV;;AyEp5QQ;EACE,iFAAA;AzEu5QV;;AyEx5QQ;EACE,iFAAA;AzE25QV;;AyE55QQ;EACE,iFAAA;AzE+5QV;;AyEh6QQ;EACE,iFAAA;AzEm6QV;;AyEp6QQ;EACE,iFAAA;AzEu6QV;;AyEx6QQ;EACE,iFAAA;AzE26QV;;AyE56QQ;EACE,iFAAA;AzE+6QV;;AyEh7QQ;EACE,oFAAA;AzEm7QV;;AyEp7QQ;EACE,oFAAA;AzEu7QV;;AyEx7QQ;EACE,oFAAA;AzE27QV;;AyE57QQ;EACE,oFAAA;AzE+7QV;;AyEh8QQ;EACE,oFAAA;AzEm8QV;;AyEp8QQ;EACE,oFAAA;AzEu8QV;;AyEx8QQ;EACE,oFAAA;AzE28QV;;AyE58QQ;EACE,oFAAA;AzE+8QV;;AyEh9QQ;EACE,oFAAA;AzEm9QV;;AyE18QQ;EAOI,2BAAA;AzEu8QZ;;AyE98QQ;EAOI,6BAAA;AzE28QZ;;AyEl9QQ;EAOI,6BAAA;AzE+8QZ;;AyEt9QQ;EAOI,0BAAA;AzEm9QZ;;AyE19QQ;EAOI,2BAAA;AzEu9QZ;;AyE99QQ;EAOI,iBAAA;AzE29QZ;;AyEl+QQ;EAOI,mBAAA;AzE+9QZ;;AyEt+QQ;EAOI,oBAAA;AzEm+QZ;;AyE1+QQ;EAOI,oBAAA;AzEu+QZ;;AyE9+QQ;EAOI,sBAAA;AzE2+QZ;;AyEl/QQ;EAOI,uBAAA;AzE++QZ;;AyEt/QQ;EAOI,kBAAA;AzEm/QZ;;AyE1/QQ;EAOI,oBAAA;AzEu/QZ;;AyE9/QQ;EAOI,qBAAA;AzE2/QZ;;AyElgRQ;EAOI,mBAAA;AzE+/QZ;;AyEtgRQ;EAOI,qBAAA;AzEmgRZ;;AyE1gRQ;EAOI,sBAAA;AzEugRZ;;AyE9gRQ;EAOI,2CAAA;AzE2gRZ;;AyElhRQ;EAOI,sCAAA;AzE+gRZ;;AyEthRQ;EAOI,sCAAA;AzEmhRZ;;AyE1hRQ;EAOI,uFAAA;AzEuhRZ;;AyE9hRQ;EAOI,oBAAA;AzE2hRZ;;AyEliRQ;EAOI,2FAAA;AzE+hRZ;;AyEtiRQ;EAOI,wBAAA;AzEmiRZ;;AyE1iRQ;EAOI,6FAAA;AzEuiRZ;;AyE9iRQ;EAOI,0BAAA;AzE2iRZ;;AyEljRQ;EAOI,8FAAA;AzE+iRZ;;AyEtjRQ;EAOI,2BAAA;AzEmjRZ;;AyE1jRQ;EAOI,4FAAA;AzEujRZ;;AyE9jRQ;EAOI,yBAAA;AzE2jRZ;;AyElkRQ;EAIQ,sBAAA;EAGJ,8EAAA;AzEgkRZ;;AyEvkRQ;EAIQ,sBAAA;EAGJ,gFAAA;AzEqkRZ;;AyE5kRQ;EAIQ,sBAAA;EAGJ,8EAAA;AzE0kRZ;;AyEjlRQ;EAIQ,sBAAA;EAGJ,2EAAA;AzE+kRZ;;AyEtlRQ;EAIQ,sBAAA;EAGJ,8EAAA;AzEolRZ;;AyE3lRQ;EAIQ,sBAAA;EAGJ,6EAAA;AzEylRZ;;AyEhmRQ;EAIQ,sBAAA;EAGJ,4EAAA;AzE8lRZ;;AyErmRQ;EAIQ,sBAAA;EAGJ,2EAAA;AzEmmRZ;;AyE1mRQ;EAIQ,sBAAA;EAGJ,+EAAA;AzEwmRZ;;AyE/mRQ;EAIQ,sBAAA;EAGJ,+EAAA;AzE6mRZ;;AyEpnRQ;EAIQ,sBAAA;EAGJ,+EAAA;AzEknRZ;;AyEznRQ;EAIQ,sBAAA;EAGJ,+EAAA;AzEunRZ;;AyE9nRQ;EAIQ,sBAAA;EAGJ,+EAAA;AzE4nRZ;;AyEnoRQ;EAIQ,sBAAA;EAGJ,+EAAA;AzEioRZ;;AyExoRQ;EAIQ,sBAAA;EAGJ,+EAAA;AzEsoRZ;;AyE7oRQ;EAIQ,sBAAA;EAGJ,+EAAA;AzE2oRZ;;AyElpRQ;EAIQ,sBAAA;EAGJ,+EAAA;AzEgpRZ;;AyEvpRQ;EAIQ,sBAAA;EAGJ,kFAAA;AzEqpRZ;;AyE5pRQ;EAIQ,sBAAA;EAGJ,kFAAA;AzE0pRZ;;AyEjqRQ;EAIQ,sBAAA;EAGJ,kFAAA;AzE+pRZ;;AyEtqRQ;EAIQ,sBAAA;EAGJ,kFAAA;AzEoqRZ;;AyE3qRQ;EAIQ,sBAAA;EAGJ,kFAAA;AzEyqRZ;;AyEhrRQ;EAIQ,sBAAA;EAGJ,kFAAA;AzE8qRZ;;AyErrRQ;EAIQ,sBAAA;EAGJ,kFAAA;AzEmrRZ;;AyE1rRQ;EAIQ,sBAAA;EAGJ,kFAAA;AzEwrRZ;;AyE/rRQ;EAIQ,sBAAA;EAGJ,kFAAA;AzE6rRZ;;AyEpsRQ;EAIQ,sBAAA;EAGJ,4EAAA;AzEksRZ;;AyEzsRQ;EAIQ,sBAAA;EAGJ,4EAAA;AzEusRZ;;AyE9sRQ;EAOI,wDAAA;AzE2sRZ;;AyEltRQ;EAOI,0DAAA;AzE+sRZ;;AyEttRQ;EAOI,wDAAA;AzEmtRZ;;AyE1tRQ;EAOI,qDAAA;AzEutRZ;;AyE9tRQ;EAOI,wDAAA;AzE2tRZ;;AyEluRQ;EAOI,uDAAA;AzE+tRZ;;AyEtuRQ;EAOI,sDAAA;AzEmuRZ;;AyE1uRQ;EAOI,qDAAA;AzEuuRZ;;AyE9uRQ;EAOI,4BAAA;AzE2uRZ;;AyElvRQ;EAOI,4BAAA;AzE+uRZ;;AyEtvRQ;EAOI,4BAAA;AzEmvRZ;;AyE1vRQ;EAOI,4BAAA;AzEuvRZ;;AyE9vRQ;EAOI,4BAAA;AzE2vRZ;;AyE5wRQ;EACE,wBAAA;AzE+wRV;;AyEhxRQ;EACE,yBAAA;AzEmxRV;;AyEpxRQ;EACE,wBAAA;AzEuxRV;;AyExxRQ;EACE,yBAAA;AzE2xRV;;AyE5xRQ;EACE,sBAAA;AzE+xRV;;AyEtxRQ;EAOI,qBAAA;AzEmxRZ;;AyE1xRQ;EAOI,qBAAA;AzEuxRZ;;AyE9xRQ;EAOI,qBAAA;AzE2xRZ;;AyElyRQ;EAOI,sBAAA;AzE+xRZ;;AyEtyRQ;EAOI,sBAAA;AzEmyRZ;;AyE1yRQ;EAOI,0BAAA;AzEuyRZ;;AyE9yRQ;EAOI,uBAAA;AzE2yRZ;;AyElzRQ;EAOI,2BAAA;AzE+yRZ;;AyEtzRQ;EAOI,sBAAA;AzEmzRZ;;AyE1zRQ;EAOI,sBAAA;AzEuzRZ;;AyE9zRQ;EAOI,sBAAA;AzE2zRZ;;AyEl0RQ;EAOI,uBAAA;AzE+zRZ;;AyEt0RQ;EAOI,uBAAA;AzEm0RZ;;AyE10RQ;EAOI,2BAAA;AzEu0RZ;;AyE90RQ;EAOI,wBAAA;AzE20RZ;;AyEl1RQ;EAOI,4BAAA;AzE+0RZ;;AyEt1RQ;EAOI,yBAAA;AzEm1RZ;;AyE11RQ;EAOI,8BAAA;AzEu1RZ;;AyE91RQ;EAOI,iCAAA;AzE21RZ;;AyEl2RQ;EAOI,sCAAA;AzE+1RZ;;AyEt2RQ;EAOI,yCAAA;AzEm2RZ;;AyE12RQ;EAOI,uBAAA;AzEu2RZ;;AyE92RQ;EAOI,uBAAA;AzE22RZ;;AyEl3RQ;EAOI,yBAAA;AzE+2RZ;;AyEt3RQ;EAOI,yBAAA;AzEm3RZ;;AyE13RQ;EAOI,0BAAA;AzEu3RZ;;AyE93RQ;EAOI,4BAAA;AzE23RZ;;AyEl4RQ;EAOI,kCAAA;AzE+3RZ;;AyEt4RQ;EAOI,sCAAA;AzEm4RZ;;AyE14RQ;EAOI,oCAAA;AzEu4RZ;;AyE94RQ;EAOI,kCAAA;AzE24RZ;;AyEl5RQ;EAOI,yCAAA;AzE+4RZ;;AyEt5RQ;EAOI,wCAAA;AzEm5RZ;;AyE15RQ;EAOI,wCAAA;AzEu5RZ;;AyE95RQ;EAOI,kCAAA;AzE25RZ;;AyEl6RQ;EAOI,gCAAA;AzE+5RZ;;AyEt6RQ;EAOI,8BAAA;AzEm6RZ;;AyE16RQ;EAOI,gCAAA;AzEu6RZ;;AyE96RQ;EAOI,+BAAA;AzE26RZ;;AyEl7RQ;EAOI,oCAAA;AzE+6RZ;;AyEt7RQ;EAOI,kCAAA;AzEm7RZ;;AyE17RQ;EAOI,gCAAA;AzEu7RZ;;AyE97RQ;EAOI,uCAAA;AzE27RZ;;AyEl8RQ;EAOI,sCAAA;AzE+7RZ;;AyEt8RQ;EAOI,iCAAA;AzEm8RZ;;AyE18RQ;EAOI,2BAAA;AzEu8RZ;;AyE98RQ;EAOI,iCAAA;AzE28RZ;;AyEl9RQ;EAOI,+BAAA;AzE+8RZ;;AyEt9RQ;EAOI,6BAAA;AzEm9RZ;;AyE19RQ;EAOI,+BAAA;AzEu9RZ;;AyE99RQ;EAOI,8BAAA;AzE29RZ;;AyEl+RQ;EAOI,oBAAA;AzE+9RZ;;AyEt+RQ;EAOI,mBAAA;AzEm+RZ;;AyE1+RQ;EAOI,mBAAA;AzEu+RZ;;AyE9+RQ;EAOI,mBAAA;AzE2+RZ;;AyEl/RQ;EAOI,mBAAA;AzE++RZ;;AyEt/RQ;EAOI,mBAAA;AzEm/RZ;;AyE1/RQ;EAOI,mBAAA;AzEu/RZ;;AyE9/RQ;EAOI,mBAAA;AzE2/RZ;;AyElgSQ;EAOI,oBAAA;AzE+/RZ;;AyEtgSQ;EAOI,0BAAA;AzEmgSZ;;AyE1gSQ;EAOI,yBAAA;AzEugSZ;;AyE9gSQ;EAOI,uBAAA;AzE2gSZ;;AyElhSQ;EAOI,yBAAA;AzE+gSZ;;AyEthSQ;EAOI,uBAAA;AzEmhSZ;;AyE1hSQ;EAOI,uBAAA;AzEuhSZ;;AyE9hSQ;EAOI,0BAAA;EAAA,yBAAA;AzE4hSZ;;AyEniSQ;EAOI,gCAAA;EAAA,+BAAA;AzEiiSZ;;AyExiSQ;EAOI,+BAAA;EAAA,8BAAA;AzEsiSZ;;AyE7iSQ;EAOI,6BAAA;EAAA,4BAAA;AzE2iSZ;;AyEljSQ;EAOI,+BAAA;EAAA,8BAAA;AzEgjSZ;;AyEvjSQ;EAOI,6BAAA;EAAA,4BAAA;AzEqjSZ;;AyE5jSQ;EAOI,6BAAA;EAAA,4BAAA;AzE0jSZ;;AyEjkSQ;EAOI,wBAAA;EAAA,2BAAA;AzE+jSZ;;AyEtkSQ;EAOI,8BAAA;EAAA,iCAAA;AzEokSZ;;AyE3kSQ;EAOI,6BAAA;EAAA,gCAAA;AzEykSZ;;AyEhlSQ;EAOI,2BAAA;EAAA,8BAAA;AzE8kSZ;;AyErlSQ;EAOI,6BAAA;EAAA,gCAAA;AzEmlSZ;;AyE1lSQ;EAOI,2BAAA;EAAA,8BAAA;AzEwlSZ;;AyE/lSQ;EAOI,2BAAA;EAAA,8BAAA;AzE6lSZ;;AyEpmSQ;EAOI,wBAAA;AzEimSZ;;AyExmSQ;EAOI,8BAAA;AzEqmSZ;;AyE5mSQ;EAOI,6BAAA;AzEymSZ;;AyEhnSQ;EAOI,2BAAA;AzE6mSZ;;AyEpnSQ;EAOI,6BAAA;AzEinSZ;;AyExnSQ;EAOI,2BAAA;AzEqnSZ;;AyE5nSQ;EAOI,2BAAA;AzEynSZ;;AyEhoSQ;EAOI,0BAAA;AzE6nSZ;;AyEpoSQ;EAOI,gCAAA;AzEioSZ;;AyExoSQ;EAOI,+BAAA;AzEqoSZ;;AyE5oSQ;EAOI,6BAAA;AzEyoSZ;;AyEhpSQ;EAOI,+BAAA;AzE6oSZ;;AyEppSQ;EAOI,6BAAA;AzEipSZ;;AyExpSQ;EAOI,6BAAA;AzEqpSZ;;AyE5pSQ;EAOI,2BAAA;AzEypSZ;;AyEhqSQ;EAOI,iCAAA;AzE6pSZ;;AyEpqSQ;EAOI,gCAAA;AzEiqSZ;;AyExqSQ;EAOI,8BAAA;AzEqqSZ;;AyE5qSQ;EAOI,gCAAA;AzEyqSZ;;AyEhrSQ;EAOI,8BAAA;AzE6qSZ;;AyEprSQ;EAOI,8BAAA;AzEirSZ;;AyExrSQ;EAOI,yBAAA;AzEqrSZ;;AyE5rSQ;EAOI,+BAAA;AzEyrSZ;;AyEhsSQ;EAOI,8BAAA;AzE6rSZ;;AyEpsSQ;EAOI,4BAAA;AzEisSZ;;AyExsSQ;EAOI,8BAAA;AzEqsSZ;;AyE5sSQ;EAOI,4BAAA;AzEysSZ;;AyEhtSQ;EAOI,4BAAA;AzE6sSZ;;AyEptSQ;EAOI,2BAAA;AzEitSZ;;AyExtSQ;EAOI,0BAAA;AzEqtSZ;;AyE5tSQ;EAOI,wBAAA;AzEytSZ;;AyEhuSQ;EAOI,0BAAA;AzE6tSZ;;AyEpuSQ;EAOI,wBAAA;AzEiuSZ;;AyExuSQ;EAOI,iCAAA;EAAA,gCAAA;AzEsuSZ;;AyE7uSQ;EAOI,gCAAA;EAAA,+BAAA;AzE2uSZ;;AyElvSQ;EAOI,8BAAA;EAAA,6BAAA;AzEgvSZ;;AyEvvSQ;EAOI,gCAAA;EAAA,+BAAA;AzEqvSZ;;AyE5vSQ;EAOI,8BAAA;EAAA,6BAAA;AzE0vSZ;;AyEjwSQ;EAOI,+BAAA;EAAA,kCAAA;AzE+vSZ;;AyEtwSQ;EAOI,8BAAA;EAAA,iCAAA;AzEowSZ;;AyE3wSQ;EAOI,4BAAA;EAAA,+BAAA;AzEywSZ;;AyEhxSQ;EAOI,8BAAA;EAAA,iCAAA;AzE8wSZ;;AyErxSQ;EAOI,4BAAA;EAAA,+BAAA;AzEmxSZ;;AyE1xSQ;EAOI,+BAAA;AzEuxSZ;;AyE9xSQ;EAOI,8BAAA;AzE2xSZ;;AyElySQ;EAOI,4BAAA;AzE+xSZ;;AyEtySQ;EAOI,8BAAA;AzEmySZ;;AyE1ySQ;EAOI,4BAAA;AzEuySZ;;AyE9ySQ;EAOI,iCAAA;AzE2ySZ;;AyElzSQ;EAOI,gCAAA;AzE+ySZ;;AyEtzSQ;EAOI,8BAAA;AzEmzSZ;;AyE1zSQ;EAOI,gCAAA;AzEuzSZ;;AyE9zSQ;EAOI,8BAAA;AzE2zSZ;;AyEl0SQ;EAOI,kCAAA;AzE+zSZ;;AyEt0SQ;EAOI,iCAAA;AzEm0SZ;;AyE10SQ;EAOI,+BAAA;AzEu0SZ;;AyE90SQ;EAOI,iCAAA;AzE20SZ;;AyEl1SQ;EAOI,+BAAA;AzE+0SZ;;AyEt1SQ;EAOI,gCAAA;AzEm1SZ;;AyE11SQ;EAOI,+BAAA;AzEu1SZ;;AyE91SQ;EAOI,6BAAA;AzE21SZ;;AyEl2SQ;EAOI,+BAAA;AzE+1SZ;;AyEt2SQ;EAOI,6BAAA;AzEm2SZ;;AyE12SQ;EAOI,qBAAA;AzEu2SZ;;AyE92SQ;EAOI,2BAAA;AzE22SZ;;AyEl3SQ;EAOI,0BAAA;AzE+2SZ;;AyEt3SQ;EAOI,wBAAA;AzEm3SZ;;AyE13SQ;EAOI,0BAAA;AzEu3SZ;;AyE93SQ;EAOI,wBAAA;AzE23SZ;;AyEl4SQ;EAOI,2BAAA;EAAA,0BAAA;AzEg4SZ;;AyEv4SQ;EAOI,iCAAA;EAAA,gCAAA;AzEq4SZ;;AyE54SQ;EAOI,gCAAA;EAAA,+BAAA;AzE04SZ;;AyEj5SQ;EAOI,8BAAA;EAAA,6BAAA;AzE+4SZ;;AyEt5SQ;EAOI,gCAAA;EAAA,+BAAA;AzEo5SZ;;AyE35SQ;EAOI,8BAAA;EAAA,6BAAA;AzEy5SZ;;AyEh6SQ;EAOI,yBAAA;EAAA,4BAAA;AzE85SZ;;AyEr6SQ;EAOI,+BAAA;EAAA,kCAAA;AzEm6SZ;;AyE16SQ;EAOI,8BAAA;EAAA,iCAAA;AzEw6SZ;;AyE/6SQ;EAOI,4BAAA;EAAA,+BAAA;AzE66SZ;;AyEp7SQ;EAOI,8BAAA;EAAA,iCAAA;AzEk7SZ;;AyEz7SQ;EAOI,4BAAA;EAAA,+BAAA;AzEu7SZ;;AyE97SQ;EAOI,yBAAA;AzE27SZ;;AyEl8SQ;EAOI,+BAAA;AzE+7SZ;;AyEt8SQ;EAOI,8BAAA;AzEm8SZ;;AyE18SQ;EAOI,4BAAA;AzEu8SZ;;AyE98SQ;EAOI,8BAAA;AzE28SZ;;AyEl9SQ;EAOI,4BAAA;AzE+8SZ;;AyEt9SQ;EAOI,2BAAA;AzEm9SZ;;AyE19SQ;EAOI,iCAAA;AzEu9SZ;;AyE99SQ;EAOI,gCAAA;AzE29SZ;;AyEl+SQ;EAOI,8BAAA;AzE+9SZ;;AyEt+SQ;EAOI,gCAAA;AzEm+SZ;;AyE1+SQ;EAOI,8BAAA;AzEu+SZ;;AyE9+SQ;EAOI,4BAAA;AzE2+SZ;;AyEl/SQ;EAOI,kCAAA;AzE++SZ;;AyEt/SQ;EAOI,iCAAA;AzEm/SZ;;AyE1/SQ;EAOI,+BAAA;AzEu/SZ;;AyE9/SQ;EAOI,iCAAA;AzE2/SZ;;AyElgTQ;EAOI,+BAAA;AzE+/SZ;;AyEtgTQ;EAOI,0BAAA;AzEmgTZ;;AyE1gTQ;EAOI,gCAAA;AzEugTZ;;AyE9gTQ;EAOI,+BAAA;AzE2gTZ;;AyElhTQ;EAOI,6BAAA;AzE+gTZ;;AyEthTQ;EAOI,+BAAA;AzEmhTZ;;AyE1hTQ;EAOI,6BAAA;AzEuhTZ;;AyE9hTQ;EAOI,iBAAA;AzE2hTZ;;AyEliTQ;EAOI,uBAAA;AzE+hTZ;;AyEtiTQ;EAOI,sBAAA;AzEmiTZ;;AyE1iTQ;EAOI,oBAAA;AzEuiTZ;;AyE9iTQ;EAOI,sBAAA;AzE2iTZ;;AyEljTQ;EAOI,oBAAA;AzE+iTZ;;AyEtjTQ;EAOI,qBAAA;AzEmjTZ;;AyE1jTQ;EAOI,2BAAA;AzEujTZ;;AyE9jTQ;EAOI,0BAAA;AzE2jTZ;;AyElkTQ;EAOI,wBAAA;AzE+jTZ;;AyEtkTQ;EAOI,0BAAA;AzEmkTZ;;AyE1kTQ;EAOI,wBAAA;AzEukTZ;;AyE9kTQ;EAOI,wBAAA;AzE2kTZ;;AyEllTQ;EAOI,8BAAA;AzE+kTZ;;AyEtlTQ;EAOI,6BAAA;AzEmlTZ;;AyE1lTQ;EAOI,2BAAA;AzEulTZ;;AyE9lTQ;EAOI,6BAAA;AzE2lTZ;;AyElmTQ;EAOI,2BAAA;AzE+lTZ;;AyEtmTQ;EAOI,gDAAA;AzEmmTZ;;AyE1mTQ;EAOI,6CAAA;AzEumTZ;;AyE9mTQ;EAOI,8CAAA;AzE2mTZ;;AyElnTQ;EAOI,8CAAA;AzE+mTZ;;AyEtnTQ;EAOI,8CAAA;AzEmnTZ;;AyE1nTQ;EAOI,4BAAA;AzEunTZ;;AyE9nTQ;EAOI,6BAAA;AzE2nTZ;;AyEloTQ;EAOI,6BAAA;AzE+nTZ;;AyEtoTQ;EAOI,6BAAA;AzEmoTZ;;AyE1oTQ;EAOI,2BAAA;AzEuoTZ;;AyE9oTQ;EAOI,2BAAA;AzE2oTZ;;AyElpTQ;EAOI,2BAAA;AzE+oTZ;;AyEtpTQ;EAOI,2BAAA;AzEmpTZ;;AyE1pTQ;EAOI,2BAAA;AzEupTZ;;AyE9pTQ;EAOI,2BAAA;AzE2pTZ;;AyElqTQ;EAOI,2BAAA;AzE+pTZ;;AyEtqTQ;EAOI,yBAAA;AzEmqTZ;;AyE1qTQ;EAOI,4BAAA;AzEuqTZ;;AyE9qTQ;EAOI,2BAAA;AzE2qTZ;;AyElrTQ;EAOI,yBAAA;AzE+qTZ;;AyEtrTQ;EAOI,2BAAA;AzEmrTZ;;AyE1rTQ;EAOI,4BAAA;AzEurTZ;;AyE9rTQ;EAOI,6BAAA;AzE2rTZ;;AyElsTQ;EAOI,gCAAA;AzE+rTZ;;AyEtsTQ;EAOI,qCAAA;AzEmsTZ;;AyE1sTQ;EAOI,wCAAA;AzEusTZ;;AyE9sTQ;EAOI,oCAAA;AzE2sTZ;;AyEltTQ;EAOI,oCAAA;AzE+sTZ;;AyEttTQ;EAOI,qCAAA;AzEmtTZ;;AyE1tTQ;EAOI,8BAAA;AzEutTZ;;AyE9tTQ;EAOI,8BAAA;AzE2tTZ;;AyEhvTQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AzEiuTZ;;AyE9sTQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AzEuuTZ;;AyE9uTQ;EAIQ,oBAAA;EAGJ,uEAAA;AzE4uTZ;;AyEnvTQ;EAIQ,oBAAA;EAGJ,qEAAA;AzEivTZ;;AyExvTQ;EAIQ,oBAAA;EAGJ,kEAAA;AzEsvTZ;;AyE7vTQ;EAIQ,oBAAA;EAGJ,qEAAA;AzE2vTZ;;AyElwTQ;EAIQ,oBAAA;EAGJ,oEAAA;AzEgwTZ;;AyEvwTQ;EAIQ,oBAAA;EAGJ,mEAAA;AzEqwTZ;;AyE5wTQ;EAIQ,oBAAA;EAGJ,kEAAA;AzE0wTZ;;AyEjxTQ;EAIQ,oBAAA;EAGJ,sEAAA;AzE+wTZ;;AyEtxTQ;EAIQ,oBAAA;EAGJ,sEAAA;AzEoxTZ;;AyE3xTQ;EAIQ,oBAAA;EAGJ,sEAAA;AzEyxTZ;;AyEhyTQ;EAIQ,oBAAA;EAGJ,sEAAA;AzE8xTZ;;AyEryTQ;EAIQ,oBAAA;EAGJ,sEAAA;AzEmyTZ;;AyE1yTQ;EAIQ,oBAAA;EAGJ,sEAAA;AzEwyTZ;;AyE/yTQ;EAIQ,oBAAA;EAGJ,sEAAA;AzE6yTZ;;AyEpzTQ;EAIQ,oBAAA;EAGJ,sEAAA;AzEkzTZ;;AyEzzTQ;EAIQ,oBAAA;EAGJ,sEAAA;AzEuzTZ;;AyE9zTQ;EAIQ,oBAAA;EAGJ,yEAAA;AzE4zTZ;;AyEn0TQ;EAIQ,oBAAA;EAGJ,yEAAA;AzEi0TZ;;AyEx0TQ;EAIQ,oBAAA;EAGJ,yEAAA;AzEs0TZ;;AyE70TQ;EAIQ,oBAAA;EAGJ,yEAAA;AzE20TZ;;AyEl1TQ;EAIQ,oBAAA;EAGJ,yEAAA;AzEg1TZ;;AyEv1TQ;EAIQ,oBAAA;EAGJ,yEAAA;AzEq1TZ;;AyE51TQ;EAIQ,oBAAA;EAGJ,yEAAA;AzE01TZ;;AyEj2TQ;EAIQ,oBAAA;EAGJ,yEAAA;AzE+1TZ;;AyEt2TQ;EAIQ,oBAAA;EAGJ,yEAAA;AzEo2TZ;;AyE32TQ;EAIQ,oBAAA;EAGJ,mEAAA;AzEy2TZ;;AyEh3TQ;EAIQ,oBAAA;EAGJ,mEAAA;AzE82TZ;;AyEr3TQ;EAIQ,oBAAA;EAGJ,wEAAA;AzEm3TZ;;AyE13TQ;EAIQ,oBAAA;EAGJ,2CAAA;AzEw3TZ;;AyE/3TQ;EAIQ,oBAAA;EAGJ,oCAAA;AzE63TZ;;AyEp4TQ;EAIQ,oBAAA;EAGJ,0CAAA;AzEk4TZ;;AyEz4TQ;EAIQ,oBAAA;EAGJ,2CAAA;AzEu4TZ;;AyE94TQ;EAIQ,oBAAA;EAGJ,0CAAA;AzE44TZ;;AyEn5TQ;EAIQ,oBAAA;EAGJ,0CAAA;AzEi5TZ;;AyEx5TQ;EAIQ,oBAAA;EAGJ,yBAAA;AzEs5TZ;;AyEv6TQ;EACE,uBAAA;AzE06TV;;AyE36TQ;EACE,sBAAA;AzE86TV;;AyE/6TQ;EACE,uBAAA;AzEk7TV;;AyEn7TQ;EACE,oBAAA;AzEs7TV;;AyE76TQ;EAOI,iDAAA;AzE06TZ;;AyEj7TQ;EAOI,mDAAA;AzE86TZ;;AyEr7TQ;EAOI,iDAAA;AzEk7TZ;;AyEz7TQ;EAOI,8CAAA;AzEs7TZ;;AyE77TQ;EAOI,iDAAA;AzE07TZ;;AyEj8TQ;EAOI,gDAAA;AzE87TZ;;AyEr8TQ;EAOI,+CAAA;AzEk8TZ;;AyEz8TQ;EAOI,8CAAA;AzEs8TZ;;AyEv9TQ;EACE,sBAAA;AzE09TV;;AyEt9TU;EACE,sBAAA;AzEy9TZ;;AyE/9TQ;EACE,uBAAA;AzEk+TV;;AyE99TU;EACE,uBAAA;AzEi+TZ;;AyEv+TQ;EACE,sBAAA;AzE0+TV;;AyEt+TU;EACE,sBAAA;AzEy+TZ;;AyE/+TQ;EACE,uBAAA;AzEk/TV;;AyE9+TU;EACE,uBAAA;AzEi/TZ;;AyEv/TQ;EACE,oBAAA;AzE0/TV;;AyEt/TU;EACE,oBAAA;AzEy/TZ;;AyEr/TQ;EAOI,yCAAA;AzEk/TZ;;AyE7+TU;EAOI,yCAAA;AzE0+Td;;AyE7/TQ;EAOI,wCAAA;AzE0/TZ;;AyEr/TU;EAOI,wCAAA;AzEk/Td;;AyErgUQ;EAOI,yCAAA;AzEkgUZ;;AyE7/TU;EAOI,yCAAA;AzE0/Td;;AyE7gUQ;EAIQ,8BAAA;EAGJ,+FAAA;AzE2gUZ;;AyElhUQ;EAIQ,8BAAA;EAGJ,iGAAA;AzEghUZ;;AyEvhUQ;EAIQ,8BAAA;EAGJ,+FAAA;AzEqhUZ;;AyE5hUQ;EAIQ,8BAAA;EAGJ,4FAAA;AzE0hUZ;;AyEjiUQ;EAIQ,8BAAA;EAGJ,+FAAA;AzE+hUZ;;AyEtiUQ;EAIQ,8BAAA;EAGJ,8FAAA;AzEoiUZ;;AyE3iUQ;EAIQ,8BAAA;EAGJ,6FAAA;AzEyiUZ;;AyEhjUQ;EAIQ,8BAAA;EAGJ,4FAAA;AzE8iUZ;;AyErjUQ;EAIQ,8BAAA;EAGJ,gGAAA;AzEmjUZ;;AyE1jUQ;EAIQ,8BAAA;EAGJ,gGAAA;AzEwjUZ;;AyE/jUQ;EAIQ,8BAAA;EAGJ,gGAAA;AzE6jUZ;;AyEpkUQ;EAIQ,8BAAA;EAGJ,gGAAA;AzEkkUZ;;AyEzkUQ;EAIQ,8BAAA;EAGJ,gGAAA;AzEukUZ;;AyE9kUQ;EAIQ,8BAAA;EAGJ,gGAAA;AzE4kUZ;;AyEnlUQ;EAIQ,8BAAA;EAGJ,gGAAA;AzEilUZ;;AyExlUQ;EAIQ,8BAAA;EAGJ,gGAAA;AzEslUZ;;AyE7lUQ;EAIQ,8BAAA;EAGJ,gGAAA;AzE2lUZ;;AyElmUQ;EAIQ,8BAAA;EAGJ,mGAAA;AzEgmUZ;;AyEvmUQ;EAIQ,8BAAA;EAGJ,mGAAA;AzEqmUZ;;AyE5mUQ;EAIQ,8BAAA;EAGJ,mGAAA;AzE0mUZ;;AyEjnUQ;EAIQ,8BAAA;EAGJ,mGAAA;AzE+mUZ;;AyEtnUQ;EAIQ,8BAAA;EAGJ,mGAAA;AzEonUZ;;AyE3nUQ;EAIQ,8BAAA;EAGJ,mGAAA;AzEynUZ;;AyEhoUQ;EAIQ,8BAAA;EAGJ,mGAAA;AzE8nUZ;;AyEroUQ;EAIQ,8BAAA;EAGJ,mGAAA;AzEmoUZ;;AyE1oUQ;EAIQ,8BAAA;EAGJ,mGAAA;AzEwoUZ;;AyE/oUQ;EAIQ,8BAAA;EAGJ,qGAAA;AzE6oUZ;;AyE9pUQ;EACE,8BAAA;AzEiqUV;;AyE7pUU;EACE,8BAAA;AzEgqUZ;;AyEtqUQ;EACE,gCAAA;AzEyqUV;;AyErqUU;EACE,gCAAA;AzEwqUZ;;AyE9qUQ;EACE,iCAAA;AzEirUV;;AyE7qUU;EACE,iCAAA;AzEgrUZ;;AyEtrUQ;EACE,gCAAA;AzEyrUV;;AyErrUU;EACE,gCAAA;AzEwrUZ;;AyE9rUQ;EACE,iCAAA;AzEisUV;;AyE7rUU;EACE,iCAAA;AzEgsUZ;;AyEtsUQ;EACE,8BAAA;AzEysUV;;AyErsUU;EACE,8BAAA;AzEwsUZ;;AyEpsUQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEksUZ;;AyEzsUQ;EAIQ,kBAAA;EAGJ,gFAAA;AzEusUZ;;AyE9sUQ;EAIQ,kBAAA;EAGJ,8EAAA;AzE4sUZ;;AyEntUQ;EAIQ,kBAAA;EAGJ,2EAAA;AzEitUZ;;AyExtUQ;EAIQ,kBAAA;EAGJ,8EAAA;AzEstUZ;;AyE7tUQ;EAIQ,kBAAA;EAGJ,6EAAA;AzE2tUZ;;AyEluUQ;EAIQ,kBAAA;EAGJ,4EAAA;AzEguUZ;;AyEvuUQ;EAIQ,kBAAA;EAGJ,2EAAA;AzEquUZ;;AyE5uUQ;EAIQ,kBAAA;EAGJ,+EAAA;AzE0uUZ;;AyEjvUQ;EAIQ,kBAAA;EAGJ,+EAAA;AzE+uUZ;;AyEtvUQ;EAIQ,kBAAA;EAGJ,+EAAA;AzEovUZ;;AyE3vUQ;EAIQ,kBAAA;EAGJ,+EAAA;AzEyvUZ;;AyEhwUQ;EAIQ,kBAAA;EAGJ,+EAAA;AzE8vUZ;;AyErwUQ;EAIQ,kBAAA;EAGJ,+EAAA;AzEmwUZ;;AyE1wUQ;EAIQ,kBAAA;EAGJ,+EAAA;AzEwwUZ;;AyE/wUQ;EAIQ,kBAAA;EAGJ,+EAAA;AzE6wUZ;;AyEpxUQ;EAIQ,kBAAA;EAGJ,+EAAA;AzEkxUZ;;AyEzxUQ;EAIQ,kBAAA;EAGJ,kFAAA;AzEuxUZ;;AyE9xUQ;EAIQ,kBAAA;EAGJ,kFAAA;AzE4xUZ;;AyEnyUQ;EAIQ,kBAAA;EAGJ,kFAAA;AzEiyUZ;;AyExyUQ;EAIQ,kBAAA;EAGJ,kFAAA;AzEsyUZ;;AyE7yUQ;EAIQ,kBAAA;EAGJ,kFAAA;AzE2yUZ;;AyElzUQ;EAIQ,kBAAA;EAGJ,kFAAA;AzEgzUZ;;AyEvzUQ;EAIQ,kBAAA;EAGJ,kFAAA;AzEqzUZ;;AyE5zUQ;EAIQ,kBAAA;EAGJ,kFAAA;AzE0zUZ;;AyEj0UQ;EAIQ,kBAAA;EAGJ,kFAAA;AzE+zUZ;;AyEt0UQ;EAIQ,kBAAA;EAGJ,4EAAA;AzEo0UZ;;AyE30UQ;EAIQ,kBAAA;EAGJ,4EAAA;AzEy0UZ;;AyEh1UQ;EAIQ,kBAAA;EAGJ,8EAAA;AzE80UZ;;AyEr1UQ;EAIQ,kBAAA;EAGJ,wCAAA;AzEm1UZ;;AyE11UQ;EAIQ,kBAAA;EAGJ,mFAAA;AzEw1UZ;;AyE/1UQ;EAIQ,kBAAA;EAGJ,kFAAA;AzE61UZ;;AyE92UQ;EACE,oBAAA;AzEi3UV;;AyEl3UQ;EACE,qBAAA;AzEq3UV;;AyEt3UQ;EACE,oBAAA;AzEy3UV;;AyE13UQ;EACE,qBAAA;AzE63UV;;AyE93UQ;EACE,kBAAA;AzEi4UV;;AyEx3UQ;EAOI,wDAAA;AzEq3UZ;;AyE53UQ;EAOI,0DAAA;AzEy3UZ;;AyEh4UQ;EAOI,wDAAA;AzE63UZ;;AyEp4UQ;EAOI,qDAAA;AzEi4UZ;;AyEx4UQ;EAOI,wDAAA;AzEq4UZ;;AyE54UQ;EAOI,uDAAA;AzEy4UZ;;AyEh5UQ;EAOI,sDAAA;AzE64UZ;;AyEp5UQ;EAOI,qDAAA;AzEi5UZ;;AyEx5UQ;EAOI,+CAAA;AzEq5UZ;;AyE55UQ;EAOI,mCAAA;UAAA,2BAAA;AzEy5UZ;;AyEh6UQ;EAOI,oCAAA;UAAA,4BAAA;AzE65UZ;;AyEp6UQ;EAOI,oCAAA;UAAA,4BAAA;AzEi6UZ;;AyEx6UQ;EAOI,+BAAA;AzEq6UZ;;AyE56UQ;EAOI,+BAAA;AzEy6UZ;;AyEh7UQ;EAOI,iDAAA;AzE66UZ;;AyEp7UQ;EAOI,2BAAA;AzEi7UZ;;AyEx7UQ;EAOI,oDAAA;AzEq7UZ;;AyE57UQ;EAOI,iDAAA;AzEy7UZ;;AyEh8UQ;EAOI,oDAAA;AzE67UZ;;AyEp8UQ;EAOI,oDAAA;AzEi8UZ;;AyEx8UQ;EAOI,qDAAA;AzEq8UZ;;AyE58UQ;EAOI,6BAAA;AzEy8UZ;;AyEh9UQ;EAOI,sDAAA;AzE68UZ;;AyEp9UQ;EAOI,0DAAA;EAAA,2DAAA;AzEk9UZ;;AyEz9UQ;EAOI,oCAAA;EAAA,qCAAA;AzEu9UZ;;AyE99UQ;EAOI,6DAAA;EAAA,8DAAA;AzE49UZ;;AyEn+UQ;EAOI,0DAAA;EAAA,2DAAA;AzEi+UZ;;AyEx+UQ;EAOI,6DAAA;EAAA,8DAAA;AzEs+UZ;;AyE7+UQ;EAOI,6DAAA;EAAA,8DAAA;AzE2+UZ;;AyEl/UQ;EAOI,8DAAA;EAAA,+DAAA;AzEg/UZ;;AyEv/UQ;EAOI,sCAAA;EAAA,uCAAA;AzEq/UZ;;AyE5/UQ;EAOI,+DAAA;EAAA,gEAAA;AzE0/UZ;;AyEjgVQ;EAOI,2DAAA;EAAA,8DAAA;AzE+/UZ;;AyEtgVQ;EAOI,qCAAA;EAAA,wCAAA;AzEogVZ;;AyE3gVQ;EAOI,8DAAA;EAAA,iEAAA;AzEygVZ;;AyEhhVQ;EAOI,2DAAA;EAAA,8DAAA;AzE8gVZ;;AyErhVQ;EAOI,8DAAA;EAAA,iEAAA;AzEmhVZ;;AyE1hVQ;EAOI,8DAAA;EAAA,iEAAA;AzEwhVZ;;AyE/hVQ;EAOI,+DAAA;EAAA,kEAAA;AzE6hVZ;;AyEpiVQ;EAOI,uCAAA;EAAA,0CAAA;AzEkiVZ;;AyEziVQ;EAOI,gEAAA;EAAA,mEAAA;AzEuiVZ;;AyE9iVQ;EAOI,8DAAA;EAAA,6DAAA;AzE4iVZ;;AyEnjVQ;EAOI,wCAAA;EAAA,uCAAA;AzEijVZ;;AyExjVQ;EAOI,iEAAA;EAAA,gEAAA;AzEsjVZ;;AyE7jVQ;EAOI,8DAAA;EAAA,6DAAA;AzE2jVZ;;AyElkVQ;EAOI,iEAAA;EAAA,gEAAA;AzEgkVZ;;AyEvkVQ;EAOI,iEAAA;EAAA,gEAAA;AzEqkVZ;;AyE5kVQ;EAOI,kEAAA;EAAA,iEAAA;AzE0kVZ;;AyEjlVQ;EAOI,0CAAA;EAAA,yCAAA;AzE+kVZ;;AyEtlVQ;EAOI,mEAAA;EAAA,kEAAA;AzEolVZ;;AyE3lVQ;EAOI,6DAAA;EAAA,0DAAA;AzEylVZ;;AyEhmVQ;EAOI,uCAAA;EAAA,oCAAA;AzE8lVZ;;AyErmVQ;EAOI,gEAAA;EAAA,6DAAA;AzEmmVZ;;AyE1mVQ;EAOI,6DAAA;EAAA,0DAAA;AzEwmVZ;;AyE/mVQ;EAOI,gEAAA;EAAA,6DAAA;AzE6mVZ;;AyEpnVQ;EAOI,gEAAA;EAAA,6DAAA;AzEknVZ;;AyEznVQ;EAOI,iEAAA;EAAA,8DAAA;AzEunVZ;;AyE9nVQ;EAOI,yCAAA;EAAA,sCAAA;AzE4nVZ;;AyEnoVQ;EAOI,kEAAA;EAAA,+DAAA;AzEioVZ;;AyExoVQ;EAOI,8BAAA;AzEqoVZ;;AyE5oVQ;EAOI,6BAAA;AzEyoVZ;;AyEhpVQ;EAOI,sBAAA;AzE6oVZ;;AyEppVQ;EAOI,qBAAA;AzEipVZ;;AyExpVQ;EAOI,qBAAA;AzEqpVZ;;AyE5pVQ;EAOI,qBAAA;AzEypVZ;;AyEhqVQ;EAOI,qBAAA;AzE6pVZ;;AevqVI;E0DGI;IAOI,sBAAA;EzEkqVV;EyEzqVM;IAOI,uBAAA;EzEqqVV;EyE5qVM;IAOI,sBAAA;EzEwqVV;EyE/qVM;IAOI,8BAAA;EzE2qVV;EyElrVM;IAOI,4BAAA;EzE8qVV;EyErrVM;IAOI,2BAAA;EzEirVV;EyExrVM;IAOI,iCAAA;EzEorVV;EyE3rVM;IAOI,2BAAA;EzEurVV;EyE9rVM;IAOI,0BAAA;EzE0rVV;EyEjsVM;IAOI,gCAAA;EzE6rVV;EyEpsVM;IAOI,yBAAA;EzEgsVV;EyEvsVM;IAOI,wBAAA;EzEmsVV;EyE1sVM;IAOI,+BAAA;EzEssVV;EyE7sVM;IAOI,yBAAA;EzEysVV;EyEhtVM;IAOI,6BAAA;EzE4sVV;EyEntVM;IAOI,8BAAA;EzE+sVV;EyEttVM;IAOI,wBAAA;EzEktVV;EyEztVM;IAOI,+BAAA;EzEqtVV;EyE5tVM;IAOI,wBAAA;EzEwtVV;EyE/tVM;IAOI,yBAAA;EzE2tVV;EyEluVM;IAOI,8BAAA;EzE8tVV;EyEruVM;IAOI,iCAAA;EzEiuVV;EyExuVM;IAOI,sCAAA;EzEouVV;EyE3uVM;IAOI,yCAAA;EzEuuVV;EyE9uVM;IAOI,uBAAA;EzE0uVV;EyEjvVM;IAOI,uBAAA;EzE6uVV;EyEpvVM;IAOI,yBAAA;EzEgvVV;EyEvvVM;IAOI,yBAAA;EzEmvVV;EyE1vVM;IAOI,0BAAA;EzEsvVV;EyE7vVM;IAOI,4BAAA;EzEyvVV;EyEhwVM;IAOI,kCAAA;EzE4vVV;EyEnwVM;IAOI,sCAAA;EzE+vVV;EyEtwVM;IAOI,oCAAA;EzEkwVV;EyEzwVM;IAOI,kCAAA;EzEqwVV;EyE5wVM;IAOI,yCAAA;EzEwwVV;EyE/wVM;IAOI,wCAAA;EzE2wVV;EyElxVM;IAOI,wCAAA;EzE8wVV;EyErxVM;IAOI,kCAAA;EzEixVV;EyExxVM;IAOI,gCAAA;EzEoxVV;EyE3xVM;IAOI,8BAAA;EzEuxVV;EyE9xVM;IAOI,gCAAA;EzE0xVV;EyEjyVM;IAOI,+BAAA;EzE6xVV;EyEpyVM;IAOI,oCAAA;EzEgyVV;EyEvyVM;IAOI,kCAAA;EzEmyVV;EyE1yVM;IAOI,gCAAA;EzEsyVV;EyE7yVM;IAOI,uCAAA;EzEyyVV;EyEhzVM;IAOI,sCAAA;EzE4yVV;EyEnzVM;IAOI,iCAAA;EzE+yVV;EyEtzVM;IAOI,2BAAA;EzEkzVV;EyEzzVM;IAOI,iCAAA;EzEqzVV;EyE5zVM;IAOI,+BAAA;EzEwzVV;EyE/zVM;IAOI,6BAAA;EzE2zVV;EyEl0VM;IAOI,+BAAA;EzE8zVV;EyEr0VM;IAOI,8BAAA;EzEi0VV;EyEx0VM;IAOI,oBAAA;EzEo0VV;EyE30VM;IAOI,mBAAA;EzEu0VV;EyE90VM;IAOI,mBAAA;EzE00VV;EyEj1VM;IAOI,mBAAA;EzE60VV;EyEp1VM;IAOI,mBAAA;EzEg1VV;EyEv1VM;IAOI,mBAAA;EzEm1VV;EyE11VM;IAOI,mBAAA;EzEs1VV;EyE71VM;IAOI,mBAAA;EzEy1VV;EyEh2VM;IAOI,oBAAA;EzE41VV;EyEn2VM;IAOI,0BAAA;EzE+1VV;EyEt2VM;IAOI,yBAAA;EzEk2VV;EyEz2VM;IAOI,uBAAA;EzEq2VV;EyE52VM;IAOI,yBAAA;EzEw2VV;EyE/2VM;IAOI,uBAAA;EzE22VV;EyEl3VM;IAOI,uBAAA;EzE82VV;EyEr3VM;IAOI,0BAAA;IAAA,yBAAA;EzEk3VV;EyEz3VM;IAOI,gCAAA;IAAA,+BAAA;EzEs3VV;EyE73VM;IAOI,+BAAA;IAAA,8BAAA;EzE03VV;EyEj4VM;IAOI,6BAAA;IAAA,4BAAA;EzE83VV;EyEr4VM;IAOI,+BAAA;IAAA,8BAAA;EzEk4VV;EyEz4VM;IAOI,6BAAA;IAAA,4BAAA;EzEs4VV;EyE74VM;IAOI,6BAAA;IAAA,4BAAA;EzE04VV;EyEj5VM;IAOI,wBAAA;IAAA,2BAAA;EzE84VV;EyEr5VM;IAOI,8BAAA;IAAA,iCAAA;EzEk5VV;EyEz5VM;IAOI,6BAAA;IAAA,gCAAA;EzEs5VV;EyE75VM;IAOI,2BAAA;IAAA,8BAAA;EzE05VV;EyEj6VM;IAOI,6BAAA;IAAA,gCAAA;EzE85VV;EyEr6VM;IAOI,2BAAA;IAAA,8BAAA;EzEk6VV;EyEz6VM;IAOI,2BAAA;IAAA,8BAAA;EzEs6VV;EyE76VM;IAOI,wBAAA;EzEy6VV;EyEh7VM;IAOI,8BAAA;EzE46VV;EyEn7VM;IAOI,6BAAA;EzE+6VV;EyEt7VM;IAOI,2BAAA;EzEk7VV;EyEz7VM;IAOI,6BAAA;EzEq7VV;EyE57VM;IAOI,2BAAA;EzEw7VV;EyE/7VM;IAOI,2BAAA;EzE27VV;EyEl8VM;IAOI,0BAAA;EzE87VV;EyEr8VM;IAOI,gCAAA;EzEi8VV;EyEx8VM;IAOI,+BAAA;EzEo8VV;EyE38VM;IAOI,6BAAA;EzEu8VV;EyE98VM;IAOI,+BAAA;EzE08VV;EyEj9VM;IAOI,6BAAA;EzE68VV;EyEp9VM;IAOI,6BAAA;EzEg9VV;EyEv9VM;IAOI,2BAAA;EzEm9VV;EyE19VM;IAOI,iCAAA;EzEs9VV;EyE79VM;IAOI,gCAAA;EzEy9VV;EyEh+VM;IAOI,8BAAA;EzE49VV;EyEn+VM;IAOI,gCAAA;EzE+9VV;EyEt+VM;IAOI,8BAAA;EzEk+VV;EyEz+VM;IAOI,8BAAA;EzEq+VV;EyE5+VM;IAOI,yBAAA;EzEw+VV;EyE/+VM;IAOI,+BAAA;EzE2+VV;EyEl/VM;IAOI,8BAAA;EzE8+VV;EyEr/VM;IAOI,4BAAA;EzEi/VV;EyEx/VM;IAOI,8BAAA;EzEo/VV;EyE3/VM;IAOI,4BAAA;EzEu/VV;EyE9/VM;IAOI,4BAAA;EzE0/VV;EyEjgWM;IAOI,2BAAA;EzE6/VV;EyEpgWM;IAOI,0BAAA;EzEggWV;EyEvgWM;IAOI,wBAAA;EzEmgWV;EyE1gWM;IAOI,0BAAA;EzEsgWV;EyE7gWM;IAOI,wBAAA;EzEygWV;EyEhhWM;IAOI,iCAAA;IAAA,gCAAA;EzE6gWV;EyEphWM;IAOI,gCAAA;IAAA,+BAAA;EzEihWV;EyExhWM;IAOI,8BAAA;IAAA,6BAAA;EzEqhWV;EyE5hWM;IAOI,gCAAA;IAAA,+BAAA;EzEyhWV;EyEhiWM;IAOI,8BAAA;IAAA,6BAAA;EzE6hWV;EyEpiWM;IAOI,+BAAA;IAAA,kCAAA;EzEiiWV;EyExiWM;IAOI,8BAAA;IAAA,iCAAA;EzEqiWV;EyE5iWM;IAOI,4BAAA;IAAA,+BAAA;EzEyiWV;EyEhjWM;IAOI,8BAAA;IAAA,iCAAA;EzE6iWV;EyEpjWM;IAOI,4BAAA;IAAA,+BAAA;EzEijWV;EyExjWM;IAOI,+BAAA;EzEojWV;EyE3jWM;IAOI,8BAAA;EzEujWV;EyE9jWM;IAOI,4BAAA;EzE0jWV;EyEjkWM;IAOI,8BAAA;EzE6jWV;EyEpkWM;IAOI,4BAAA;EzEgkWV;EyEvkWM;IAOI,iCAAA;EzEmkWV;EyE1kWM;IAOI,gCAAA;EzEskWV;EyE7kWM;IAOI,8BAAA;EzEykWV;EyEhlWM;IAOI,gCAAA;EzE4kWV;EyEnlWM;IAOI,8BAAA;EzE+kWV;EyEtlWM;IAOI,kCAAA;EzEklWV;EyEzlWM;IAOI,iCAAA;EzEqlWV;EyE5lWM;IAOI,+BAAA;EzEwlWV;EyE/lWM;IAOI,iCAAA;EzE2lWV;EyElmWM;IAOI,+BAAA;EzE8lWV;EyErmWM;IAOI,gCAAA;EzEimWV;EyExmWM;IAOI,+BAAA;EzEomWV;EyE3mWM;IAOI,6BAAA;EzEumWV;EyE9mWM;IAOI,+BAAA;EzE0mWV;EyEjnWM;IAOI,6BAAA;EzE6mWV;EyEpnWM;IAOI,qBAAA;EzEgnWV;EyEvnWM;IAOI,2BAAA;EzEmnWV;EyE1nWM;IAOI,0BAAA;EzEsnWV;EyE7nWM;IAOI,wBAAA;EzEynWV;EyEhoWM;IAOI,0BAAA;EzE4nWV;EyEnoWM;IAOI,wBAAA;EzE+nWV;EyEtoWM;IAOI,2BAAA;IAAA,0BAAA;EzEmoWV;EyE1oWM;IAOI,iCAAA;IAAA,gCAAA;EzEuoWV;EyE9oWM;IAOI,gCAAA;IAAA,+BAAA;EzE2oWV;EyElpWM;IAOI,8BAAA;IAAA,6BAAA;EzE+oWV;EyEtpWM;IAOI,gCAAA;IAAA,+BAAA;EzEmpWV;EyE1pWM;IAOI,8BAAA;IAAA,6BAAA;EzEupWV;EyE9pWM;IAOI,yBAAA;IAAA,4BAAA;EzE2pWV;EyElqWM;IAOI,+BAAA;IAAA,kCAAA;EzE+pWV;EyEtqWM;IAOI,8BAAA;IAAA,iCAAA;EzEmqWV;EyE1qWM;IAOI,4BAAA;IAAA,+BAAA;EzEuqWV;EyE9qWM;IAOI,8BAAA;IAAA,iCAAA;EzE2qWV;EyElrWM;IAOI,4BAAA;IAAA,+BAAA;EzE+qWV;EyEtrWM;IAOI,yBAAA;EzEkrWV;EyEzrWM;IAOI,+BAAA;EzEqrWV;EyE5rWM;IAOI,8BAAA;EzEwrWV;EyE/rWM;IAOI,4BAAA;EzE2rWV;EyElsWM;IAOI,8BAAA;EzE8rWV;EyErsWM;IAOI,4BAAA;EzEisWV;EyExsWM;IAOI,2BAAA;EzEosWV;EyE3sWM;IAOI,iCAAA;EzEusWV;EyE9sWM;IAOI,gCAAA;EzE0sWV;EyEjtWM;IAOI,8BAAA;EzE6sWV;EyEptWM;IAOI,gCAAA;EzEgtWV;EyEvtWM;IAOI,8BAAA;EzEmtWV;EyE1tWM;IAOI,4BAAA;EzEstWV;EyE7tWM;IAOI,kCAAA;EzEytWV;EyEhuWM;IAOI,iCAAA;EzE4tWV;EyEnuWM;IAOI,+BAAA;EzE+tWV;EyEtuWM;IAOI,iCAAA;EzEkuWV;EyEzuWM;IAOI,+BAAA;EzEquWV;EyE5uWM;IAOI,0BAAA;EzEwuWV;EyE/uWM;IAOI,gCAAA;EzE2uWV;EyElvWM;IAOI,+BAAA;EzE8uWV;EyErvWM;IAOI,6BAAA;EzEivWV;EyExvWM;IAOI,+BAAA;EzEovWV;EyE3vWM;IAOI,6BAAA;EzEuvWV;EyE9vWM;IAOI,iBAAA;EzE0vWV;EyEjwWM;IAOI,uBAAA;EzE6vWV;EyEpwWM;IAOI,sBAAA;EzEgwWV;EyEvwWM;IAOI,oBAAA;EzEmwWV;EyE1wWM;IAOI,sBAAA;EzEswWV;EyE7wWM;IAOI,oBAAA;EzEywWV;EyEhxWM;IAOI,qBAAA;EzE4wWV;EyEnxWM;IAOI,2BAAA;EzE+wWV;EyEtxWM;IAOI,0BAAA;EzEkxWV;EyEzxWM;IAOI,wBAAA;EzEqxWV;EyE5xWM;IAOI,0BAAA;EzEwxWV;EyE/xWM;IAOI,wBAAA;EzE2xWV;EyElyWM;IAOI,wBAAA;EzE8xWV;EyEryWM;IAOI,8BAAA;EzEiyWV;EyExyWM;IAOI,6BAAA;EzEoyWV;EyE3yWM;IAOI,2BAAA;EzEuyWV;EyE9yWM;IAOI,6BAAA;EzE0yWV;EyEjzWM;IAOI,2BAAA;EzE6yWV;EyEpzWM;IAOI,2BAAA;EzEgzWV;EyEvzWM;IAOI,4BAAA;EzEmzWV;EyE1zWM;IAOI,6BAAA;EzEszWV;AACF;Aej0WI;E0DGI;IAOI,sBAAA;EzE2zWV;EyEl0WM;IAOI,uBAAA;EzE8zWV;EyEr0WM;IAOI,sBAAA;EzEi0WV;EyEx0WM;IAOI,8BAAA;EzEo0WV;EyE30WM;IAOI,4BAAA;EzEu0WV;EyE90WM;IAOI,2BAAA;EzE00WV;EyEj1WM;IAOI,iCAAA;EzE60WV;EyEp1WM;IAOI,2BAAA;EzEg1WV;EyEv1WM;IAOI,0BAAA;EzEm1WV;EyE11WM;IAOI,gCAAA;EzEs1WV;EyE71WM;IAOI,yBAAA;EzEy1WV;EyEh2WM;IAOI,wBAAA;EzE41WV;EyEn2WM;IAOI,+BAAA;EzE+1WV;EyEt2WM;IAOI,yBAAA;EzEk2WV;EyEz2WM;IAOI,6BAAA;EzEq2WV;EyE52WM;IAOI,8BAAA;EzEw2WV;EyE/2WM;IAOI,wBAAA;EzE22WV;EyEl3WM;IAOI,+BAAA;EzE82WV;EyEr3WM;IAOI,wBAAA;EzEi3WV;EyEx3WM;IAOI,yBAAA;EzEo3WV;EyE33WM;IAOI,8BAAA;EzEu3WV;EyE93WM;IAOI,iCAAA;EzE03WV;EyEj4WM;IAOI,sCAAA;EzE63WV;EyEp4WM;IAOI,yCAAA;EzEg4WV;EyEv4WM;IAOI,uBAAA;EzEm4WV;EyE14WM;IAOI,uBAAA;EzEs4WV;EyE74WM;IAOI,yBAAA;EzEy4WV;EyEh5WM;IAOI,yBAAA;EzE44WV;EyEn5WM;IAOI,0BAAA;EzE+4WV;EyEt5WM;IAOI,4BAAA;EzEk5WV;EyEz5WM;IAOI,kCAAA;EzEq5WV;EyE55WM;IAOI,sCAAA;EzEw5WV;EyE/5WM;IAOI,oCAAA;EzE25WV;EyEl6WM;IAOI,kCAAA;EzE85WV;EyEr6WM;IAOI,yCAAA;EzEi6WV;EyEx6WM;IAOI,wCAAA;EzEo6WV;EyE36WM;IAOI,wCAAA;EzEu6WV;EyE96WM;IAOI,kCAAA;EzE06WV;EyEj7WM;IAOI,gCAAA;EzE66WV;EyEp7WM;IAOI,8BAAA;EzEg7WV;EyEv7WM;IAOI,gCAAA;EzEm7WV;EyE17WM;IAOI,+BAAA;EzEs7WV;EyE77WM;IAOI,oCAAA;EzEy7WV;EyEh8WM;IAOI,kCAAA;EzE47WV;EyEn8WM;IAOI,gCAAA;EzE+7WV;EyEt8WM;IAOI,uCAAA;EzEk8WV;EyEz8WM;IAOI,sCAAA;EzEq8WV;EyE58WM;IAOI,iCAAA;EzEw8WV;EyE/8WM;IAOI,2BAAA;EzE28WV;EyEl9WM;IAOI,iCAAA;EzE88WV;EyEr9WM;IAOI,+BAAA;EzEi9WV;EyEx9WM;IAOI,6BAAA;EzEo9WV;EyE39WM;IAOI,+BAAA;EzEu9WV;EyE99WM;IAOI,8BAAA;EzE09WV;EyEj+WM;IAOI,oBAAA;EzE69WV;EyEp+WM;IAOI,mBAAA;EzEg+WV;EyEv+WM;IAOI,mBAAA;EzEm+WV;EyE1+WM;IAOI,mBAAA;EzEs+WV;EyE7+WM;IAOI,mBAAA;EzEy+WV;EyEh/WM;IAOI,mBAAA;EzE4+WV;EyEn/WM;IAOI,mBAAA;EzE++WV;EyEt/WM;IAOI,mBAAA;EzEk/WV;EyEz/WM;IAOI,oBAAA;EzEq/WV;EyE5/WM;IAOI,0BAAA;EzEw/WV;EyE//WM;IAOI,yBAAA;EzE2/WV;EyElgXM;IAOI,uBAAA;EzE8/WV;EyErgXM;IAOI,yBAAA;EzEigXV;EyExgXM;IAOI,uBAAA;EzEogXV;EyE3gXM;IAOI,uBAAA;EzEugXV;EyE9gXM;IAOI,0BAAA;IAAA,yBAAA;EzE2gXV;EyElhXM;IAOI,gCAAA;IAAA,+BAAA;EzE+gXV;EyEthXM;IAOI,+BAAA;IAAA,8BAAA;EzEmhXV;EyE1hXM;IAOI,6BAAA;IAAA,4BAAA;EzEuhXV;EyE9hXM;IAOI,+BAAA;IAAA,8BAAA;EzE2hXV;EyEliXM;IAOI,6BAAA;IAAA,4BAAA;EzE+hXV;EyEtiXM;IAOI,6BAAA;IAAA,4BAAA;EzEmiXV;EyE1iXM;IAOI,wBAAA;IAAA,2BAAA;EzEuiXV;EyE9iXM;IAOI,8BAAA;IAAA,iCAAA;EzE2iXV;EyEljXM;IAOI,6BAAA;IAAA,gCAAA;EzE+iXV;EyEtjXM;IAOI,2BAAA;IAAA,8BAAA;EzEmjXV;EyE1jXM;IAOI,6BAAA;IAAA,gCAAA;EzEujXV;EyE9jXM;IAOI,2BAAA;IAAA,8BAAA;EzE2jXV;EyElkXM;IAOI,2BAAA;IAAA,8BAAA;EzE+jXV;EyEtkXM;IAOI,wBAAA;EzEkkXV;EyEzkXM;IAOI,8BAAA;EzEqkXV;EyE5kXM;IAOI,6BAAA;EzEwkXV;EyE/kXM;IAOI,2BAAA;EzE2kXV;EyEllXM;IAOI,6BAAA;EzE8kXV;EyErlXM;IAOI,2BAAA;EzEilXV;EyExlXM;IAOI,2BAAA;EzEolXV;EyE3lXM;IAOI,0BAAA;EzEulXV;EyE9lXM;IAOI,gCAAA;EzE0lXV;EyEjmXM;IAOI,+BAAA;EzE6lXV;EyEpmXM;IAOI,6BAAA;EzEgmXV;EyEvmXM;IAOI,+BAAA;EzEmmXV;EyE1mXM;IAOI,6BAAA;EzEsmXV;EyE7mXM;IAOI,6BAAA;EzEymXV;EyEhnXM;IAOI,2BAAA;EzE4mXV;EyEnnXM;IAOI,iCAAA;EzE+mXV;EyEtnXM;IAOI,gCAAA;EzEknXV;EyEznXM;IAOI,8BAAA;EzEqnXV;EyE5nXM;IAOI,gCAAA;EzEwnXV;EyE/nXM;IAOI,8BAAA;EzE2nXV;EyEloXM;IAOI,8BAAA;EzE8nXV;EyEroXM;IAOI,yBAAA;EzEioXV;EyExoXM;IAOI,+BAAA;EzEooXV;EyE3oXM;IAOI,8BAAA;EzEuoXV;EyE9oXM;IAOI,4BAAA;EzE0oXV;EyEjpXM;IAOI,8BAAA;EzE6oXV;EyEppXM;IAOI,4BAAA;EzEgpXV;EyEvpXM;IAOI,4BAAA;EzEmpXV;EyE1pXM;IAOI,2BAAA;EzEspXV;EyE7pXM;IAOI,0BAAA;EzEypXV;EyEhqXM;IAOI,wBAAA;EzE4pXV;EyEnqXM;IAOI,0BAAA;EzE+pXV;EyEtqXM;IAOI,wBAAA;EzEkqXV;EyEzqXM;IAOI,iCAAA;IAAA,gCAAA;EzEsqXV;EyE7qXM;IAOI,gCAAA;IAAA,+BAAA;EzE0qXV;EyEjrXM;IAOI,8BAAA;IAAA,6BAAA;EzE8qXV;EyErrXM;IAOI,gCAAA;IAAA,+BAAA;EzEkrXV;EyEzrXM;IAOI,8BAAA;IAAA,6BAAA;EzEsrXV;EyE7rXM;IAOI,+BAAA;IAAA,kCAAA;EzE0rXV;EyEjsXM;IAOI,8BAAA;IAAA,iCAAA;EzE8rXV;EyErsXM;IAOI,4BAAA;IAAA,+BAAA;EzEksXV;EyEzsXM;IAOI,8BAAA;IAAA,iCAAA;EzEssXV;EyE7sXM;IAOI,4BAAA;IAAA,+BAAA;EzE0sXV;EyEjtXM;IAOI,+BAAA;EzE6sXV;EyEptXM;IAOI,8BAAA;EzEgtXV;EyEvtXM;IAOI,4BAAA;EzEmtXV;EyE1tXM;IAOI,8BAAA;EzEstXV;EyE7tXM;IAOI,4BAAA;EzEytXV;EyEhuXM;IAOI,iCAAA;EzE4tXV;EyEnuXM;IAOI,gCAAA;EzE+tXV;EyEtuXM;IAOI,8BAAA;EzEkuXV;EyEzuXM;IAOI,gCAAA;EzEquXV;EyE5uXM;IAOI,8BAAA;EzEwuXV;EyE/uXM;IAOI,kCAAA;EzE2uXV;EyElvXM;IAOI,iCAAA;EzE8uXV;EyErvXM;IAOI,+BAAA;EzEivXV;EyExvXM;IAOI,iCAAA;EzEovXV;EyE3vXM;IAOI,+BAAA;EzEuvXV;EyE9vXM;IAOI,gCAAA;EzE0vXV;EyEjwXM;IAOI,+BAAA;EzE6vXV;EyEpwXM;IAOI,6BAAA;EzEgwXV;EyEvwXM;IAOI,+BAAA;EzEmwXV;EyE1wXM;IAOI,6BAAA;EzEswXV;EyE7wXM;IAOI,qBAAA;EzEywXV;EyEhxXM;IAOI,2BAAA;EzE4wXV;EyEnxXM;IAOI,0BAAA;EzE+wXV;EyEtxXM;IAOI,wBAAA;EzEkxXV;EyEzxXM;IAOI,0BAAA;EzEqxXV;EyE5xXM;IAOI,wBAAA;EzEwxXV;EyE/xXM;IAOI,2BAAA;IAAA,0BAAA;EzE4xXV;EyEnyXM;IAOI,iCAAA;IAAA,gCAAA;EzEgyXV;EyEvyXM;IAOI,gCAAA;IAAA,+BAAA;EzEoyXV;EyE3yXM;IAOI,8BAAA;IAAA,6BAAA;EzEwyXV;EyE/yXM;IAOI,gCAAA;IAAA,+BAAA;EzE4yXV;EyEnzXM;IAOI,8BAAA;IAAA,6BAAA;EzEgzXV;EyEvzXM;IAOI,yBAAA;IAAA,4BAAA;EzEozXV;EyE3zXM;IAOI,+BAAA;IAAA,kCAAA;EzEwzXV;EyE/zXM;IAOI,8BAAA;IAAA,iCAAA;EzE4zXV;EyEn0XM;IAOI,4BAAA;IAAA,+BAAA;EzEg0XV;EyEv0XM;IAOI,8BAAA;IAAA,iCAAA;EzEo0XV;EyE30XM;IAOI,4BAAA;IAAA,+BAAA;EzEw0XV;EyE/0XM;IAOI,yBAAA;EzE20XV;EyEl1XM;IAOI,+BAAA;EzE80XV;EyEr1XM;IAOI,8BAAA;EzEi1XV;EyEx1XM;IAOI,4BAAA;EzEo1XV;EyE31XM;IAOI,8BAAA;EzEu1XV;EyE91XM;IAOI,4BAAA;EzE01XV;EyEj2XM;IAOI,2BAAA;EzE61XV;EyEp2XM;IAOI,iCAAA;EzEg2XV;EyEv2XM;IAOI,gCAAA;EzEm2XV;EyE12XM;IAOI,8BAAA;EzEs2XV;EyE72XM;IAOI,gCAAA;EzEy2XV;EyEh3XM;IAOI,8BAAA;EzE42XV;EyEn3XM;IAOI,4BAAA;EzE+2XV;EyEt3XM;IAOI,kCAAA;EzEk3XV;EyEz3XM;IAOI,iCAAA;EzEq3XV;EyE53XM;IAOI,+BAAA;EzEw3XV;EyE/3XM;IAOI,iCAAA;EzE23XV;EyEl4XM;IAOI,+BAAA;EzE83XV;EyEr4XM;IAOI,0BAAA;EzEi4XV;EyEx4XM;IAOI,gCAAA;EzEo4XV;EyE34XM;IAOI,+BAAA;EzEu4XV;EyE94XM;IAOI,6BAAA;EzE04XV;EyEj5XM;IAOI,+BAAA;EzE64XV;EyEp5XM;IAOI,6BAAA;EzEg5XV;EyEv5XM;IAOI,iBAAA;EzEm5XV;EyE15XM;IAOI,uBAAA;EzEs5XV;EyE75XM;IAOI,sBAAA;EzEy5XV;EyEh6XM;IAOI,oBAAA;EzE45XV;EyEn6XM;IAOI,sBAAA;EzE+5XV;EyEt6XM;IAOI,oBAAA;EzEk6XV;EyEz6XM;IAOI,qBAAA;EzEq6XV;EyE56XM;IAOI,2BAAA;EzEw6XV;EyE/6XM;IAOI,0BAAA;EzE26XV;EyEl7XM;IAOI,wBAAA;EzE86XV;EyEr7XM;IAOI,0BAAA;EzEi7XV;EyEx7XM;IAOI,wBAAA;EzEo7XV;EyE37XM;IAOI,wBAAA;EzEu7XV;EyE97XM;IAOI,8BAAA;EzE07XV;EyEj8XM;IAOI,6BAAA;EzE67XV;EyEp8XM;IAOI,2BAAA;EzEg8XV;EyEv8XM;IAOI,6BAAA;EzEm8XV;EyE18XM;IAOI,2BAAA;EzEs8XV;EyE78XM;IAOI,2BAAA;EzEy8XV;EyEh9XM;IAOI,4BAAA;EzE48XV;EyEn9XM;IAOI,6BAAA;EzE+8XV;AACF;Ae19XI;E0DGI;IAOI,sBAAA;EzEo9XV;EyE39XM;IAOI,uBAAA;EzEu9XV;EyE99XM;IAOI,sBAAA;EzE09XV;EyEj+XM;IAOI,8BAAA;EzE69XV;EyEp+XM;IAOI,4BAAA;EzEg+XV;EyEv+XM;IAOI,2BAAA;EzEm+XV;EyE1+XM;IAOI,iCAAA;EzEs+XV;EyE7+XM;IAOI,2BAAA;EzEy+XV;EyEh/XM;IAOI,0BAAA;EzE4+XV;EyEn/XM;IAOI,gCAAA;EzE++XV;EyEt/XM;IAOI,yBAAA;EzEk/XV;EyEz/XM;IAOI,wBAAA;EzEq/XV;EyE5/XM;IAOI,+BAAA;EzEw/XV;EyE//XM;IAOI,yBAAA;EzE2/XV;EyElgYM;IAOI,6BAAA;EzE8/XV;EyErgYM;IAOI,8BAAA;EzEigYV;EyExgYM;IAOI,wBAAA;EzEogYV;EyE3gYM;IAOI,+BAAA;EzEugYV;EyE9gYM;IAOI,wBAAA;EzE0gYV;EyEjhYM;IAOI,yBAAA;EzE6gYV;EyEphYM;IAOI,8BAAA;EzEghYV;EyEvhYM;IAOI,iCAAA;EzEmhYV;EyE1hYM;IAOI,sCAAA;EzEshYV;EyE7hYM;IAOI,yCAAA;EzEyhYV;EyEhiYM;IAOI,uBAAA;EzE4hYV;EyEniYM;IAOI,uBAAA;EzE+hYV;EyEtiYM;IAOI,yBAAA;EzEkiYV;EyEziYM;IAOI,yBAAA;EzEqiYV;EyE5iYM;IAOI,0BAAA;EzEwiYV;EyE/iYM;IAOI,4BAAA;EzE2iYV;EyEljYM;IAOI,kCAAA;EzE8iYV;EyErjYM;IAOI,sCAAA;EzEijYV;EyExjYM;IAOI,oCAAA;EzEojYV;EyE3jYM;IAOI,kCAAA;EzEujYV;EyE9jYM;IAOI,yCAAA;EzE0jYV;EyEjkYM;IAOI,wCAAA;EzE6jYV;EyEpkYM;IAOI,wCAAA;EzEgkYV;EyEvkYM;IAOI,kCAAA;EzEmkYV;EyE1kYM;IAOI,gCAAA;EzEskYV;EyE7kYM;IAOI,8BAAA;EzEykYV;EyEhlYM;IAOI,gCAAA;EzE4kYV;EyEnlYM;IAOI,+BAAA;EzE+kYV;EyEtlYM;IAOI,oCAAA;EzEklYV;EyEzlYM;IAOI,kCAAA;EzEqlYV;EyE5lYM;IAOI,gCAAA;EzEwlYV;EyE/lYM;IAOI,uCAAA;EzE2lYV;EyElmYM;IAOI,sCAAA;EzE8lYV;EyErmYM;IAOI,iCAAA;EzEimYV;EyExmYM;IAOI,2BAAA;EzEomYV;EyE3mYM;IAOI,iCAAA;EzEumYV;EyE9mYM;IAOI,+BAAA;EzE0mYV;EyEjnYM;IAOI,6BAAA;EzE6mYV;EyEpnYM;IAOI,+BAAA;EzEgnYV;EyEvnYM;IAOI,8BAAA;EzEmnYV;EyE1nYM;IAOI,oBAAA;EzEsnYV;EyE7nYM;IAOI,mBAAA;EzEynYV;EyEhoYM;IAOI,mBAAA;EzE4nYV;EyEnoYM;IAOI,mBAAA;EzE+nYV;EyEtoYM;IAOI,mBAAA;EzEkoYV;EyEzoYM;IAOI,mBAAA;EzEqoYV;EyE5oYM;IAOI,mBAAA;EzEwoYV;EyE/oYM;IAOI,mBAAA;EzE2oYV;EyElpYM;IAOI,oBAAA;EzE8oYV;EyErpYM;IAOI,0BAAA;EzEipYV;EyExpYM;IAOI,yBAAA;EzEopYV;EyE3pYM;IAOI,uBAAA;EzEupYV;EyE9pYM;IAOI,yBAAA;EzE0pYV;EyEjqYM;IAOI,uBAAA;EzE6pYV;EyEpqYM;IAOI,uBAAA;EzEgqYV;EyEvqYM;IAOI,0BAAA;IAAA,yBAAA;EzEoqYV;EyE3qYM;IAOI,gCAAA;IAAA,+BAAA;EzEwqYV;EyE/qYM;IAOI,+BAAA;IAAA,8BAAA;EzE4qYV;EyEnrYM;IAOI,6BAAA;IAAA,4BAAA;EzEgrYV;EyEvrYM;IAOI,+BAAA;IAAA,8BAAA;EzEorYV;EyE3rYM;IAOI,6BAAA;IAAA,4BAAA;EzEwrYV;EyE/rYM;IAOI,6BAAA;IAAA,4BAAA;EzE4rYV;EyEnsYM;IAOI,wBAAA;IAAA,2BAAA;EzEgsYV;EyEvsYM;IAOI,8BAAA;IAAA,iCAAA;EzEosYV;EyE3sYM;IAOI,6BAAA;IAAA,gCAAA;EzEwsYV;EyE/sYM;IAOI,2BAAA;IAAA,8BAAA;EzE4sYV;EyEntYM;IAOI,6BAAA;IAAA,gCAAA;EzEgtYV;EyEvtYM;IAOI,2BAAA;IAAA,8BAAA;EzEotYV;EyE3tYM;IAOI,2BAAA;IAAA,8BAAA;EzEwtYV;EyE/tYM;IAOI,wBAAA;EzE2tYV;EyEluYM;IAOI,8BAAA;EzE8tYV;EyEruYM;IAOI,6BAAA;EzEiuYV;EyExuYM;IAOI,2BAAA;EzEouYV;EyE3uYM;IAOI,6BAAA;EzEuuYV;EyE9uYM;IAOI,2BAAA;EzE0uYV;EyEjvYM;IAOI,2BAAA;EzE6uYV;EyEpvYM;IAOI,0BAAA;EzEgvYV;EyEvvYM;IAOI,gCAAA;EzEmvYV;EyE1vYM;IAOI,+BAAA;EzEsvYV;EyE7vYM;IAOI,6BAAA;EzEyvYV;EyEhwYM;IAOI,+BAAA;EzE4vYV;EyEnwYM;IAOI,6BAAA;EzE+vYV;EyEtwYM;IAOI,6BAAA;EzEkwYV;EyEzwYM;IAOI,2BAAA;EzEqwYV;EyE5wYM;IAOI,iCAAA;EzEwwYV;EyE/wYM;IAOI,gCAAA;EzE2wYV;EyElxYM;IAOI,8BAAA;EzE8wYV;EyErxYM;IAOI,gCAAA;EzEixYV;EyExxYM;IAOI,8BAAA;EzEoxYV;EyE3xYM;IAOI,8BAAA;EzEuxYV;EyE9xYM;IAOI,yBAAA;EzE0xYV;EyEjyYM;IAOI,+BAAA;EzE6xYV;EyEpyYM;IAOI,8BAAA;EzEgyYV;EyEvyYM;IAOI,4BAAA;EzEmyYV;EyE1yYM;IAOI,8BAAA;EzEsyYV;EyE7yYM;IAOI,4BAAA;EzEyyYV;EyEhzYM;IAOI,4BAAA;EzE4yYV;EyEnzYM;IAOI,2BAAA;EzE+yYV;EyEtzYM;IAOI,0BAAA;EzEkzYV;EyEzzYM;IAOI,wBAAA;EzEqzYV;EyE5zYM;IAOI,0BAAA;EzEwzYV;EyE/zYM;IAOI,wBAAA;EzE2zYV;EyEl0YM;IAOI,iCAAA;IAAA,gCAAA;EzE+zYV;EyEt0YM;IAOI,gCAAA;IAAA,+BAAA;EzEm0YV;EyE10YM;IAOI,8BAAA;IAAA,6BAAA;EzEu0YV;EyE90YM;IAOI,gCAAA;IAAA,+BAAA;EzE20YV;EyEl1YM;IAOI,8BAAA;IAAA,6BAAA;EzE+0YV;EyEt1YM;IAOI,+BAAA;IAAA,kCAAA;EzEm1YV;EyE11YM;IAOI,8BAAA;IAAA,iCAAA;EzEu1YV;EyE91YM;IAOI,4BAAA;IAAA,+BAAA;EzE21YV;EyEl2YM;IAOI,8BAAA;IAAA,iCAAA;EzE+1YV;EyEt2YM;IAOI,4BAAA;IAAA,+BAAA;EzEm2YV;EyE12YM;IAOI,+BAAA;EzEs2YV;EyE72YM;IAOI,8BAAA;EzEy2YV;EyEh3YM;IAOI,4BAAA;EzE42YV;EyEn3YM;IAOI,8BAAA;EzE+2YV;EyEt3YM;IAOI,4BAAA;EzEk3YV;EyEz3YM;IAOI,iCAAA;EzEq3YV;EyE53YM;IAOI,gCAAA;EzEw3YV;EyE/3YM;IAOI,8BAAA;EzE23YV;EyEl4YM;IAOI,gCAAA;EzE83YV;EyEr4YM;IAOI,8BAAA;EzEi4YV;EyEx4YM;IAOI,kCAAA;EzEo4YV;EyE34YM;IAOI,iCAAA;EzEu4YV;EyE94YM;IAOI,+BAAA;EzE04YV;EyEj5YM;IAOI,iCAAA;EzE64YV;EyEp5YM;IAOI,+BAAA;EzEg5YV;EyEv5YM;IAOI,gCAAA;EzEm5YV;EyE15YM;IAOI,+BAAA;EzEs5YV;EyE75YM;IAOI,6BAAA;EzEy5YV;EyEh6YM;IAOI,+BAAA;EzE45YV;EyEn6YM;IAOI,6BAAA;EzE+5YV;EyEt6YM;IAOI,qBAAA;EzEk6YV;EyEz6YM;IAOI,2BAAA;EzEq6YV;EyE56YM;IAOI,0BAAA;EzEw6YV;EyE/6YM;IAOI,wBAAA;EzE26YV;EyEl7YM;IAOI,0BAAA;EzE86YV;EyEr7YM;IAOI,wBAAA;EzEi7YV;EyEx7YM;IAOI,2BAAA;IAAA,0BAAA;EzEq7YV;EyE57YM;IAOI,iCAAA;IAAA,gCAAA;EzEy7YV;EyEh8YM;IAOI,gCAAA;IAAA,+BAAA;EzE67YV;EyEp8YM;IAOI,8BAAA;IAAA,6BAAA;EzEi8YV;EyEx8YM;IAOI,gCAAA;IAAA,+BAAA;EzEq8YV;EyE58YM;IAOI,8BAAA;IAAA,6BAAA;EzEy8YV;EyEh9YM;IAOI,yBAAA;IAAA,4BAAA;EzE68YV;EyEp9YM;IAOI,+BAAA;IAAA,kCAAA;EzEi9YV;EyEx9YM;IAOI,8BAAA;IAAA,iCAAA;EzEq9YV;EyE59YM;IAOI,4BAAA;IAAA,+BAAA;EzEy9YV;EyEh+YM;IAOI,8BAAA;IAAA,iCAAA;EzE69YV;EyEp+YM;IAOI,4BAAA;IAAA,+BAAA;EzEi+YV;EyEx+YM;IAOI,yBAAA;EzEo+YV;EyE3+YM;IAOI,+BAAA;EzEu+YV;EyE9+YM;IAOI,8BAAA;EzE0+YV;EyEj/YM;IAOI,4BAAA;EzE6+YV;EyEp/YM;IAOI,8BAAA;EzEg/YV;EyEv/YM;IAOI,4BAAA;EzEm/YV;EyE1/YM;IAOI,2BAAA;EzEs/YV;EyE7/YM;IAOI,iCAAA;EzEy/YV;EyEhgZM;IAOI,gCAAA;EzE4/YV;EyEngZM;IAOI,8BAAA;EzE+/YV;EyEtgZM;IAOI,gCAAA;EzEkgZV;EyEzgZM;IAOI,8BAAA;EzEqgZV;EyE5gZM;IAOI,4BAAA;EzEwgZV;EyE/gZM;IAOI,kCAAA;EzE2gZV;EyElhZM;IAOI,iCAAA;EzE8gZV;EyErhZM;IAOI,+BAAA;EzEihZV;EyExhZM;IAOI,iCAAA;EzEohZV;EyE3hZM;IAOI,+BAAA;EzEuhZV;EyE9hZM;IAOI,0BAAA;EzE0hZV;EyEjiZM;IAOI,gCAAA;EzE6hZV;EyEpiZM;IAOI,+BAAA;EzEgiZV;EyEviZM;IAOI,6BAAA;EzEmiZV;EyE1iZM;IAOI,+BAAA;EzEsiZV;EyE7iZM;IAOI,6BAAA;EzEyiZV;EyEhjZM;IAOI,iBAAA;EzE4iZV;EyEnjZM;IAOI,uBAAA;EzE+iZV;EyEtjZM;IAOI,sBAAA;EzEkjZV;EyEzjZM;IAOI,oBAAA;EzEqjZV;EyE5jZM;IAOI,sBAAA;EzEwjZV;EyE/jZM;IAOI,oBAAA;EzE2jZV;EyElkZM;IAOI,qBAAA;EzE8jZV;EyErkZM;IAOI,2BAAA;EzEikZV;EyExkZM;IAOI,0BAAA;EzEokZV;EyE3kZM;IAOI,wBAAA;EzEukZV;EyE9kZM;IAOI,0BAAA;EzE0kZV;EyEjlZM;IAOI,wBAAA;EzE6kZV;EyEplZM;IAOI,wBAAA;EzEglZV;EyEvlZM;IAOI,8BAAA;EzEmlZV;EyE1lZM;IAOI,6BAAA;EzEslZV;EyE7lZM;IAOI,2BAAA;EzEylZV;EyEhmZM;IAOI,6BAAA;EzE4lZV;EyEnmZM;IAOI,2BAAA;EzE+lZV;EyEtmZM;IAOI,2BAAA;EzEkmZV;EyEzmZM;IAOI,4BAAA;EzEqmZV;EyE5mZM;IAOI,6BAAA;EzEwmZV;AACF;AennZI;E0DGI;IAOI,sBAAA;EzE6mZV;EyEpnZM;IAOI,uBAAA;EzEgnZV;EyEvnZM;IAOI,sBAAA;EzEmnZV;EyE1nZM;IAOI,8BAAA;EzEsnZV;EyE7nZM;IAOI,4BAAA;EzEynZV;EyEhoZM;IAOI,2BAAA;EzE4nZV;EyEnoZM;IAOI,iCAAA;EzE+nZV;EyEtoZM;IAOI,2BAAA;EzEkoZV;EyEzoZM;IAOI,0BAAA;EzEqoZV;EyE5oZM;IAOI,gCAAA;EzEwoZV;EyE/oZM;IAOI,yBAAA;EzE2oZV;EyElpZM;IAOI,wBAAA;EzE8oZV;EyErpZM;IAOI,+BAAA;EzEipZV;EyExpZM;IAOI,yBAAA;EzEopZV;EyE3pZM;IAOI,6BAAA;EzEupZV;EyE9pZM;IAOI,8BAAA;EzE0pZV;EyEjqZM;IAOI,wBAAA;EzE6pZV;EyEpqZM;IAOI,+BAAA;EzEgqZV;EyEvqZM;IAOI,wBAAA;EzEmqZV;EyE1qZM;IAOI,yBAAA;EzEsqZV;EyE7qZM;IAOI,8BAAA;EzEyqZV;EyEhrZM;IAOI,iCAAA;EzE4qZV;EyEnrZM;IAOI,sCAAA;EzE+qZV;EyEtrZM;IAOI,yCAAA;EzEkrZV;EyEzrZM;IAOI,uBAAA;EzEqrZV;EyE5rZM;IAOI,uBAAA;EzEwrZV;EyE/rZM;IAOI,yBAAA;EzE2rZV;EyElsZM;IAOI,yBAAA;EzE8rZV;EyErsZM;IAOI,0BAAA;EzEisZV;EyExsZM;IAOI,4BAAA;EzEosZV;EyE3sZM;IAOI,kCAAA;EzEusZV;EyE9sZM;IAOI,sCAAA;EzE0sZV;EyEjtZM;IAOI,oCAAA;EzE6sZV;EyEptZM;IAOI,kCAAA;EzEgtZV;EyEvtZM;IAOI,yCAAA;EzEmtZV;EyE1tZM;IAOI,wCAAA;EzEstZV;EyE7tZM;IAOI,wCAAA;EzEytZV;EyEhuZM;IAOI,kCAAA;EzE4tZV;EyEnuZM;IAOI,gCAAA;EzE+tZV;EyEtuZM;IAOI,8BAAA;EzEkuZV;EyEzuZM;IAOI,gCAAA;EzEquZV;EyE5uZM;IAOI,+BAAA;EzEwuZV;EyE/uZM;IAOI,oCAAA;EzE2uZV;EyElvZM;IAOI,kCAAA;EzE8uZV;EyErvZM;IAOI,gCAAA;EzEivZV;EyExvZM;IAOI,uCAAA;EzEovZV;EyE3vZM;IAOI,sCAAA;EzEuvZV;EyE9vZM;IAOI,iCAAA;EzE0vZV;EyEjwZM;IAOI,2BAAA;EzE6vZV;EyEpwZM;IAOI,iCAAA;EzEgwZV;EyEvwZM;IAOI,+BAAA;EzEmwZV;EyE1wZM;IAOI,6BAAA;EzEswZV;EyE7wZM;IAOI,+BAAA;EzEywZV;EyEhxZM;IAOI,8BAAA;EzE4wZV;EyEnxZM;IAOI,oBAAA;EzE+wZV;EyEtxZM;IAOI,mBAAA;EzEkxZV;EyEzxZM;IAOI,mBAAA;EzEqxZV;EyE5xZM;IAOI,mBAAA;EzEwxZV;EyE/xZM;IAOI,mBAAA;EzE2xZV;EyElyZM;IAOI,mBAAA;EzE8xZV;EyEryZM;IAOI,mBAAA;EzEiyZV;EyExyZM;IAOI,mBAAA;EzEoyZV;EyE3yZM;IAOI,oBAAA;EzEuyZV;EyE9yZM;IAOI,0BAAA;EzE0yZV;EyEjzZM;IAOI,yBAAA;EzE6yZV;EyEpzZM;IAOI,uBAAA;EzEgzZV;EyEvzZM;IAOI,yBAAA;EzEmzZV;EyE1zZM;IAOI,uBAAA;EzEszZV;EyE7zZM;IAOI,uBAAA;EzEyzZV;EyEh0ZM;IAOI,0BAAA;IAAA,yBAAA;EzE6zZV;EyEp0ZM;IAOI,gCAAA;IAAA,+BAAA;EzEi0ZV;EyEx0ZM;IAOI,+BAAA;IAAA,8BAAA;EzEq0ZV;EyE50ZM;IAOI,6BAAA;IAAA,4BAAA;EzEy0ZV;EyEh1ZM;IAOI,+BAAA;IAAA,8BAAA;EzE60ZV;EyEp1ZM;IAOI,6BAAA;IAAA,4BAAA;EzEi1ZV;EyEx1ZM;IAOI,6BAAA;IAAA,4BAAA;EzEq1ZV;EyE51ZM;IAOI,wBAAA;IAAA,2BAAA;EzEy1ZV;EyEh2ZM;IAOI,8BAAA;IAAA,iCAAA;EzE61ZV;EyEp2ZM;IAOI,6BAAA;IAAA,gCAAA;EzEi2ZV;EyEx2ZM;IAOI,2BAAA;IAAA,8BAAA;EzEq2ZV;EyE52ZM;IAOI,6BAAA;IAAA,gCAAA;EzEy2ZV;EyEh3ZM;IAOI,2BAAA;IAAA,8BAAA;EzE62ZV;EyEp3ZM;IAOI,2BAAA;IAAA,8BAAA;EzEi3ZV;EyEx3ZM;IAOI,wBAAA;EzEo3ZV;EyE33ZM;IAOI,8BAAA;EzEu3ZV;EyE93ZM;IAOI,6BAAA;EzE03ZV;EyEj4ZM;IAOI,2BAAA;EzE63ZV;EyEp4ZM;IAOI,6BAAA;EzEg4ZV;EyEv4ZM;IAOI,2BAAA;EzEm4ZV;EyE14ZM;IAOI,2BAAA;EzEs4ZV;EyE74ZM;IAOI,0BAAA;EzEy4ZV;EyEh5ZM;IAOI,gCAAA;EzE44ZV;EyEn5ZM;IAOI,+BAAA;EzE+4ZV;EyEt5ZM;IAOI,6BAAA;EzEk5ZV;EyEz5ZM;IAOI,+BAAA;EzEq5ZV;EyE55ZM;IAOI,6BAAA;EzEw5ZV;EyE/5ZM;IAOI,6BAAA;EzE25ZV;EyEl6ZM;IAOI,2BAAA;EzE85ZV;EyEr6ZM;IAOI,iCAAA;EzEi6ZV;EyEx6ZM;IAOI,gCAAA;EzEo6ZV;EyE36ZM;IAOI,8BAAA;EzEu6ZV;EyE96ZM;IAOI,gCAAA;EzE06ZV;EyEj7ZM;IAOI,8BAAA;EzE66ZV;EyEp7ZM;IAOI,8BAAA;EzEg7ZV;EyEv7ZM;IAOI,yBAAA;EzEm7ZV;EyE17ZM;IAOI,+BAAA;EzEs7ZV;EyE77ZM;IAOI,8BAAA;EzEy7ZV;EyEh8ZM;IAOI,4BAAA;EzE47ZV;EyEn8ZM;IAOI,8BAAA;EzE+7ZV;EyEt8ZM;IAOI,4BAAA;EzEk8ZV;EyEz8ZM;IAOI,4BAAA;EzEq8ZV;EyE58ZM;IAOI,2BAAA;EzEw8ZV;EyE/8ZM;IAOI,0BAAA;EzE28ZV;EyEl9ZM;IAOI,wBAAA;EzE88ZV;EyEr9ZM;IAOI,0BAAA;EzEi9ZV;EyEx9ZM;IAOI,wBAAA;EzEo9ZV;EyE39ZM;IAOI,iCAAA;IAAA,gCAAA;EzEw9ZV;EyE/9ZM;IAOI,gCAAA;IAAA,+BAAA;EzE49ZV;EyEn+ZM;IAOI,8BAAA;IAAA,6BAAA;EzEg+ZV;EyEv+ZM;IAOI,gCAAA;IAAA,+BAAA;EzEo+ZV;EyE3+ZM;IAOI,8BAAA;IAAA,6BAAA;EzEw+ZV;EyE/+ZM;IAOI,+BAAA;IAAA,kCAAA;EzE4+ZV;EyEn/ZM;IAOI,8BAAA;IAAA,iCAAA;EzEg/ZV;EyEv/ZM;IAOI,4BAAA;IAAA,+BAAA;EzEo/ZV;EyE3/ZM;IAOI,8BAAA;IAAA,iCAAA;EzEw/ZV;EyE//ZM;IAOI,4BAAA;IAAA,+BAAA;EzE4/ZV;EyEngaM;IAOI,+BAAA;EzE+/ZV;EyEtgaM;IAOI,8BAAA;EzEkgaV;EyEzgaM;IAOI,4BAAA;EzEqgaV;EyE5gaM;IAOI,8BAAA;EzEwgaV;EyE/gaM;IAOI,4BAAA;EzE2gaV;EyElhaM;IAOI,iCAAA;EzE8gaV;EyErhaM;IAOI,gCAAA;EzEihaV;EyExhaM;IAOI,8BAAA;EzEohaV;EyE3haM;IAOI,gCAAA;EzEuhaV;EyE9haM;IAOI,8BAAA;EzE0haV;EyEjiaM;IAOI,kCAAA;EzE6haV;EyEpiaM;IAOI,iCAAA;EzEgiaV;EyEviaM;IAOI,+BAAA;EzEmiaV;EyE1iaM;IAOI,iCAAA;EzEsiaV;EyE7iaM;IAOI,+BAAA;EzEyiaV;EyEhjaM;IAOI,gCAAA;EzE4iaV;EyEnjaM;IAOI,+BAAA;EzE+iaV;EyEtjaM;IAOI,6BAAA;EzEkjaV;EyEzjaM;IAOI,+BAAA;EzEqjaV;EyE5jaM;IAOI,6BAAA;EzEwjaV;EyE/jaM;IAOI,qBAAA;EzE2jaV;EyElkaM;IAOI,2BAAA;EzE8jaV;EyErkaM;IAOI,0BAAA;EzEikaV;EyExkaM;IAOI,wBAAA;EzEokaV;EyE3kaM;IAOI,0BAAA;EzEukaV;EyE9kaM;IAOI,wBAAA;EzE0kaV;EyEjlaM;IAOI,2BAAA;IAAA,0BAAA;EzE8kaV;EyErlaM;IAOI,iCAAA;IAAA,gCAAA;EzEklaV;EyEzlaM;IAOI,gCAAA;IAAA,+BAAA;EzEslaV;EyE7laM;IAOI,8BAAA;IAAA,6BAAA;EzE0laV;EyEjmaM;IAOI,gCAAA;IAAA,+BAAA;EzE8laV;EyErmaM;IAOI,8BAAA;IAAA,6BAAA;EzEkmaV;EyEzmaM;IAOI,yBAAA;IAAA,4BAAA;EzEsmaV;EyE7maM;IAOI,+BAAA;IAAA,kCAAA;EzE0maV;EyEjnaM;IAOI,8BAAA;IAAA,iCAAA;EzE8maV;EyErnaM;IAOI,4BAAA;IAAA,+BAAA;EzEknaV;EyEznaM;IAOI,8BAAA;IAAA,iCAAA;EzEsnaV;EyE7naM;IAOI,4BAAA;IAAA,+BAAA;EzE0naV;EyEjoaM;IAOI,yBAAA;EzE6naV;EyEpoaM;IAOI,+BAAA;EzEgoaV;EyEvoaM;IAOI,8BAAA;EzEmoaV;EyE1oaM;IAOI,4BAAA;EzEsoaV;EyE7oaM;IAOI,8BAAA;EzEyoaV;EyEhpaM;IAOI,4BAAA;EzE4oaV;EyEnpaM;IAOI,2BAAA;EzE+oaV;EyEtpaM;IAOI,iCAAA;EzEkpaV;EyEzpaM;IAOI,gCAAA;EzEqpaV;EyE5paM;IAOI,8BAAA;EzEwpaV;EyE/paM;IAOI,gCAAA;EzE2paV;EyElqaM;IAOI,8BAAA;EzE8paV;EyErqaM;IAOI,4BAAA;EzEiqaV;EyExqaM;IAOI,kCAAA;EzEoqaV;EyE3qaM;IAOI,iCAAA;EzEuqaV;EyE9qaM;IAOI,+BAAA;EzE0qaV;EyEjraM;IAOI,iCAAA;EzE6qaV;EyEpraM;IAOI,+BAAA;EzEgraV;EyEvraM;IAOI,0BAAA;EzEmraV;EyE1raM;IAOI,gCAAA;EzEsraV;EyE7raM;IAOI,+BAAA;EzEyraV;EyEhsaM;IAOI,6BAAA;EzE4raV;EyEnsaM;IAOI,+BAAA;EzE+raV;EyEtsaM;IAOI,6BAAA;EzEksaV;EyEzsaM;IAOI,iBAAA;EzEqsaV;EyE5saM;IAOI,uBAAA;EzEwsaV;EyE/saM;IAOI,sBAAA;EzE2saV;EyEltaM;IAOI,oBAAA;EzE8saV;EyErtaM;IAOI,sBAAA;EzEitaV;EyExtaM;IAOI,oBAAA;EzEotaV;EyE3taM;IAOI,qBAAA;EzEutaV;EyE9taM;IAOI,2BAAA;EzE0taV;EyEjuaM;IAOI,0BAAA;EzE6taV;EyEpuaM;IAOI,wBAAA;EzEguaV;EyEvuaM;IAOI,0BAAA;EzEmuaV;EyE1uaM;IAOI,wBAAA;EzEsuaV;EyE7uaM;IAOI,wBAAA;EzEyuaV;EyEhvaM;IAOI,8BAAA;EzE4uaV;EyEnvaM;IAOI,6BAAA;EzE+uaV;EyEtvaM;IAOI,2BAAA;EzEkvaV;EyEzvaM;IAOI,6BAAA;EzEqvaV;EyE5vaM;IAOI,2BAAA;EzEwvaV;EyE/vaM;IAOI,2BAAA;EzE2vaV;EyElwaM;IAOI,4BAAA;EzE8vaV;EyErwaM;IAOI,6BAAA;EzEiwaV;AACF;Ae5waI;E0DGI;IAOI,sBAAA;EzEswaV;EyE7waM;IAOI,uBAAA;EzEywaV;EyEhxaM;IAOI,sBAAA;EzE4waV;EyEnxaM;IAOI,8BAAA;EzE+waV;EyEtxaM;IAOI,4BAAA;EzEkxaV;EyEzxaM;IAOI,2BAAA;EzEqxaV;EyE5xaM;IAOI,iCAAA;EzEwxaV;EyE/xaM;IAOI,2BAAA;EzE2xaV;EyElyaM;IAOI,0BAAA;EzE8xaV;EyEryaM;IAOI,gCAAA;EzEiyaV;EyExyaM;IAOI,yBAAA;EzEoyaV;EyE3yaM;IAOI,wBAAA;EzEuyaV;EyE9yaM;IAOI,+BAAA;EzE0yaV;EyEjzaM;IAOI,yBAAA;EzE6yaV;EyEpzaM;IAOI,6BAAA;EzEgzaV;EyEvzaM;IAOI,8BAAA;EzEmzaV;EyE1zaM;IAOI,wBAAA;EzEszaV;EyE7zaM;IAOI,+BAAA;EzEyzaV;EyEh0aM;IAOI,wBAAA;EzE4zaV;EyEn0aM;IAOI,yBAAA;EzE+zaV;EyEt0aM;IAOI,8BAAA;EzEk0aV;EyEz0aM;IAOI,iCAAA;EzEq0aV;EyE50aM;IAOI,sCAAA;EzEw0aV;EyE/0aM;IAOI,yCAAA;EzE20aV;EyEl1aM;IAOI,uBAAA;EzE80aV;EyEr1aM;IAOI,uBAAA;EzEi1aV;EyEx1aM;IAOI,yBAAA;EzEo1aV;EyE31aM;IAOI,yBAAA;EzEu1aV;EyE91aM;IAOI,0BAAA;EzE01aV;EyEj2aM;IAOI,4BAAA;EzE61aV;EyEp2aM;IAOI,kCAAA;EzEg2aV;EyEv2aM;IAOI,sCAAA;EzEm2aV;EyE12aM;IAOI,oCAAA;EzEs2aV;EyE72aM;IAOI,kCAAA;EzEy2aV;EyEh3aM;IAOI,yCAAA;EzE42aV;EyEn3aM;IAOI,wCAAA;EzE+2aV;EyEt3aM;IAOI,wCAAA;EzEk3aV;EyEz3aM;IAOI,kCAAA;EzEq3aV;EyE53aM;IAOI,gCAAA;EzEw3aV;EyE/3aM;IAOI,8BAAA;EzE23aV;EyEl4aM;IAOI,gCAAA;EzE83aV;EyEr4aM;IAOI,+BAAA;EzEi4aV;EyEx4aM;IAOI,oCAAA;EzEo4aV;EyE34aM;IAOI,kCAAA;EzEu4aV;EyE94aM;IAOI,gCAAA;EzE04aV;EyEj5aM;IAOI,uCAAA;EzE64aV;EyEp5aM;IAOI,sCAAA;EzEg5aV;EyEv5aM;IAOI,iCAAA;EzEm5aV;EyE15aM;IAOI,2BAAA;EzEs5aV;EyE75aM;IAOI,iCAAA;EzEy5aV;EyEh6aM;IAOI,+BAAA;EzE45aV;EyEn6aM;IAOI,6BAAA;EzE+5aV;EyEt6aM;IAOI,+BAAA;EzEk6aV;EyEz6aM;IAOI,8BAAA;EzEq6aV;EyE56aM;IAOI,oBAAA;EzEw6aV;EyE/6aM;IAOI,mBAAA;EzE26aV;EyEl7aM;IAOI,mBAAA;EzE86aV;EyEr7aM;IAOI,mBAAA;EzEi7aV;EyEx7aM;IAOI,mBAAA;EzEo7aV;EyE37aM;IAOI,mBAAA;EzEu7aV;EyE97aM;IAOI,mBAAA;EzE07aV;EyEj8aM;IAOI,mBAAA;EzE67aV;EyEp8aM;IAOI,oBAAA;EzEg8aV;EyEv8aM;IAOI,0BAAA;EzEm8aV;EyE18aM;IAOI,yBAAA;EzEs8aV;EyE78aM;IAOI,uBAAA;EzEy8aV;EyEh9aM;IAOI,yBAAA;EzE48aV;EyEn9aM;IAOI,uBAAA;EzE+8aV;EyEt9aM;IAOI,uBAAA;EzEk9aV;EyEz9aM;IAOI,0BAAA;IAAA,yBAAA;EzEs9aV;EyE79aM;IAOI,gCAAA;IAAA,+BAAA;EzE09aV;EyEj+aM;IAOI,+BAAA;IAAA,8BAAA;EzE89aV;EyEr+aM;IAOI,6BAAA;IAAA,4BAAA;EzEk+aV;EyEz+aM;IAOI,+BAAA;IAAA,8BAAA;EzEs+aV;EyE7+aM;IAOI,6BAAA;IAAA,4BAAA;EzE0+aV;EyEj/aM;IAOI,6BAAA;IAAA,4BAAA;EzE8+aV;EyEr/aM;IAOI,wBAAA;IAAA,2BAAA;EzEk/aV;EyEz/aM;IAOI,8BAAA;IAAA,iCAAA;EzEs/aV;EyE7/aM;IAOI,6BAAA;IAAA,gCAAA;EzE0/aV;EyEjgbM;IAOI,2BAAA;IAAA,8BAAA;EzE8/aV;EyErgbM;IAOI,6BAAA;IAAA,gCAAA;EzEkgbV;EyEzgbM;IAOI,2BAAA;IAAA,8BAAA;EzEsgbV;EyE7gbM;IAOI,2BAAA;IAAA,8BAAA;EzE0gbV;EyEjhbM;IAOI,wBAAA;EzE6gbV;EyEphbM;IAOI,8BAAA;EzEghbV;EyEvhbM;IAOI,6BAAA;EzEmhbV;EyE1hbM;IAOI,2BAAA;EzEshbV;EyE7hbM;IAOI,6BAAA;EzEyhbV;EyEhibM;IAOI,2BAAA;EzE4hbV;EyEnibM;IAOI,2BAAA;EzE+hbV;EyEtibM;IAOI,0BAAA;EzEkibV;EyEzibM;IAOI,gCAAA;EzEqibV;EyE5ibM;IAOI,+BAAA;EzEwibV;EyE/ibM;IAOI,6BAAA;EzE2ibV;EyEljbM;IAOI,+BAAA;EzE8ibV;EyErjbM;IAOI,6BAAA;EzEijbV;EyExjbM;IAOI,6BAAA;EzEojbV;EyE3jbM;IAOI,2BAAA;EzEujbV;EyE9jbM;IAOI,iCAAA;EzE0jbV;EyEjkbM;IAOI,gCAAA;EzE6jbV;EyEpkbM;IAOI,8BAAA;EzEgkbV;EyEvkbM;IAOI,gCAAA;EzEmkbV;EyE1kbM;IAOI,8BAAA;EzEskbV;EyE7kbM;IAOI,8BAAA;EzEykbV;EyEhlbM;IAOI,yBAAA;EzE4kbV;EyEnlbM;IAOI,+BAAA;EzE+kbV;EyEtlbM;IAOI,8BAAA;EzEklbV;EyEzlbM;IAOI,4BAAA;EzEqlbV;EyE5lbM;IAOI,8BAAA;EzEwlbV;EyE/lbM;IAOI,4BAAA;EzE2lbV;EyElmbM;IAOI,4BAAA;EzE8lbV;EyErmbM;IAOI,2BAAA;EzEimbV;EyExmbM;IAOI,0BAAA;EzEombV;EyE3mbM;IAOI,wBAAA;EzEumbV;EyE9mbM;IAOI,0BAAA;EzE0mbV;EyEjnbM;IAOI,wBAAA;EzE6mbV;EyEpnbM;IAOI,iCAAA;IAAA,gCAAA;EzEinbV;EyExnbM;IAOI,gCAAA;IAAA,+BAAA;EzEqnbV;EyE5nbM;IAOI,8BAAA;IAAA,6BAAA;EzEynbV;EyEhobM;IAOI,gCAAA;IAAA,+BAAA;EzE6nbV;EyEpobM;IAOI,8BAAA;IAAA,6BAAA;EzEiobV;EyExobM;IAOI,+BAAA;IAAA,kCAAA;EzEqobV;EyE5obM;IAOI,8BAAA;IAAA,iCAAA;EzEyobV;EyEhpbM;IAOI,4BAAA;IAAA,+BAAA;EzE6obV;EyEppbM;IAOI,8BAAA;IAAA,iCAAA;EzEipbV;EyExpbM;IAOI,4BAAA;IAAA,+BAAA;EzEqpbV;EyE5pbM;IAOI,+BAAA;EzEwpbV;EyE/pbM;IAOI,8BAAA;EzE2pbV;EyElqbM;IAOI,4BAAA;EzE8pbV;EyErqbM;IAOI,8BAAA;EzEiqbV;EyExqbM;IAOI,4BAAA;EzEoqbV;EyE3qbM;IAOI,iCAAA;EzEuqbV;EyE9qbM;IAOI,gCAAA;EzE0qbV;EyEjrbM;IAOI,8BAAA;EzE6qbV;EyEprbM;IAOI,gCAAA;EzEgrbV;EyEvrbM;IAOI,8BAAA;EzEmrbV;EyE1rbM;IAOI,kCAAA;EzEsrbV;EyE7rbM;IAOI,iCAAA;EzEyrbV;EyEhsbM;IAOI,+BAAA;EzE4rbV;EyEnsbM;IAOI,iCAAA;EzE+rbV;EyEtsbM;IAOI,+BAAA;EzEksbV;EyEzsbM;IAOI,gCAAA;EzEqsbV;EyE5sbM;IAOI,+BAAA;EzEwsbV;EyE/sbM;IAOI,6BAAA;EzE2sbV;EyEltbM;IAOI,+BAAA;EzE8sbV;EyErtbM;IAOI,6BAAA;EzEitbV;EyExtbM;IAOI,qBAAA;EzEotbV;EyE3tbM;IAOI,2BAAA;EzEutbV;EyE9tbM;IAOI,0BAAA;EzE0tbV;EyEjubM;IAOI,wBAAA;EzE6tbV;EyEpubM;IAOI,0BAAA;EzEgubV;EyEvubM;IAOI,wBAAA;EzEmubV;EyE1ubM;IAOI,2BAAA;IAAA,0BAAA;EzEuubV;EyE9ubM;IAOI,iCAAA;IAAA,gCAAA;EzE2ubV;EyElvbM;IAOI,gCAAA;IAAA,+BAAA;EzE+ubV;EyEtvbM;IAOI,8BAAA;IAAA,6BAAA;EzEmvbV;EyE1vbM;IAOI,gCAAA;IAAA,+BAAA;EzEuvbV;EyE9vbM;IAOI,8BAAA;IAAA,6BAAA;EzE2vbV;EyElwbM;IAOI,yBAAA;IAAA,4BAAA;EzE+vbV;EyEtwbM;IAOI,+BAAA;IAAA,kCAAA;EzEmwbV;EyE1wbM;IAOI,8BAAA;IAAA,iCAAA;EzEuwbV;EyE9wbM;IAOI,4BAAA;IAAA,+BAAA;EzE2wbV;EyElxbM;IAOI,8BAAA;IAAA,iCAAA;EzE+wbV;EyEtxbM;IAOI,4BAAA;IAAA,+BAAA;EzEmxbV;EyE1xbM;IAOI,yBAAA;EzEsxbV;EyE7xbM;IAOI,+BAAA;EzEyxbV;EyEhybM;IAOI,8BAAA;EzE4xbV;EyEnybM;IAOI,4BAAA;EzE+xbV;EyEtybM;IAOI,8BAAA;EzEkybV;EyEzybM;IAOI,4BAAA;EzEqybV;EyE5ybM;IAOI,2BAAA;EzEwybV;EyE/ybM;IAOI,iCAAA;EzE2ybV;EyElzbM;IAOI,gCAAA;EzE8ybV;EyErzbM;IAOI,8BAAA;EzEizbV;EyExzbM;IAOI,gCAAA;EzEozbV;EyE3zbM;IAOI,8BAAA;EzEuzbV;EyE9zbM;IAOI,4BAAA;EzE0zbV;EyEj0bM;IAOI,kCAAA;EzE6zbV;EyEp0bM;IAOI,iCAAA;EzEg0bV;EyEv0bM;IAOI,+BAAA;EzEm0bV;EyE10bM;IAOI,iCAAA;EzEs0bV;EyE70bM;IAOI,+BAAA;EzEy0bV;EyEh1bM;IAOI,0BAAA;EzE40bV;EyEn1bM;IAOI,gCAAA;EzE+0bV;EyEt1bM;IAOI,+BAAA;EzEk1bV;EyEz1bM;IAOI,6BAAA;EzEq1bV;EyE51bM;IAOI,+BAAA;EzEw1bV;EyE/1bM;IAOI,6BAAA;EzE21bV;EyEl2bM;IAOI,iBAAA;EzE81bV;EyEr2bM;IAOI,uBAAA;EzEi2bV;EyEx2bM;IAOI,sBAAA;EzEo2bV;EyE32bM;IAOI,oBAAA;EzEu2bV;EyE92bM;IAOI,sBAAA;EzE02bV;EyEj3bM;IAOI,oBAAA;EzE62bV;EyEp3bM;IAOI,qBAAA;EzEg3bV;EyEv3bM;IAOI,2BAAA;EzEm3bV;EyE13bM;IAOI,0BAAA;EzEs3bV;EyE73bM;IAOI,wBAAA;EzEy3bV;EyEh4bM;IAOI,0BAAA;EzE43bV;EyEn4bM;IAOI,wBAAA;EzE+3bV;EyEt4bM;IAOI,wBAAA;EzEk4bV;EyEz4bM;IAOI,8BAAA;EzEq4bV;EyE54bM;IAOI,6BAAA;EzEw4bV;EyE/4bM;IAOI,2BAAA;EzE24bV;EyEl5bM;IAOI,6BAAA;EzE84bV;EyEr5bM;IAOI,2BAAA;EzEi5bV;EyEx5bM;IAOI,2BAAA;EzEo5bV;EyE35bM;IAOI,4BAAA;EzEu5bV;EyE95bM;IAOI,6BAAA;EzE05bV;AACF;A0Ej9bA;ED+CQ;IAOI,4BAAA;EzE+5bV;EyEt6bM;IAOI,6BAAA;EzEk6bV;EyEz6bM;IAOI,6BAAA;EzEq6bV;EyE56bM;IAOI,6BAAA;EzEw6bV;AACF;A0E58bA;ED4BQ;IAOI,0BAAA;EzE66bV;EyEp7bM;IAOI,gCAAA;EzEg7bV;EyEv7bM;IAOI,yBAAA;EzEm7bV;EyE17bM;IAOI,wBAAA;EzEs7bV;EyE77bM;IAOI,+BAAA;EzEy7bV;EyEh8bM;IAOI,yBAAA;EzE47bV;EyEn8bM;IAOI,6BAAA;EzE+7bV;EyEt8bM;IAOI,8BAAA;EzEk8bV;EyEz8bM;IAOI,wBAAA;EzEq8bV;EyE58bM;IAOI,+BAAA;EzEw8bV;EyE/8bM;IAOI,wBAAA;EzE28bV;AACF;ACn0bA;EACE,+CAAA;ADq0bF;;AC7zbE;EACE,iBAAA;EACA,kBAAA;ADg0bJ;;AC5zbA;EACE,4BAAA;EACA,yBAAA;EACA,gEA3E4B;AD04b9B;AC9zbE;EACE,8BAAA;ADg0bJ;;A2EricA;EACI;IACI,mBAAA;IACA,kBAAA;E3EwicN;AACF;AAjicA;EACE,wBAAA;EACA,gEAAA;EACA,gBAAA;EACA,kBAAA;AAmicF;AAhicA;EACE,wBAAA;EACA,gEAAA;EACA,gBAAA;EACA,kBAAA;AAkicF;AA/hcA;EACE,wBAAA;EACA,gEAAA;EACA,gBAAA;EACA,kBAAA;AAiicF;AA9hcA;EACE,wBAAA;EACA,gEAAA;EACA,gBAAA;EACA,kBAAA;AAgicF;AA7hcA;EACE,wBAAA;EACA,gEAAA;EACA,gBAAA;EACA,kBAAA;AA+hcF;AA5hcA;EACE,iBAAA;EACA,oCAAA;AA8hcF;;AA3hcA;EACE,gBAAA;AA8hcF;;AA3hcA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,cAAA;EACA,WAAA;AA8hcF;;AA3hcA;EACE,eAAA;AA8hcF;;AA3hcA;EACE,eAAA;AA8hcF;;AA3hcA;EACE,UAAA;AA8hcF;;AAzhcE;EACE,UAFS;AA8hcb;;AAxhcE;EACE,WAAA;AA2hcJ;;AAvhcE;EACE,YAAA;AA0hcJ;;AAthcE;EACE,aAAA;AAyhcJ;;AAzicE;EACE,UAFS;AA8icb;;AAxicE;EACE,WAAA;AA2icJ;;AAvicE;EACE,YAAA;AA0icJ;;AAticE;EACE,aAAA;AAyicJ;;AAzjcE;EACE,UAFS;AA8jcb;;AAxjcE;EACE,WAAA;AA2jcJ;;AAvjcE;EACE,YAAA;AA0jcJ;;AAtjcE;EACE,aAAA;AAyjcJ;;AAzkcE;EACE,UAFS;AA8kcb;;AAxkcE;EACE,WAAA;AA2kcJ;;AAvkcE;EACE,YAAA;AA0kcJ;;AAtkcE;EACE,aAAA;AAykcJ;;AAzlcE;EACE,UAFS;AA8lcb;;AAxlcE;EACE,WAAA;AA2lcJ;;AAvlcE;EACE,YAAA;AA0lcJ;;AAtlcE;EACE,aAAA;AAylcJ;;AAzmcE;EACE,UAFS;AA8mcb;;AAxmcE;EACE,WAAA;AA2mcJ;;AAvmcE;EACE,YAAA;AA0mcJ;;AAtmcE;EACE,aAAA;AAymcJ;;AAzncE;EACE,UAFS;AA8ncb;;AAxncE;EACE,WAAA;AA2ncJ;;AAvncE;EACE,YAAA;AA0ncJ;;AAtncE;EACE,aAAA;AAyncJ;;AAzocE;EACE,UAFS;AA8ocb;;AAxocE;EACE,WAAA;AA2ocJ;;AAvocE;EACE,YAAA;AA0ocJ;;AAtocE;EACE,aAAA;AAyocJ;;AAzpcE;EACE,UAFS;AA8pcb;;AAxpcE;EACE,WAAA;AA2pcJ;;AAvpcE;EACE,YAAA;AA0pcJ;;AAtpcE;EACE,aAAA;AAypcJ;;AAnpcA;EAEE,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,UAAA;EAKA,UAAA;EAKA,WAAA;EAMA,oBAAA;AAuocF;AAtpcE;EACE,UAAA;AAwpcJ;AAppcE;EACE,uBAAA;AAspcJ;AAlpcE;EACE,mBCpHO;EDqHP,kBAAA;AAopcJ;AAhpcE;EACE,mBCzHO;AD2wcX;;AA3ocE;EACE,0BAAA;AA8ocJ;;AA/ocE;EACE,0BAAA;AAkpcJ;;AAnpcE;EACE,0BAAA;AAspcJ;;AAvpcE;EACE,0BAAA;AA0pcJ;;AA3pcE;EACE,0BAAA;AA8pcJ;;AA/pcE;EACE,0BAAA;AAkqcJ;;AAnqcE;EACE,0BAAA;AAsqcJ;;AAvqcE;EACE,0BAAA;AA0qcJ;;AA3qcE;EACE,0BAAA;AA8qcJ;;AA/qcE;EACE,0BAAA;AAkrcJ;;AAnrcE;EACE,0BAAA;AAsrcJ;;AAvrcE;EACE,0BAAA;AA0rcJ;;AA3rcE;EACE,0BAAA;AA8rcJ;;AA/rcE;EACE,0BAAA;AAkscJ;;AAnscE;EACE,0BAAA;AAsscJ;;AAvscE;EACE,0BAAA;AA0scJ;;AA3scE;EACE,0BAAA;AA8scJ;;AA/scE;EACE,0BAAA;AAktcJ;;AAntcE;EACE,0BAAA;AAstcJ;;AAvtcE;EACE,0BAAA;AA0tcJ;;AA3tcE;EACE,0BAAA;AA8tcJ;;AA/tcE;EACE,0BAAA;AAkucJ;;AAnucE;EACE,0BAAA;AAsucJ;;AAvucE;EACE,0BAAA;AA0ucJ;;AA3ucE;EACE,0BAAA;AA8ucJ;;AA/ucE;EACE,0BAAA;AAkvcJ;;AAnvcE;EACE,0BAAA;AAsvcJ;;AAvvcE;EACE,0BAAA;AA0vcJ;;AA3vcE;EACE,0BAAA;AA8vcJ;;AA/vcE;EACE,0BAAA;AAkwcJ;;AAnwcE;EACE,0BAAA;AAswcJ;;AAvwcE;EACE,0BAAA;AA0wcJ;;AA3wcE;EACE,0BAAA;AA8wcJ;;AA/wcE;EACE,0BAAA;AAkxcJ;;AAnxcE;EACE,0BAAA;AAsxcJ;;AAvxcE;EACE,0BAAA;AA0xcJ;;AA3xcE;EACE,0BAAA;AA8xcJ;;AA/xcE;EACE,0BAAA;AAkycJ;;AAnycE;EACE,0BAAA;AAsycJ;;AAvycE;EACE,0BAAA;AA0ycJ;;AA3ycE;EACE,2BAAA;AA8ycJ;;AA/ycE;EACE,2BAAA;AAkzcJ;;AAnzcE;EACE,2BAAA;AAszcJ;;AAvzcE;EACE,2BAAA;AA0zcJ;;AA3zcE;EACE,2BAAA;AA8zcJ;;AA/zcE;EACE,2BAAA;AAk0cJ;;AAn0cE;EACE,2BAAA;AAs0cJ;;AAv0cE;EACE,2BAAA;AA00cJ;;AA30cE;EACE,2BAAA;AA80cJ;;AA/0cE;EACE,2BAAA;AAk1cJ;;AAn1cE;EACE,2BAAA;AAs1cJ;;AAv1cE;EACE,2BAAA;AA01cJ;;AA31cE;EACE,2BAAA;AA81cJ;;AA/1cE;EACE,2BAAA;AAk2cJ;;AAn2cE;EACE,2BAAA;AAs2cJ;;AAv2cE;EACE,2BAAA;AA02cJ;;AA32cE;EACE,2BAAA;AA82cJ;;AA/2cE;EACE,2BAAA;AAk3cJ;;AAn3cE;EACE,2BAAA;AAs3cJ;;AAv3cE;EACE,2BAAA;AA03cJ;;AA33cE;EACE,2BAAA;AA83cJ;;AA/3cE;EACE,2BAAA;AAk4cJ;;AAn4cE;EACE,2BAAA;AAs4cJ;;AAv4cE;EACE,2BAAA;AA04cJ;;AA34cE;EACE,2BAAA;AA84cJ;;AA/4cE;EACE,2BAAA;AAk5cJ;;AAn5cE;EACE,2BAAA;AAs5cJ;;AAv5cE;EACE,2BAAA;AA05cJ;;AA35cE;EACE,2BAAA;AA85cJ;;AA/5cE;EACE,2BAAA;AAk6cJ;;AAn6cE;EACE,2BAAA;AAs6cJ;;AAv6cE;EACE,2BAAA;AA06cJ;;AA36cE;EACE,2BAAA;AA86cJ;;AA/6cE;EACE,2BAAA;AAk7cJ;;AAn7cE;EACE,2BAAA;AAs7cJ;;AAv7cE;EACE,2BAAA;AA07cJ;;AA37cE;EACE,2BAAA;AA87cJ;;AA/7cE;EACE,2BAAA;AAk8cJ;;AAn8cE;EACE,2BAAA;AAs8cJ;;AAv8cE;EACE,2BAAA;AA08cJ;;AA38cE;EACE,2BAAA;AA88cJ;;AA/8cE;EACE,2BAAA;AAk9cJ;;AAn9cE;EACE,2BAAA;AAs9cJ;;AAv9cE;EACE,2BAAA;AA09cJ;;AA39cE;EACE,2BAAA;AA89cJ;;AA/9cE;EACE,2BAAA;AAk+cJ;;AAn+cE;EACE,2BAAA;AAs+cJ;;AAv+cE;EACE,2BAAA;AA0+cJ;;AA3+cE;EACE,2BAAA;AA8+cJ;;AA/+cE;EACE,2BAAA;AAk/cJ;;AAn/cE;EACE,2BAAA;AAs/cJ;;AAv/cE;EACE,2BAAA;AA0/cJ;;AA3/cE;EACE,2BAAA;AA8/cJ;;AA//cE;EACE,2BAAA;AAkgdJ;;AAngdE;EACE,2BAAA;AAsgdJ;;AAvgdE;EACE,2BAAA;AA0gdJ;;AA3gdE;EACE,2BAAA;AA8gdJ;;AA/gdE;EACE,2BAAA;AAkhdJ;;AAnhdE;EACE,2BAAA;AAshdJ;;AAvhdE;EACE,2BAAA;AA0hdJ;;AA3hdE;EACE,2BAAA;AA8hdJ;;AA/hdE;EACE,2BAAA;AAkidJ;;AAnidE;EACE,2BAAA;AAsidJ;;AAvidE;EACE,2BAAA;AA0idJ;;AA3idE;EACE,2BAAA;AA8idJ;;AA/idE;EACE,2BAAA;AAkjdJ;;AAnjdE;EACE,2BAAA;AAsjdJ;;AAvjdE;EACE,2BAAA;AA0jdJ;;AA3jdE;EACE,2BAAA;AA8jdJ;;AA/jdE;EACE,2BAAA;AAkkdJ;;AAnkdE;EACE,2BAAA;AAskdJ;;AAvkdE;EACE,2BAAA;AA0kdJ;;AA3kdE;EACE,2BAAA;AA8kdJ;;AA/kdE;EACE,2BAAA;AAkldJ;;AAnldE;EACE,2BAAA;AAsldJ;;AAvldE;EACE,2BAAA;AA0ldJ;;AA3ldE;EACE,2BAAA;AA8ldJ;;AA/ldE;EACE,2BAAA;AAkmdJ;;AAnmdE;EACE,2BAAA;AAsmdJ;;AAvmdE;EACE,2BAAA;AA0mdJ;;AA3mdE;EACE,2BAAA;AA8mdJ;;AA/mdE;EACE,2BAAA;AAkndJ;;AAnndE;EACE,2BAAA;AAsndJ;;AAvndE;EACE,2BAAA;AA0ndJ;;AA3ndE;EACE,2BAAA;AA8ndJ;;AA/ndE;EACE,2BAAA;AAkodJ;;AAnodE;EACE,2BAAA;AAsodJ;;AAvodE;EACE,2BAAA;AA0odJ;;AA3odE;EACE,2BAAA;AA8odJ;;AA/odE;EACE,2BAAA;AAkpdJ;;AAnpdE;EACE,2BAAA;AAspdJ;;AAvpdE;EACE,2BAAA;AA0pdJ;;AA3pdE;EACE,2BAAA;AA8pdJ;;AA/pdE;EACE,2BAAA;AAkqdJ;;AAnqdE;EACE,2BAAA;AAsqdJ;;AAvqdE;EACE,2BAAA;AA0qdJ;;AA3qdE;EACE,2BAAA;AA8qdJ;;AA/qdE;EACE,2BAAA;AAkrdJ;;AAnrdE;EACE,2BAAA;AAsrdJ;;AAvrdE;EACE,2BAAA;AA0rdJ;;AA3rdE;EACE,2BAAA;AA8rdJ;;AA/rdE;EACE,2BAAA;AAksdJ;;AAnsdE;EACE,2BAAA;AAssdJ;;AAvsdE;EACE,2BAAA;AA0sdJ;;AA3sdE;EACE,2BAAA;AA8sdJ;;AA/sdE;EACE,2BAAA;AAktdJ;;AAntdE;EACE,2BAAA;AAstdJ;;AAvtdE;EACE,2BAAA;AA0tdJ;;AA3tdE;EACE,2BAAA;AA8tdJ;;AA/tdE;EACE,2BAAA;AAkudJ;;AAnudE;EACE,2BAAA;AAsudJ;;AAvudE;EACE,2BAAA;AA0udJ;;AA3udE;EACE,2BAAA;AA8udJ;;AA/udE;EACE,2BAAA;AAkvdJ;;AAnvdE;EACE,2BAAA;AAsvdJ;;AAvvdE;EACE,2BAAA;AA0vdJ;;AA3vdE;EACE,2BAAA;AA8vdJ;;AA/vdE;EACE,2BAAA;AAkwdJ;;AAnwdE;EACE,2BAAA;AAswdJ;;AAvwdE;EACE,2BAAA;AA0wdJ;;AA3wdE;EACE,2BAAA;AA8wdJ;;AA/wdE;EACE,2BAAA;AAkxdJ;;AAnxdE;EACE,2BAAA;AAsxdJ;;AAvxdE;EACE,2BAAA;AA0xdJ;;AA3xdE;EACE,2BAAA;AA8xdJ;;AA/xdE;EACE,2BAAA;AAkydJ;;AAnydE;EACE,2BAAA;AAsydJ;;AAvydE;EACE,2BAAA;AA0ydJ;;AA3ydE;EACE,2BAAA;AA8ydJ;;AA/ydE;EACE,2BAAA;AAkzdJ;;AAnzdE;EACE,2BAAA;AAszdJ;;AAvzdE;EACE,2BAAA;AA0zdJ;;AA3zdE;EACE,2BAAA;AA8zdJ;;AA/zdE;EACE,2BAAA;AAk0dJ;;AAn0dE;EACE,2BAAA;AAs0dJ;;AAv0dE;EACE,2BAAA;AA00dJ;;AA30dE;EACE,2BAAA;AA80dJ;;AA/0dE;EACE,2BAAA;AAk1dJ;;AAn1dE;EACE,2BAAA;AAs1dJ;;AAv1dE;EACE,2BAAA;AA01dJ;;AA31dE;EACE,2BAAA;AA81dJ;;AA/1dE;EACE,2BAAA;AAk2dJ;;AAn2dE;EACE,2BAAA;AAs2dJ;;AAv2dE;EACE,2BAAA;AA02dJ;;AA32dE;EACE,2BAAA;AA82dJ;;AA/2dE;EACE,2BAAA;AAk3dJ;;AAn3dE;EACE,2BAAA;AAs3dJ;;AAv3dE;EACE,2BAAA;AA03dJ;;AA33dE;EACE,2BAAA;AA83dJ;;AA/3dE;EACE,2BAAA;AAk4dJ;;AAn4dE;EACE,2BAAA;AAs4dJ;;AAv4dE;EACE,2BAAA;AA04dJ;;AA34dE;EACE,2BAAA;AA84dJ;;AA/4dE;EACE,2BAAA;AAk5dJ;;AAn5dE;EACE,2BAAA;AAs5dJ;;AAv5dE;EACE,2BAAA;AA05dJ;;AA35dE;EACE,2BAAA;AA85dJ;;AA/5dE;EACE,2BAAA;AAk6dJ;;AAn6dE;EACE,2BAAA;AAs6dJ;;AAv6dE;EACE,2BAAA;AA06dJ;;AA36dE;EACE,2BAAA;AA86dJ;;AA/6dE;EACE,2BAAA;AAk7dJ;;AAn7dE;EACE,2BAAA;AAs7dJ;;AAv7dE;EACE,2BAAA;AA07dJ;;AA37dE;EACE,2BAAA;AA87dJ;;AA/7dE;EACE,2BAAA;AAk8dJ;;AAn8dE;EACE,2BAAA;AAs8dJ;;AAv8dE;EACE,2BAAA;AA08dJ;;AA38dE;EACE,2BAAA;AA88dJ;;AA/8dE;EACE,2BAAA;AAk9dJ;;AAn9dE;EACE,2BAAA;AAs9dJ;;AAv9dE;EACE,2BAAA;AA09dJ;;AA39dE;EACE,2BAAA;AA89dJ;;AA/9dE;EACE,2BAAA;AAk+dJ;;AAn+dE;EACE,2BAAA;AAs+dJ;;AAv+dE;EACE,2BAAA;AA0+dJ;;AA3+dE;EACE,2BAAA;AA8+dJ;;AA/+dE;EACE,2BAAA;AAk/dJ;;AAn/dE;EACE,2BAAA;AAs/dJ;;AAv/dE;EACE,2BAAA;AA0/dJ;;AA3/dE;EACE,2BAAA;AA8/dJ;;AA//dE;EACE,2BAAA;AAkgeJ;;AAngeE;EACE,2BAAA;AAsgeJ;;AAvgeE;EACE,2BAAA;AA0geJ;;AA3geE;EACE,2BAAA;AA8geJ;;AA/geE;EACE,2BAAA;AAkheJ;;AAnheE;EACE,2BAAA;AAsheJ;;AAvheE;EACE,2BAAA;AA0heJ;;AA3heE;EACE,2BAAA;AA8heJ;;AA/heE;EACE,2BAAA;AAkieJ;;AAnieE;EACE,2BAAA;AAsieJ;;AAvieE;EACE,2BAAA;AA0ieJ;;AA3ieE;EACE,2BAAA;AA8ieJ;;AA/ieE;EACE,2BAAA;AAkjeJ;;AAnjeE;EACE,2BAAA;AAsjeJ;;AAvjeE;EACE,2BAAA;AA0jeJ;;AA3jeE;EACE,2BAAA;AA8jeJ;;AA/jeE;EACE,2BAAA;AAkkeJ;;AAnkeE;EACE,2BAAA;AAskeJ;;AAvkeE;EACE,2BAAA;AA0keJ;;AA3keE;EACE,2BAAA;AA8keJ;;AA/keE;EACE,2BAAA;AAkleJ;;AAnleE;EACE,2BAAA;AAsleJ;;AAvleE;EACE,2BAAA;AA0leJ;;AA3leE;EACE,2BAAA;AA8leJ;;AA/leE;EACE,2BAAA;AAkmeJ;;AAnmeE;EACE,2BAAA;AAsmeJ;;AAvmeE;EACE,2BAAA;AA0meJ;;AA3meE;EACE,2BAAA;AA8meJ;;AA/meE;EACE,2BAAA;AAkneJ;;AAnneE;EACE,2BAAA;AAsneJ;;AAvneE;EACE,2BAAA;AA0neJ;;AA3neE;EACE,2BAAA;AA8neJ;;AA/neE;EACE,2BAAA;AAkoeJ;;AAnoeE;EACE,2BAAA;AAsoeJ;;AAvoeE;EACE,2BAAA;AA0oeJ;;AA3oeE;EACE,2BAAA;AA8oeJ;;AA/oeE;EACE,2BAAA;AAkpeJ;;AAnpeE;EACE,2BAAA;AAspeJ;;AAvpeE;EACE,2BAAA;AA0peJ;;AA3peE;EACE,2BAAA;AA8peJ;;AA/peE;EACE,2BAAA;AAkqeJ;;AAnqeE;EACE,2BAAA;AAsqeJ;;AAvqeE;EACE,2BAAA;AA0qeJ;;AA3qeE;EACE,2BAAA;AA8qeJ;;AA/qeE;EACE,2BAAA;AAkreJ;;AAnreE;EACE,2BAAA;AAsreJ;;AAvreE;EACE,2BAAA;AA0reJ;;AA3reE;EACE,2BAAA;AA8reJ;;AA/reE;EACE,2BAAA;AAkseJ;;AAnseE;EACE,2BAAA;AAsseJ;;AAvseE;EACE,2BAAA;AA0seJ;;AA3seE;EACE,2BAAA;AA8seJ;;AA/seE;EACE,2BAAA;AAkteJ;;AAnteE;EACE,2BAAA;AAsteJ;;AAvteE;EACE,2BAAA;AA0teJ;;AA3teE;EACE,2BAAA;AA8teJ;;AA/teE;EACE,2BAAA;AAkueJ;;AAnueE;EACE,2BAAA;AAsueJ;;AAvueE;EACE,2BAAA;AA0ueJ;;AA3ueE;EACE,2BAAA;AA8ueJ;;AA/ueE;EACE,2BAAA;AAkveJ;;AAnveE;EACE,2BAAA;AAsveJ;;AAvveE;EACE,2BAAA;AA0veJ;;AA3veE;EACE,2BAAA;AA8veJ;;AA/veE;EACE,2BAAA;AAkweJ;;AAnweE;EACE,2BAAA;AAsweJ;;AAvweE;EACE,2BAAA;AA0weJ;;AA3weE;EACE,2BAAA;AA8weJ;;AA/weE;EACE,2BAAA;AAkxeJ;;AAnxeE;EACE,2BAAA;AAsxeJ;;AAvxeE;EACE,2BAAA;AA0xeJ;;AA3xeE;EACE,2BAAA;AA8xeJ;;AA/xeE;EACE,2BAAA;AAkyeJ;;AAnyeE;EACE,2BAAA;AAsyeJ;;AAvyeE;EACE,2BAAA;AA0yeJ;;AA3yeE;EACE,2BAAA;AA8yeJ;;AA/yeE;EACE,2BAAA;AAkzeJ;;AAnzeE;EACE,2BAAA;AAszeJ;;AAvzeE;EACE,2BAAA;AA0zeJ;;AA3zeE;EACE,2BAAA;AA8zeJ;;AA/zeE;EACE,2BAAA;AAk0eJ;;AAn0eE;EACE,2BAAA;AAs0eJ;;AAv0eE;EACE,2BAAA;AA00eJ;;AA30eE;EACE,2BAAA;AA80eJ;;AA/0eE;EACE,2BAAA;AAk1eJ;;AAn1eE;EACE,2BAAA;AAs1eJ;;AAv1eE;EACE,2BAAA;AA01eJ;;AA31eE;EACE,2BAAA;AA81eJ;;AA/1eE;EACE,2BAAA;AAk2eJ;;AAn2eE;EACE,2BAAA;AAs2eJ;;AAv2eE;EACE,2BAAA;AA02eJ;;AA32eE;EACE,2BAAA;AA82eJ;;AA/2eE;EACE,2BAAA;AAk3eJ;;AAn3eE;EACE,2BAAA;AAs3eJ;;AAv3eE;EACE,2BAAA;AA03eJ;;AA33eE;EACE,2BAAA;AA83eJ;;AA/3eE;EACE,2BAAA;AAk4eJ;;AAn4eE;EACE,2BAAA;AAs4eJ;;AAv4eE;EACE,2BAAA;AA04eJ;;AA34eE;EACE,2BAAA;AA84eJ;;AA/4eE;EACE,2BAAA;AAk5eJ;;AAn5eE;EACE,2BAAA;AAs5eJ;;AAv5eE;EACE,2BAAA;AA05eJ;;AA35eE;EACE,2BAAA;AA85eJ;;AA/5eE;EACE,2BAAA;AAk6eJ;;AAn6eE;EACE,2BAAA;AAs6eJ;;AAv6eE;EACE,2BAAA;AA06eJ;;AA36eE;EACE,2BAAA;AA86eJ;;AA/6eE;EACE,2BAAA;AAk7eJ;;AAn7eE;EACE,2BAAA;AAs7eJ;;AAv7eE;EACE,2BAAA;AA07eJ;;AA37eE;EACE,2BAAA;AA87eJ;;AA/7eE;EACE,2BAAA;AAk8eJ;;AAn8eE;EACE,2BAAA;AAs8eJ;;AAv8eE;EACE,2BAAA;AA08eJ;;AA38eE;EACE,2BAAA;AA88eJ;;AA/8eE;EACE,2BAAA;AAk9eJ;;AAn9eE;EACE,2BAAA;AAs9eJ;;AAv9eE;EACE,2BAAA;AA09eJ;;AA39eE;EACE,2BAAA;AA89eJ;;AA/9eE;EACE,2BAAA;AAk+eJ;;AAn+eE;EACE,2BAAA;AAs+eJ;;AAv+eE;EACE,2BAAA;AA0+eJ;;AA3+eE;EACE,2BAAA;AA8+eJ;;AA/+eE;EACE,2BAAA;AAk/eJ;;AAn/eE;EACE,2BAAA;AAs/eJ;;AAv/eE;EACE,2BAAA;AA0/eJ;;AA3/eE;EACE,2BAAA;AA8/eJ;;AA//eE;EACE,2BAAA;AAkgfJ;;AAngfE;EACE,2BAAA;AAsgfJ;;AAvgfE;EACE,2BAAA;AA0gfJ;;AA3gfE;EACE,2BAAA;AA8gfJ;;AA/gfE;EACE,2BAAA;AAkhfJ;;AAnhfE;EACE,2BAAA;AAshfJ;;AAvhfE;EACE,2BAAA;AA0hfJ;;AA3hfE;EACE,2BAAA;AA8hfJ;;AA/hfE;EACE,2BAAA;AAkifJ;;AAnifE;EACE,2BAAA;AAsifJ;;AAvifE;EACE,2BAAA;AA0ifJ;;AA3ifE;EACE,2BAAA;AA8ifJ;;AA/ifE;EACE,2BAAA;AAkjfJ;;AAnjfE;EACE,2BAAA;AAsjfJ;;AAvjfE;EACE,2BAAA;AA0jfJ;;AA3jfE;EACE,2BAAA;AA8jfJ;;AA/jfE;EACE,2BAAA;AAkkfJ;;AAnkfE;EACE,2BAAA;AAskfJ;;AAvkfE;EACE,2BAAA;AA0kfJ;;AA3kfE;EACE,2BAAA;AA8kfJ;;AA/kfE;EACE,2BAAA;AAklfJ;;AAnlfE;EACE,2BAAA;AAslfJ;;AAvlfE;EACE,2BAAA;AA0lfJ;;AA3lfE;EACE,2BAAA;AA8lfJ;;AA/lfE;EACE,2BAAA;AAkmfJ;;AAnmfE;EACE,2BAAA;AAsmfJ;;AAvmfE;EACE,2BAAA;AA0mfJ;;AA3mfE;EACE,2BAAA;AA8mfJ;;AA/mfE;EACE,2BAAA;AAknfJ;;AAnnfE;EACE,2BAAA;AAsnfJ;;AAvnfE;EACE,2BAAA;AA0nfJ;;AA3nfE;EACE,2BAAA;AA8nfJ;;AA/nfE;EACE,2BAAA;AAkofJ;;AAnofE;EACE,2BAAA;AAsofJ;;AAvofE;EACE,2BAAA;AA0ofJ;;AA3ofE;EACE,2BAAA;AA8ofJ;;AA/ofE;EACE,2BAAA;AAkpfJ;;AAnpfE;EACE,2BAAA;AAspfJ;;AAvpfE;EACE,2BAAA;AA0pfJ;;AA3pfE;EACE,2BAAA;AA8pfJ;;AA/pfE;EACE,2BAAA;AAkqfJ;;AAnqfE;EACE,2BAAA;AAsqfJ;;AAvqfE;EACE,2BAAA;AA0qfJ;;AA3qfE;EACE,2BAAA;AA8qfJ;;AA/qfE;EACE,2BAAA;AAkrfJ;;AAnrfE;EACE,2BAAA;AAsrfJ;;AAvrfE;EACE,2BAAA;AA0rfJ;;AA3rfE;EACE,2BAAA;AA8rfJ;;AA/rfE;EACE,2BAAA;AAksfJ;;AAnsfE;EACE,2BAAA;AAssfJ;;AAvsfE;EACE,2BAAA;AA0sfJ;;AA3sfE;EACE,2BAAA;AA8sfJ;;AA/sfE;EACE,2BAAA;AAktfJ;;AAntfE;EACE,2BAAA;AAstfJ;;AAvtfE;EACE,2BAAA;AA0tfJ;;AA3tfE;EACE,2BAAA;AA8tfJ;;AA/tfE;EACE,2BAAA;AAkufJ;;AAnufE;EACE,2BAAA;AAsufJ;;AAvufE;EACE,2BAAA;AA0ufJ;;AA3ufE;EACE,2BAAA;AA8ufJ;;AA/ufE;EACE,2BAAA;AAkvfJ;;AAnvfE;EACE,2BAAA;AAsvfJ;;AAvvfE;EACE,2BAAA;AA0vfJ;;AA3vfE;EACE,2BAAA;AA8vfJ;;AA/vfE;EACE,2BAAA;AAkwfJ;;AAnwfE;EACE,2BAAA;AAswfJ;;AAvwfE;EACE,2BAAA;AA0wfJ;;AA3wfE;EACE,2BAAA;AA8wfJ;;AA/wfE;EACE,2BAAA;AAkxfJ;;AAnxfE;EACE,2BAAA;AAsxfJ;;AAvxfE;EACE,2BAAA;AA0xfJ;;AA3xfE;EACE,2BAAA;AA8xfJ;;AA/xfE;EACE,2BAAA;AAkyfJ;;AAnyfE;EACE,2BAAA;AAsyfJ;;AAvyfE;EACE,2BAAA;AA0yfJ;;AA3yfE;EACE,2BAAA;AA8yfJ;;AA/yfE;EACE,2BAAA;AAkzfJ;;AAnzfE;EACE,2BAAA;AAszfJ;;AAvzfE;EACE,2BAAA;AA0zfJ;;AA3zfE;EACE,2BAAA;AA8zfJ;;AA/zfE;EACE,2BAAA;AAk0fJ;;AAn0fE;EACE,2BAAA;AAs0fJ;;AAv0fE;EACE,2BAAA;AA00fJ;;AA30fE;EACE,2BAAA;AA80fJ;;AA/0fE;EACE,2BAAA;AAk1fJ;;AAn1fE;EACE,2BAAA;AAs1fJ;;AAv1fE;EACE,2BAAA;AA01fJ;;AA31fE;EACE,2BAAA;AA81fJ;;AA/1fE;EACE,2BAAA;AAk2fJ;;AAn2fE;EACE,2BAAA;AAs2fJ;;AAv2fE;EACE,2BAAA;AA02fJ;;AA32fE;EACE,2BAAA;AA82fJ;;AA/2fE;EACE,2BAAA;AAk3fJ;;AAn3fE;EACE,2BAAA;AAs3fJ;;AAv3fE;EACE,2BAAA;AA03fJ;;AA33fE;EACE,2BAAA;AA83fJ;;AA/3fE;EACE,2BAAA;AAk4fJ;;AAn4fE;EACE,2BAAA;AAs4fJ;;AAv4fE;EACE,2BAAA;AA04fJ;;AA34fE;EACE,2BAAA;AA84fJ;;AA/4fE;EACE,2BAAA;AAk5fJ;;AAn5fE;EACE,2BAAA;AAs5fJ;;AAh5fA;EACE,cClIS;EDmIT,mBAAA;AAm5fF;;AAh5fA;EACE,kBAAA;AAm5fF;;AAh5fA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAm5fF;;AAh5fA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AAm5fF;;AAh5fA;EACE,mBC7KS;ED8KT,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;AAm5fF;AAj5fE;EAEE,mBCtLO;EDuLP,WAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,mCAAA;EACA,UAAA;AAk5fJ;AA/4fE;EACE,gCAAA;AAi5fJ;AA94fE;EACE,oCAAA;AAg5fJ;AA74fE;EACE;IACE,mCAAA;EA+4fJ;EA54fE;IACE,kCAAA;EA84fJ;AACF;;AAx4fE;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,mBAAA;AA24fJ;AAz4fI;EACE,cAAA;EACA,6BAAA;EACA,yBAAA;AA24fN;AAx4fI;EACE,gBAAA;EACA,qBAAA;AA04fN;AAv4fI;EAEE,wBAAA;AAw4fN;;AAj4fI;EACE,aAAA;AAo4fN;AAh4fE;EACE,aAAA;AAk4fJ;;AA93fA;EACE,2BAAA;AAi4fF;;AA93fA;EACE,kBAAA;EACA,oBAAA;EACA,aAAA;AAi4fF;;AA93fA;EACE,qCAAA;AAi4fF;;AA93fA;EACE,oBAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;AAi4fF;AA/3fE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAi4fJ;AA93fM;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AAg4fR;AA53fI;EACE,aAAA;AA83fN;;AAz3fA;EACE,wBAAA;EACA,iBAAA;AA43fF","sourcesContent":["@import \"./assets/scss/BootstrapOverride.scss\";\n@import \"./assets/scss/Responsive.scss\";\n\n@import \"https://fonts.googleapis.com/icon?family=Material+Icons&Weight=700\";\n@import \"https://fonts.googleapis.com/icon?family=Material+Icons+Outlined&Weight=700\";\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap');\n\n@import url('https://cdn.jsdelivr.net/npm/bootstrap-icons@1.3.0/font/bootstrap-icons.css');\n\n\n@font-face {\n  font-family: \"MuseoSans\";\n  src: url(\"./assets/fonts/museo-sans/MuseoSans_100.ttf\") format(\"truetype\");\n  font-weight: 100;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"MuseoSans\";\n  src: url(\"./assets/fonts/museo-sans/MuseoSans_300.ttf\") format(\"truetype\");\n  font-weight: 300;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"MuseoSans\";\n  src: url(\"./assets/fonts/museo-sans/MuseoSans_500.ttf\") format(\"truetype\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"MuseoSans\";\n  src: url(\"./assets/fonts/museo-sans/MuseoSans_700.ttf\") format(\"truetype\");\n  font-weight: 700;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"MuseoSans\";\n  src: url(\"./assets/fonts/museo-sans/MuseoSans_900.ttf\") format(\"truetype\");\n  font-weight: 900;\n  font-style: normal;\n}\n\nbody {\n  padding-top: 78px;\n  font-family: 'MuseoSans', sans-serif;\n}\n\nh6{\n  font-weight: 700;\n}\n\n.section-content {\n  position: fixed;\n  top: 65px;\n  bottom: 0;\n  overflow: auto;\n  width: 100%;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.zindex-0 {\n  z-index: 0\n}\n\n// zindex-0\n@for $i from 1 through 9 {\n  .zindex-#{$i} {\n    z-index: $i\n  }\n\n  // zindex-1, zindex-2 ... zindex-9\n  .zindex-#{$i*10} {\n    z-index: $i*10\n  }\n\n  // zindex-10, zindex-20 ... zindex-90\n  .zindex-#{$i*100} {\n    z-index: $i*100\n  }\n\n  // zindex-100, zindex-200 ... zindex-900\n  .zindex-#{$i*1000} {\n    z-index: $i*1000\n  }\n\n  // zindex-1000, zindex-2000 ... zindex-9000\n}\n\n.light-v-scroll {\n\n  height: 100%;\n  overflow-x: hidden;\n  padding: 0 8px 0 0;\n  overflow-y: auto;\n\n  /* width */\n  &::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  /* Track */\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n\n  /* Handle */\n  &::-webkit-scrollbar-thumb {\n    background: $gray-200;\n    border-radius: 4px;\n  }\n\n  /* Handle on hover */\n  &::-webkit-scrollbar-thumb:hover {\n    background: $gray-300;\n  }\n\n}\n\n// Applique un height de 100vh - une valeur fixe en pixel (height-full-min-*multiple_de_10)\n@for $i from 50 through 500 {\n  .height-full-min-#{$i+10} {\n    height: calc(100vh - #{$i+10}px)\n  }\n\n  // height: calc(100vh - 110px), height: calc(100vh - 120px) ... height: calc(100vh - 500px)\n}\n\n.highlight {\n  color: $gray-900;\n  background: #fdfa2c;\n}\n\n.input-icon-space {\n  padding-left: 35px;\n}\n\n.input-icon {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  padding: 0.375rem 0.75rem;\n  font-size: inherit;\n  font-weight: 700;\n  z-index: 10;\n}\n\n.global-search-close-btn {\n  right: 46px;\n  height: 26px;\n  width: 26px;\n  padding-left: 0px;\n  top: 50%;\n  margin-top: -13px;\n  position: absolute;\n  align-items: center;\n  justify-content: center;\n  font-size: inherit;\n  font-weight: 700;\n  z-index: 10;\n}\n\n.hloader {\n  background: $gray-200;\n  height: 10px;\n  border-radius: 3px;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n  display: inline-block;\n\n  &::before,\n  &::after {\n    background: $gray-300;\n    content: '';\n    display: block;\n    height: 10px;\n    left: 0;\n    position: absolute;\n    top: 0;\n    transform: translate3d(-100%, 0, 0);\n    width: 50%;\n  }\n\n  &::before {\n    animation: hloader 1.5s infinite;\n  }\n\n  &::after {\n    animation: hloader 2.5s -1s infinite;\n  }\n\n  @keyframes hloader {\n    0% {\n      transform: translate3d(-100%, 0, 0);\n    }\n\n    100% {\n      transform: translate3d(200%, 0, 0);\n    }\n  }\n\n}\n\n.light-dropdown {\n  .dropdown-toggle {\n    background: none;\n    border: none;\n    color: inherit;\n    padding: 0;\n    margin: 0;\n    line-height: 0;\n    border-radius: 50px;\n\n    &.btn-primary.dropdown-toggle {\n      color: inherit;\n      background-color: transparent;\n      border-color: transparent;\n    }\n\n    &.btn-primary.dropdown-toggle:focus {\n      box-shadow: none;\n      outline: 0 !important;\n    }\n\n    &:before,\n    &:after {\n      display: none !important;\n    }\n  }\n}\n\n.no-btn-caret {\n  .dropdown-toggle {\n    &:after {\n      display: none;\n    }\n  }\n\n  &:after {\n    display: none;\n  }\n}\n\ntbody {\n  border-top: none !important;\n}\n\n.material-icons {\n  font-size: inherit;\n  line-height: inherit;\n  display: flex;\n}\n\n.i-lg {\n  transform: scale(1.3) translateY(1px);\n}\n\n.bubble-tags-container {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  border-radius: 20px;\n  padding: 1px 7px 1px 8px;\n\n  .bubble {\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    margin-left: 3px;\n    position: relative;\n\n    &:hover {\n      .label {\n        display: flex;\n        position: absolute;\n        white-space: nowrap;\n        z-index: 9999;\n        top: -24px;\n        border-radius: 20px;\n        padding: 0px 7px;\n        font-size: .9rem;\n        left: -5px;\n      }\n    }\n\n    .label {\n      display: none;\n    }\n  }\n}\n\ntable{\n  border-collapse: inherit;\n  border-spacing: 0;\n}","\r\n$white:    #fff !default;\r\n$gray-100: #eff1f9;\r\n$gray-200: #e7e8f1;\r\n$gray-300: #dadbe7;\r\n$gray-400: #c6c7d6;\r\n$gray-500: #9ea0b9;\r\n$gray-600: #787a91;\r\n$gray-700: #434453;\r\n$gray-800: #1e1e27;\r\n$gray-900: #11111a;\r\n$black:    #000 !default;     \r\n\r\n$blue-100: #e5f6ff;\r\n$blue-200: #C5E0FB;\r\n$blue-300: #79a8df;\r\n$blue-400: #4381cf;\r\n$blue-500: #0E59BE;\r\n$blue-600: #0b48ae;\r\n$blue-700: #08379e;\r\n$blue-800: #05268e;\r\n$blue-900: #00157C;\r\n\r\n$blue:    $blue-500 !default;\r\n$indigo:  #7b7df0 !default; \r\n$purple:  #bf71e6 !default;\r\n$pink:    #eb62d0 !default; \r\n$red:     #fc435c !default;\r\n$orange:  #f09449 !default;\r\n$yellow:  #ffd022 !default; \r\n$green:   #1eba62 !default;\r\n$teal:    #03acb8 !default;\r\n$cyan:    #13ccbb !default; \r\n\r\n$primary:       $blue !default;\r\n$primary-100:   $blue-100;\r\n$primary-200:   $blue-200;\r\n$primary-300:   $blue-300;\r\n$primary-400:   $blue-400;\r\n$primary-500:   $blue-500;\r\n$primary-600:   $blue-600;\r\n$primary-700:   $blue-700;\r\n$primary-800:   $blue-800;\r\n$primary-900:   $blue-900;\r\n$secondary:     $gray-400 !default;\r\n$success:       $green !default;\r\n$info:          $cyan !default;\r\n$warning:       $yellow !default;\r\n$danger:        $red !default;\r\n$light:         $gray-100 !default;\r\n$dark:          $gray-900 !default;\r\n\r\n\r\n.hover-bg-gray-100{&:hover{ background-color: $gray-100 !important;}}\r\n.hover-bg-gray-200{&:hover{ background-color: $gray-200 !important;}}\r\n.hover-bg-gray-300{&:hover{ background-color: $gray-300 !important;}}\r\n.hover-bg-gray-400{&:hover{ background-color: $gray-400 !important;}}\r\n.hover-bg-gray-500{&:hover{ background-color: $gray-500 !important;}}\r\n.hover-bg-gray-600{&:hover{ background-color: $gray-600 !important;}}\r\n.hover-bg-gray-700{&:hover{ background-color: $gray-700 !important;}}\r\n.hover-bg-gray-800{&:hover{ background-color: $gray-800 !important;}}\r\n.hover-bg-gray-900{&:hover{ background-color: $gray-900 !important;}}\r\n\r\n.hover-bg-primary-100{&:hover{ background-color: $primary-100 !important;}}\r\n.hover-bg-primary-200{&:hover{ background-color: $primary-200 !important;}}\r\n.hover-bg-primary-300{&:hover{ background-color: $primary-300 !important;}}\r\n.hover-bg-primary-400{&:hover{ background-color: $primary-400 !important;}}\r\n.hover-bg-primary-500{&:hover{ background-color: $primary-500 !important;}}\r\n.hover-bg-primary-600{&:hover{ background-color: $primary-600 !important;}}\r\n.hover-bg-primary-700{&:hover{ background-color: $primary-700 !important;}}\r\n.hover-bg-primary-800{&:hover{ background-color: $primary-800 !important;}}\r\n.hover-bg-primary-900{&:hover{ background-color: $primary-900 !important;}}\r\n\r\n$theme-colors: (\r\n  \"primary\":    $primary,\r\n  \"secondary\":  $secondary,\r\n  \"success\":    $success,\r\n  \"info\":       $info,\r\n  \"warning\":    $warning,\r\n  \"danger\":     $danger,\r\n  \"light\":      $light,\r\n  \"dark\":       $dark,\r\n  \"gray-100\":      $gray-100,\r\n  \"gray-200\":      $gray-200,\r\n  \"gray-300\":      $gray-300,\r\n  \"gray-400\":      $gray-400,\r\n  \"gray-500\":      $gray-500,\r\n  \"gray-600\":      $gray-600,\r\n  \"gray-700\":      $gray-700,\r\n  \"gray-800\":      $gray-800,\r\n  \"gray-900\":      $gray-900,\r\n  \"primary-100\":      $primary-100,\r\n  \"primary-200\":      $primary-200,\r\n  \"primary-300\":      $primary-300,\r\n  \"primary-400\":      $primary-400,\r\n  \"primary-500\":      $primary-500,\r\n  \"primary-600\":      $primary-600,\r\n  \"primary-700\":      $primary-700,\r\n  \"primary-800\":      $primary-800,\r\n  \"primary-900\":      $primary-900\r\n) !default;\r\n\r\n\r\n$min-contrast-ratio:   2.2 !default;\r\n\r\n// Fonts\r\n$font-size-base:              .88rem !default;\r\n$font-size-sm:                $font-size-base * .84 !default;\r\n$font-size-lg:                $font-size-base * .92 !default;\r\n\r\n$font-weight-lighter:         100 !default;\r\n$font-weight-light:           300 !default;\r\n$font-weight-normal:          500 !default;\r\n$font-weight-bold:            700 !default;\r\n$font-weight-bolder:          900 !default;\r\n\r\n$headings-font-family:        'MuseoSans', sans-serif !default;\r\n//$headings-font-weight:        $font-weight-bold !default;\r\n$input-btn-font-family:       'MuseoSans', sans-serif !default;\r\n\r\n/* $input-btn-font-size:         $font-size-base * 1 !default;\r\n$input-btn-font-size-sm:      $font-size-sm * 1 !default;\r\n$input-btn-font-size-lg:      $font-size-lg * 1 !default; */\r\n\r\n/* $btn-font-weight:             $font-weight-bold !default; */\r\n\r\n$link-color:                  $primary-600 !default;\r\n\r\n// Gutters\r\n$grid-gutter-width: 1rem !default;\r\n$container-padding-x: $grid-gutter-width*2 !default;\r\n\r\n// Paddings\r\n$input-btn-padding-y:         .450rem !default;\r\n$input-btn-padding-x:         1.1rem !default;\r\n$input-btn-padding-y-sm:      .35rem !default;\r\n$input-btn-padding-x-sm:      .85rem !default;\r\n$input-btn-padding-y-lg:      .525rem !default;\r\n$input-btn-padding-x-lg:      1.6rem !default;\r\n\r\n// Margins\r\n$enable-negative-margins:     true !default;\r\n\r\n// Table\r\n$table-th-font-weight:        $font-weight-normal !default;\r\n\r\n$table-active-bg-factor:      1 !default;\r\n$table-active-bg:             $primary-100 !default;\r\n\r\n$table-hover-bg-factor:       1 !default;\r\n$table-hover-bg:              $gray-100 !default;\r\n\r\n// Shadows\r\n$box-shadow-sm:               0.01rem 0.05rem 0.15rem 0rem rgb(62 50 147 / 15%) !default;\r\n$box-shadow:                  0.02rem 0.1rem 0.45rem 0rem rgb(62 50 147 / 13%) !default;\r\n$box-shadow-lg:               0.045rem 0.2rem 1.35rem 0rem rgb(62 50 147 / 10%) !default;\r\n\r\n// tooltip\r\n$tooltip-max-width:                 900px !default;\r\n$tooltip-color:                     $white !default;\r\n$tooltip-bg:                        $gray-800 !default;\r\n$tooltip-opacity:                   1 !default;\r\n$tooltip-arrow-color:               $gray-800 !default;\r\n\r\n// accordion\r\n$accordion-padding-y:                     .6rem !default;\r\n$accordion-padding-x:                     1.1rem !default;\r\n$accordion-button-color:                  $gray-700 !default;\r\n$accordion-button-bg:                     $gray-200 !default;\r\n$accordion-button-active-bg:              $primary-200 !default;\r\n$accordion-button-active-color:           $primary-700 !default;\r\n\r\n// popover\r\n$popover-border-color:              $gray-400 !default;\r\n$popover-header-bg:                 $white !default;\r\n$popover-arrow-outer-color:         $gray-400 !default;\r\n\r\n// tabs\r\n$nav-pills-link-active-color:       $primary-700 !default;\r\n$nav-pills-link-active-bg:          $primary-200 !default;\r\n$nav-link-padding-y:                .4rem !default;\r\n$nav-link-padding-x:                .7rem !default;\r\n\r\n// navbar\r\n$navbar-dark-color:                 rgba($white, .85) !default;\r\n$navbar-dark-hover-color:           $white !default;\r\n$navbar-dark-active-color:          $white !default;\r\n\r\n\r\n// alerts\r\n$alert-bg-scale:                -55% !default;\r\n$alert-border-scale:            -40% !default;\r\n$alert-color-scale:             80% !default;\r\n\r\n\r\n// scss-docs-start border-radius-variables\r\n$border-radius:               .35rem !default;\r\n$border-radius-sm:            .25rem !default;\r\n$border-radius-lg:            .45rem !default;\r\n$border-radius-pill:          50rem !default;\r\n\r\n\r\n// modals\r\n$zindex-modal-backdrop:             1055 !default;\r\n\r\n\r\n@import \"~bootstrap/scss/bootstrap\";\r\n\r\n\r\n// Global button (utilisé par les \"nav-pills\", \"accordion\", les \"Button\" ...)\r\nbutton{\r\n  font-family:  $input-btn-font-family !important;\r\n  //font-size: $input-btn-font-size !important;\r\n  //font-weight: $btn-font-weight !important;\r\n  //letter-spacing: .018rem;\r\n}\r\n\r\n// Custom btn\r\n.btn, button{\r\n  i{\r\n    margin-left: -5px;\r\n    margin-right: -5px;\r\n  }\r\n}\r\n\r\n.btn-secondary{\r\n  background: white !important;\r\n  color: $gray-800 !important;\r\n  box-shadow: $box-shadow-sm;\r\n  &:hover{\r\n    background: $gray-400 !important;\r\n  }\r\n}\r\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.7 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","// `xxl` applies to x-large devices (large desktops, less than 1400px)\n@media (max-width: 1399.98px) {\n    .container-fluid{\n        padding-right: 1rem;\n        padding-left: 1rem;\n    }\n}\n\n// `xl` applies to large devices (desktops, less than 1200px)\n@media (max-width: 1199.98px) {}\n\n// `lg` applies to medium devices (tablets, less than 992px)\n@media (max-width: 991.98px) { }\n\n// `md` applies to small devices (landscape phones, less than 768px)\n@media (max-width: 767.98px) { }\n\n// `sm` applies to x-small devices (portrait phones, less than 576px)\n@media (max-width: 575.98px) { }\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
